var zde = zde || {}; zde["modules"] = zde["modules"] || {}; zde["modules"]["landing"] =
webpackJsonpzde_modules__name_([6],{

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "1zZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductItem; });
/* unused harmony export Offer */
/* unused harmony export Shop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__("m9tG");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ProductList = function (_BaseList) {
	_inherits(ProductList, _BaseList);

	/**
  * @param {Settings} settings
  */
	function ProductList(settings) {
		_classCallCheck(this, ProductList);

		var _this = _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).call(this, { name: 'products', settings: settings }));

		_this._favorites = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable([]);


		_this._favoritesHash = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			var hash = {};
			_this._favorites().forEach(function (id) {
				return hash[id] = true;
			});
			return hash;
		});
		return _this;
	}

	_createClass(ProductList, [{
		key: "initData",
		value: function initData(data) {
			if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['favorites'])) {
				this._favorites(data['favorites']);

				if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['items']) && this._favorites().length > 0) {
					// inject "favorite" flag
					var favoritesHash = this._favoritesHash();
					var newItems = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data['items'], function (item) {
						return _extends({}, item, {
							favorite: favoritesHash[item.id]
						});
					});
					data = _extends({}, data, {
						items: newItems
					});
				}
			}
			if (__WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].debug && __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isObject(data['scores']) && __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['items'])) {
				var _newItems = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data['items'], function (item) {
					return _extends({}, item, {
						score: data['scores'][item['id']]
					});
				});
				data = _extends({}, data, {
					items: _newItems
				});
			}
			_get(ProductList.prototype.__proto__ || Object.getPrototypeOf(ProductList.prototype), "initData", this).call(this, data);
		}
	}, {
		key: "newItem",
		value: function newItem(itemData) {
			return new ProductItem(itemData, this.settings);
		}
	}]);

	return ProductList;
}(__WEBPACK_IMPORTED_MODULE_2__lists__["a" /* BaseList */]);

var ProductItem = function () {
	/**
  * @param {object} data
  * @param {Settings} settings
  */
	function ProductItem(data, settings) {
		_classCallCheck(this, ProductItem);

		this.id = data.id;
		this.title = data.title;
		this.url = settings.getProductUrl(data.uri);
		this.images = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data.images, function (img) {
			return settings.getImageUrl(img);
		});
		this.previews = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data.previews, function (img) {
			return settings.getPreviewImgageUrl(img);
		});
		this.previewImage = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.first(this.previews);
		this.orderUrl = __WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */]('create_order?productId=' + this.id);
		this.updateDate = new Date(data['updateTime']);
		this.offersCount = data.offersCount;
		this.bestOffer = new Offer(data.bestOffer);
		this.price = settings.convertPrice(data.price);
		this.priceOld = settings.convertPrice(data.oldPrice);
		this.discount = data.discount;
		this.score = data.score;

		if (settings.useOfferUrl) {
			this.url = this.bestOffer.url;
		}

		this._favorite = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(!!data.favorite);
	}

	_createClass(ProductItem, [{
		key: "showImages",
		value: function showImages() {
			if (this.hasImages) {
				$.fancybox.open(__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(this.images, function (img) {
					return {
						type: 'image',
						src: img
					};
				}));
			}
		}
	}, {
		key: "showDebugInfo",
		value: function showDebugInfo() {
			if (__WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].debug && this.score) {
				__WEBPACK_IMPORTED_MODULE_5__data__["a" /* debugInfo */].show('product', this.id);
			}
		}
	}, {
		key: "isFavorite",
		get: function get() {
			return this._favorite();
		}
	}, {
		key: "hasImages",
		get: function get() {
			return this.images.length > 0;
		}
	}]);

	return ProductItem;
}();

var Offer = function Offer(data) {
	_classCallCheck(this, Offer);

	this.id = data.id;
	this.name = data.name;
	this.price = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].convertPrice(data.price);
	this.oldPrice = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].convertPrice(data.oldPrice);
	this.discount = data.discount;
	this.shop = new Shop(data.shop);
	this.url = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getOfferUrl(data.id);
};

var Shop = function Shop(data) {
	_classCallCheck(this, Shop);

	this.id = data.id;
	this.title = data.title;
	this.url = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getShopUrl(data.shopSlug);
};

/***/ }),

/***/ "2F9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_var__ = __webpack_require__("dTkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_shop_quicksearch_viewmodel__ = __webpack_require__("f5X1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_packages_create_order_viewmodel__ = __webpack_require__("m137");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var MainInput = function () {
	/** @type {CreateOrderForm} */


	/** @type {JQuery.Callbacks} */
	function MainInput(options) {
		var _this = this;

		_classCallCheck(this, MainInput);

		this.input = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable('');
		this.inputFocus = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(false);
		this.active = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(false);
		this._isOpened = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(false);
		this._mode = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable('');
		this._processed = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(false);
		this.onOpen = $.Callbacks();
		this._o = {};

		var o = this._o = _extends({
			value: '',

			containerSelector: '',
			autoScroll: true,

			searchEnabled: true,
			searchOptions: {},

			orderEnabled: true,
			orderOptions: {},
			orderCloseOnSuccess: true,
			orderFormSelector: ''

		}, options);

		if (o.searchEnabled) {
			this.quickSearch = Object(__WEBPACK_IMPORTED_MODULE_2_modules_shop_quicksearch_viewmodel__["a" /* init */])(o.searchOptions);
		}

		if (o.orderEnabled) {
			this.createOrder = new __WEBPACK_IMPORTED_MODULE_3_modules_packages_create_order_viewmodel__["a" /* CreateOrderForm */](o.orderFormSelector, o);
			this.createOrder.onSuccess.add(function () {
				_this.reset();
				if (o.orderCloseOnSuccess) {
					_this.close();
				}
			});
		}

		this.input(o.value);

		this._isOpened.subscribe(function (state) {
			if (state) {
				_this.onOpen.fire();
			}
		});
		this.input.subscribe(function () {
			_this._processInput();
		});
		this.inputFocus.subscribe(function (value) {
			if (value && _this._processed()) {
				_this.open();
			}
		});

		if (o.autoScroll) {
			this._initAutoScroll();
		}
	}

	/** @type {boolean} */


	/** @type {QuickSearchViewModel} */


	_createClass(MainInput, [{
		key: "handleSubmit",
		value: function handleSubmit() {
			if (this._mode() == 'search' && this._processed() && this._o.searchEnabled) {
				this.quickSearch.handleSubmit();
			} else {
				this._processInput();
			}
		}
	}, {
		key: "_processInput",
		value: function _processInput() {
			var input = Object(__WEBPACK_IMPORTED_MODULE_1__utils_var__["d" /* asString */])(this.input()).trim();
			if (input.length < 3) {
				this._processed(false);
				return;
			}

			if (/^https?:\/\//i.test(input) && this._o.orderEnabled) {
				this._doCreateOrder();
			} else if (this._o.searchEnabled) {
				this._doSearch();
			}
			this._processed(true);
			this.open();
		}
	}, {
		key: "_doCreateOrder",
		value: function _doCreateOrder() {
			this._mode('order');
			this.createOrder.process(this.input());
		}
	}, {
		key: "_doSearch",
		value: function _doSearch() {
			this._mode('search');
			this.quickSearch.criteria(this.input());
		}
	}, {
		key: "_initAutoScroll",
		value: function _initAutoScroll() {
			var _this2 = this;

			var scroll = function scroll() {
				var $container = $(_this2._o.containerSelector);
				if ($container.length > 0) {
					var top = $container.offset().top - 40;
					$('body,html').animate({ scrollTop: top }, 600);
				}
			};
			this.onOpen.add(scroll);
			if (!this._o.orderCloseOnSuccess) {
				this.createOrder.onSuccess.add(scroll);
			}
		}
	}, {
		key: "open",
		value: function open() {
			this._isOpened(true);
		}
	}, {
		key: "close",
		value: function close() {
			this._isOpened(false);
		}
	}, {
		key: "reset",
		value: function reset() {
			this.input('');
		}
	}, {
		key: "highlight",
		value: function highlight() {
			this.active(true);
		}
	}, {
		key: "unhighlight",
		value: function unhighlight() {
			if (!this.inputFocus()) {
				this.active(false);
			}
		}
	}, {
		key: "handleExampleSearchClick",
		value: function handleExampleSearchClick(item, e) {
			var value = $(e.target).text().trim();
			this.input(value);
			this.open();
		}
	}, {
		key: "handleExampleOrderClick",
		value: function handleExampleOrderClick(item, e) {
			var value = $(e.target).attr('href');
			this.input(value);
			this.open();
		}
	}, {
		key: "handleOverlayClick",
		value: function handleOverlayClick() {
			if (this._mode() != 'order') {
				this.close();
			}
		}
	}, {
		key: "isOpened",
		get: function get() {
			return this._isOpened();
		}

		/** @type {string} */

	}, {
		key: "mode",
		get: function get() {
			return this._mode();
		}
	}]);

	return MainInput;
}();

/***/ }),

/***/ "2uje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr__ = __webpack_require__("og09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var t = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.toastr : __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default.a;

var MSG_ERROR = 'Ошибка';
var MSG_ERROR_XHR = 'Не удалось выполнить запрос';

var Notifier = function () {
	function Notifier() {
		_classCallCheck(this, Notifier);
	}

	_createClass(Notifier, null, [{
		key: "error",
		value: function error() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			// Extend timeout for errors to 10 seconds by default
			var timeOut = options ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(options.timeOut, 10000) : 10000;
			t.error(Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(message, MSG_ERROR), title, _extends({ timeOut: timeOut }, options));
		}
	}, {
		key: "errorXHR",
		value: function errorXHR(jqXHR, textStatus, errorThrown) {
			if (textStatus != 'abort') {
				Notifier.error(MSG_ERROR_XHR);
			}
		}
	}, {
		key: "info",
		value: function info(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.info(message, title, _extends({}, options));
		}
	}, {
		key: "success",
		value: function success(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.success(message, title, _extends({}, options));
		}
	}, {
		key: "warning",
		value: function warning(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.warning(message, title, _extends({}, options));
		}
	}]);

	return Notifier;
}();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("I47I");


/***/ }),

/***/ "4zkK":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">${zde.lang('caption_cart_success')}</div>\r\n</div>\r\n<div class=\"popup-text\">\r\n\t<div>${zde.lang('msg_cart_success')}</div>\r\n\t<br />\r\n\t<div>${zde.lang('txt_cart_address_summary')}</div>\r\n\t<div><strong>Имя:</strong> ${first_name}</div>\r\n\t<div><strong>Фамилия:</strong> ${last_name}</div>\r\n\t<div><strong>Область:</strong> ${region}</div>\r\n\t<div><strong>Город:</strong> ${city}</div>\r\n\t<div><strong>Улица:</strong> ${street}</div>\r\n\t<div><strong>Дом:</strong> ${house_number}</div>\r\n\t<div><strong>Квартира:</strong> ${flat_number}</div>\r\n\t<div><strong>Индекс:</strong> ${post_code}</div>\r\n\t<div><strong>Отделение Новой Почты:</strong> ${address}</div>\r\n\t<div><strong>Телефон:</strong> ${phone}</div>\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\">${zde.lang('btn_ready')}</button>\r\n</div>\r\n"

/***/ }),

/***/ "50IF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReviewList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data__ = __webpack_require__("m9tG");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ReviewList = function (_BaseList) {
	_inherits(ReviewList, _BaseList);

	/**
  * @param {Settings} settings
  */
	function ReviewList(settings) {
		_classCallCheck(this, ReviewList);

		return _possibleConstructorReturn(this, (ReviewList.__proto__ || Object.getPrototypeOf(ReviewList)).call(this, { name: 'reviews', settings: settings }));
	}

	_createClass(ReviewList, [{
		key: "initData",
		value: function initData(data) {
			if (__WEBPACK_IMPORTED_MODULE_4__data__["b" /* settings */].debug && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(data['scores']) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(data['items'])) {
				var newItems = __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.map(data['items'], function (item) {
					return _extends({}, item, {
						score: data['scores'][item['id']]
					});
				});
				data = _extends({}, data, {
					items: newItems
				});
			}
			_get(ReviewList.prototype.__proto__ || Object.getPrototypeOf(ReviewList.prototype), "initData", this).call(this, data);
		}
	}, {
		key: "newItem",
		value: function newItem(itemData) {
			return new ReviewItem(itemData, this.settings);
		}
	}]);

	return ReviewList;
}(__WEBPACK_IMPORTED_MODULE_1__lists__["a" /* BaseList */]);

var ReviewItem = function () {
	/**
  * @param {object} data
  * @param {Settings} settings
  */
	function ReviewItem(data, settings) {
		_classCallCheck(this, ReviewItem);

		this.id = data.id;
		this.text = data.text;
		this.authorId = data.authorId;
		this.authorName = data.authorName;
		this.previewImage = data.previewImage ? __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */](data.previewImage) : __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */]('public/images/noimage.png');
		this.productName = data.productName;
		this.shopName = data.shopName;
		this.shopSlug = data.shopSlug;
		this.price = settings.convertPrice(data.price);
		this.rating = data.rating;
		this.likesCount = data.likesCount;
		this.commentsCount = data.commentsCount;
		this.date = new Date(data.date);
		this.score = data.score;
	}

	_createClass(ReviewItem, [{
		key: "showDebugInfo",
		value: function showDebugInfo() {
			if (__WEBPACK_IMPORTED_MODULE_4__data__["b" /* settings */].debug && this.score) {
				__WEBPACK_IMPORTED_MODULE_4__data__["a" /* debugInfo */].show('review', this.id);
			}
		}
	}, {
		key: "authorUrl",
		get: function get() {
			return __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */]('users', this.authorId);
		}
	}, {
		key: "shopUrl",
		get: function get() {
			return __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */]('shops', this.shopSlug);
		}
	}, {
		key: "url",
		get: function get() {
			return __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */]('reviews', 'id' + this.id);
		}
	}]);

	return ReviewItem;
}();

/***/ }),

/***/ "59Ni":
/***/ (function(module, exports) {

module.exports = "<label for=\"variantRadio${id}\" class=\"{{if soldOut}}not_available{{else}}available{{/if}}\" title=\"${color}\">\n\t<input type=\"radio\"\n\t       id=\"variantRadio${id}\"\n\t       variantId=\"${id}\"\n\t       value=\"${color}\"\n\t       name=\"variant\"\n\t       class=\"labeledInput\"\n\t       image=\"${image}\"\n\t       full_image=\"${fullImage}\"\n\t       artnum=\"${artnum}\"\n\t\t   soldout=\"${soldOut}\"\n\t       {{if soldOut}}disabled1=\"disabled\"{{/if}}/>\n\t<span>${color}</span>\n</label>\n"

/***/ }),

/***/ "5sk8":
/***/ (function(module, exports) {

module.exports = "{{if package_count}}\n<div class=\"reviews-line-view\">\n\t<a href=\"/reviews/package_id/${package}\" target=\"_blank\" class=\"review-link\"></a>\n\t<div class=\"reviews-view-col-1\">\n\t\t<span class=\"rev-count\">${package_count} отзывов</span>\n\t\tна товар\n\t\t<a href=\"/reviews/package_id/${package}\" target=\"_blank\">${name}</a>\n\t</div>\n\t<a class=\"rev-readmore\" href=\"/reviews/package_id/${package}\" target=\"_blank\">Смотреть &raquo;</a>\n</div>\n{{/if}}\n"

/***/ }),

/***/ "5wqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newLogger;
/* unused harmony export setDefaultLevel */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LEVEL_DEBUG = 0;
var LEVEL_INFO = 1;
var LEVEL_WARN = 2;
var LEVEL_ERROR = 3;

var LEVELS = ['debug', 'info', 'warn', 'error'];

var defaultLevel = window.IS_PRODUCTION ? LEVEL_WARN : LEVEL_DEBUG;

/**
 * Creates new logger instance with default level.
 * @param {string|null} name
 * @return {MyLogger}
 */
function newLogger() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return new MyLogger(name, defaultLevel);
}

/**
 * Sets level for new loggers.
 * @param {number} level
 */
function setDefaultLevel(level) {
	defaultLevel = level;
}

var MyLogger = function () {
	function MyLogger(name, level) {
		_classCallCheck(this, MyLogger);

		this._name = '';
		this._level = -1;

		this._dummy = function () {};

		this._name = name;
		this.setLevel(level);
	}

	_createClass(MyLogger, [{
		key: 'setLevel',
		value: function setLevel(level) {
			var _this = this;

			level = Number.isInteger(level) ? level : LEVELS.indexOf(level);
			this._level = level;

			var name = this._name ? '[' + this._name + ']' : null;
			var bind = function bind(condition, methodName) {
				if (!condition || !console[methodName]) return _this._dummy;
				return name ? console[methodName].bind(console, name) : console[methodName].bind(console);
			};
			var bindSimple = function bindSimple(condition, methodName) {
				return condition && console[methodName] ? console[methodName].bind(console) : _this._dummy;
			};

			[['log', LEVEL_DEBUG], ['info', LEVEL_INFO], ['warn', LEVEL_WARN], ['error', LEVEL_ERROR]].forEach(function (i) {
				var _i = _slicedToArray(i, 2),
				    method = _i[0],
				    lvl = _i[1];

				_this[method] = bind(level <= lvl, method);
			});

			['time', 'timeEnd', 'profile', 'profileEnd'].forEach(function (method) {
				_this[method] = bindSimple(level <= LEVEL_DEBUG, method);
			});
		}

		/** The same as {@link Console.log} */

	}, {
		key: 'log',
		value: function log(args) {}

		/** The same as {@link Console.info} */

	}, {
		key: 'info',
		value: function info(args) {}

		/** The same as {@link Console.warn} */

	}, {
		key: 'warn',
		value: function warn(args) {}

		/** The same as {@link Console.error} */

	}, {
		key: 'error',
		value: function error(args) {}

		/** The same as {@link Console.time} */

	}, {
		key: 'time',
		value: function time(label) {}

		/** The same as {@link Console.timeEnd} */

	}, {
		key: 'timeEnd',
		value: function timeEnd(label) {}

		/** The same as {@link Console.profile} */

	}, {
		key: 'profile',
		value: function profile(label) {}

		/** The same as {@link Console.profileEnd} */

	}, {
		key: 'profileEnd',
		value: function profileEnd(label) {}
	}, {
		key: 'measureTime',
		value: function measureTime(label, callable) {
			this.time(label);
			var result = callable();
			this.timeEnd(label);
			return result;
		}
	}, {
		key: 'doProfile',
		value: function doProfile(label, callable) {
			this.profile(label);
			var result = callable();
			this.profileEnd(label);
			return result;
		}
	}, {
		key: 'setLevelDebug',
		value: function setLevelDebug() {
			this.setLevel(LEVEL_DEBUG);
		}
	}, {
		key: 'setLevelInfo',
		value: function setLevelInfo() {
			this.setLevel(LEVEL_INFO);
		}
	}, {
		key: 'setLevelWarn',
		value: function setLevelWarn() {
			this.setLevel(LEVEL_WARN);
		}
	}, {
		key: 'setLevelError',
		value: function setLevelError() {
			this.setLevel(LEVEL_ERROR);
		}
	}]);

	return MyLogger;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (newLogger());

/***/ }),

/***/ "6mWo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






/**
 * Base implementation of list that holds items of type {@link ListItem}
 */
var BaseList = function () {
	function BaseList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, BaseList);

		this._id = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._name = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._title = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._total = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		this._items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable([]);
		this._settings = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		this._indexById = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable({});
		this._indexByName = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable({});
		this._onItemClick = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		this._id(data ? data.id : '');
		this._name(data ? data.name : '');
		this._title(data ? data.title : '');
		this._total(data ? data.total : 0);
		this._settings(data ? data.settings : null);

		// fix context for methods that are used in knockout bindings
		this.handleClick = this.handleClick.bind(this);
	}

	// computed

	// fields


	_createClass(BaseList, [{
		key: "init",


		/**
   * Initializes the list with new data
   * @param {Object|Object[]} data
   */
		value: function init(data) {
			if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isArray(data)) {
				this.initItems(data);
			} else if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isObject(data)) {
				this.initData(data);
			}
		}

		/**
   * Initializes list properties
   * @param {Object} data
   */

	}, {
		key: "initData",
		value: function initData(data) {
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['id'])) {
				this._id(data['id']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['name'])) {
				this._name(data['name']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['title'])) {
				this._title(data['title']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['total'])) {
				this._total(data['total']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['settings'])) {
				this._settings(data['settings']);
			}
			if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isArray(data['items'])) {
				this.initItems(data['items']);
			}
		}

		/**
   * Initializes list items
   * @param {Object[]} itemsData
   */

	}, {
		key: "initItems",
		value: function initItems(itemsData) {
			var items = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.map(itemsData, this.newItem, this) : [];
			var indexById = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.indexBy(items, 'id') : {};
			var indexByName = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.indexBy(items, 'name') : {};
			this._items(items);
			this._indexById(indexById);
			this._indexByName(indexByName);
		}

		/**
   * Creates ListItem from given data
   * @param {Object} itemData
   * @return {ListItem}
   */

	}, {
		key: "newItem",
		value: function newItem(itemData) {
			return new ListItem(itemData);
		}

		/**
   * @param {number} id
   * @return {ListItem}
   */

	}, {
		key: "getItem",
		value: function getItem(id) {
			return this._indexById()[id];
		}

		/**
   * @param {string} name
   * @return {ListItem}
   */

	}, {
		key: "getItemByName",
		value: function getItemByName(name) {
			return this._indexByName()[name];
		}

		/**
   * Add event handler for item click
   * @param {Function} callback
   */

	}, {
		key: "onItemClick",
		value: function onItemClick(callback) {
			this._onItemClick.add(callback);
		}

		/**
   * @param {ListItem} item
   */

	}, {
		key: "handleClick",
		value: function handleClick(item) {
			this._onItemClick.fire(item);
		}
	}, {
		key: "id",
		get: function get() {
			return this._id();
		}
	}, {
		key: "name",
		get: function get() {
			return this._name();
		}
	}, {
		key: "title",
		get: function get() {
			return this._title();
		}

		/** @return {ListItem[]} */

	}, {
		key: "items",
		get: function get() {
			return this._items();
		}

		/** @return {number} */

	}, {
		key: "size",
		get: function get() {
			return this.items.length;
		}

		/** @return {boolean} */

	}, {
		key: "empty",
		get: function get() {
			return this.size == 0;
		}

		/** @return {number} */

	}, {
		key: "total",
		get: function get() {
			return this._total();
		}

		/** @type {Settings} */

	}, {
		key: "settings",
		get: function get() {
			return this._settings();
		}
	}]);

	return BaseList;
}();

/**
 * Implementation of BaseList that supports sorting and filtering
 */
var List = function (_BaseList) {
	_inherits(List, _BaseList);

	// options
	function List() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, List);

		var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, data));

		_this._sortItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(true);
		_this._filterItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(true);


		_this._selectedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var items = __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.items, function (item) {
				return item.selected;
			});
			return __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.sortBy(items, function (item) {
				return item.selected;
			});
		});
		_this._unselectedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.items, function (item) {
				return !item.selected;
			});
		});
		_this._sortedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this.sortItems ? [].concat(_toConsumableArray(_this.sortSource)).sort(_this.sortFunction.bind(_this)) : _this.sortSource;
		});
		_this._filteredItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this.filterItems ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.filterSource, function (item) {
				return _this.filterPredicate(item);
			}) : _this.filterSource;
		});

		/*
  visibleItems <- _sortedItems <- _filteredItems <- items
   */
		return _this;
	}

	/** @type {boolean} */


	_createClass(List, [{
		key: "sortFunction",


		/**
   * @param {ListItem} item1
   * @param {ListItem} item2
   * @return {number}
   */
		value: function sortFunction(item1, item2) {
			// by count descending
			return item2.count - item1.count;
		}

		/**
   * @param {ListItem} item
   * @return {boolean}
   */

	}, {
		key: "filterPredicate",
		value: function filterPredicate(item) {
			// hide empty items
			return item.count > 0;
		}

		/**
   * These items should be shown to user
   * @return {ListItem[]}
   */

	}, {
		key: "updateCounts",
		value: function updateCounts(data) {
			__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.each(this.items, function (item) {
				var d = data ? data[item.id] : null;
				item.count = Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isObject(d) ? d.count : d);
			});
		}
	}, {
		key: "resetCounts",
		value: function resetCounts() {
			__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.each(this.items, function (item) {
				return item.count = 0;
			});
		}
	}, {
		key: "sortItems",
		get: function get() {
			return this._sortItems();
		}

		/** @param {boolean} value */
		,
		set: function set(value) {
			this._sortItems(value);
		}

		/** @type {boolean} */

	}, {
		key: "filterItems",
		get: function get() {
			return this._filterItems();
		}

		/** @param {boolean} value */
		,
		set: function set(value) {
			this._filterItems(value);
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "selectedItems",
		get: function get() {
			return this._selectedItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "unselectedItems",
		get: function get() {
			return this._unselectedItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "sortSource",
		get: function get() {
			return this._filteredItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "filterSource",
		get: function get() {
			return this.items;
		}
	}, {
		key: "visibleItems",
		get: function get() {
			return this._sortedItems();
		}

		/**
   * @return {number}
   */

	}, {
		key: "visibleCount",
		get: function get() {
			return this.visibleItems.length;
		}

		/**
   * @return {number}
   */

	}, {
		key: "hiddenCount",
		get: function get() {
			return this.items.length - this.visibleItems.length;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: "hasVisibleItems",
		get: function get() {
			return this.visibleItems.length > 0;
		}
	}, {
		key: "size",
		get: function get() {
			return this.visibleItems.length;
		}
	}]);

	return List;
}(BaseList);

/**
 * Base implementation of list item for {@link List} class.
 * All input data can be observables to track changes.
 */
var ListItem = function () {
	function ListItem(data) {
		_classCallCheck(this, ListItem);

		this._count = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);

		this._data = _extends({}, data);
		this._count(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(data.count));
	}

	_createClass(ListItem, [{
		key: "id",
		get: function get() {
			return +this._data.id;
		}
	}, {
		key: "name",
		get: function get() {
			return '' + this._data.name;
		}
	}, {
		key: "title",
		get: function get() {
			return '' + this._data.title;
		}
	}, {
		key: "count",
		get: function get() {
			return this._count();
		},
		set: function set(value) {
			this._count(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(value));
		}
	}, {
		key: "selected",
		get: function get() {
			return !!this._data.selected;
		}
	}, {
		key: "disabled",
		get: function get() {
			return !!this._data.disabled;
		}
	}, {
		key: "empty",
		get: function get() {
			return this.count == 0;
		}
	}]);

	return ListItem;
}();

/***/ }),

/***/ "7fPx":
/***/ (function(module, exports) {

module.exports = ko;

/***/ }),

/***/ "EfVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DebugInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_modal__ = __webpack_require__("rItL");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DebugInfo = function () {
	function DebugInfo() {
		_classCallCheck(this, DebugInfo);

		this._searchCriteria = '';
	}

	_createClass(DebugInfo, [{
		key: 'getSearchCriteria',
		value: function getSearchCriteria() {
			return this._searchCriteria;
		}
	}, {
		key: 'setSearchCriteria',
		value: function setSearchCriteria(criteria) {
			this._searchCriteria = criteria;
		}
	}, {
		key: 'show',
		value: function show(itemType, itemId) {
			if (!this._searchCriteria) {
				return;
			}
			Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_modal__["a" /* showModalIframe */])('shop_search_debug', {
				criteria: this._searchCriteria,
				item_type: itemType,
				item_id: itemId
			});
		}
	}]);

	return DebugInfo;
}();

/***/ }),

/***/ "FYi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
/* harmony export (immutable) */ __webpack_exports__["g"] = siteUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = joinPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = isAbsolute;
/* unused harmony export buildQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = highlightUrls;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UrlParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UrlBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__("dTkA");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BASE_URL = (window.base_url || '/').replace(/(.*)\/\/$|([^/])$/, '$1/');

var isAbsoluteUrlRegex = /^https?:\/\//i;

/**
 * @param {string|object} url Url path
 * @param {string|object} more Additional parts
 * @return {string}
 */
function siteUrl(url) {
	for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		more[_key - 1] = arguments[_key];
	}

	if (isAbsoluteUrlRegex.test(url)) {
		if (more.length === 0) {
			return url;
		} else {
			return joinPath.apply(null, [url].concat(more));
		}
	} else {
		return joinPath.apply(null, [BASE_URL, url].concat(more));
	}
}

/**
 * Joins given values with slash.
 * If last value is an object - it will be formatted as query data.
 * @param {string|object} values
 * @return {string}
 */
function joinPath() {
	for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		values[_key2] = arguments[_key2];
	}

	if (values.length == 0) return '';
	var query = {};
	var queryString = '';
	var fragment = '';
	var components = [];
	var processValue = function processValue(v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(v)) {
			query = _extends({}, query, v);
		} else {
			v = Object(__WEBPACK_IMPORTED_MODULE_2__var__["d" /* asString */])(v).trim();
			var i = void 0;
			if ((i = v.indexOf('#')) >= 0) {
				fragment = v.substr(i + 1);
				v = v.substr(0, i);
			} else if ((i = v.indexOf('?')) >= 0) {
				queryString = v.substr(i + 1);
				v = v.substr(0, i);
			}
			if (v) {
				if (components.length == 0) {
					v = v.replace(/\/$/g, '');
				} else {
					v = v.replace(/^\/|\/$/g, '');
				}
				components.push(v);
			}
		}
	};
	values.forEach(function (v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(v)) {
			v.forEach(processValue);
		} else {
			processValue(v);
		}
	});
	var url = components.join('/');
	if (!__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(query)) {
		var q = buildQuery(query);
		if (queryString) {
			queryString += '&';
		}
		queryString += q;
	}
	if (queryString) {
		url += '?' + queryString;
	}
	if (fragment) {
		url += '#' + fragment;
	}
	return url;
}

/**
 *
 * @param {string} url
 * @return {boolean}
 */
function isAbsolute(url) {
	return isAbsoluteUrlRegex.test(url);
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @return {string}
 */
function buildQuery(queryData) {
	return __WEBPACK_IMPORTED_MODULE_1__location__["c" /* buildQuery */](queryData);
}

function highlightUrls(text) {
	var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

	return text.replace(/(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\?+=&%#\/\wА-Яа-яёЁ\.;-]*)*\/?/g, function (s) {
		var st = s;

		if (s.length > maxlength) {
			st = s.slice(0, maxlength) + "...";
		}

		if (!/^(https?:\/\/)/.test(s)) {
			s = "http://" + s;
		}

		return "<a href='" + s + "' target='_blank' rel='nofollow noopener'>" + st + "</a>";
	});
}

var UrlParser = function () {
	/**
  * @param {string} url
  */
	function UrlParser(url) {
		_classCallCheck(this, UrlParser);

		this._a = document.createElement('a');
		this._a.href = url;
	}

	/** @return {string} */


	_createClass(UrlParser, [{
		key: 'origin',
		get: function get() {
			return this._a.origin;
		}

		/** @return {string} */

	}, {
		key: 'protocol',
		get: function get() {
			return this._a.protocol;
		}

		/** @return {string} */

	}, {
		key: 'host',
		get: function get() {
			return this._a.host;
		}

		/** @return {string} */

	}, {
		key: 'hostname',
		get: function get() {
			return this._a.hostname;
		}

		/** @return {string} */

	}, {
		key: 'port',
		get: function get() {
			return this._a.port;
		}

		/** @return {string} */

	}, {
		key: 'pathname',
		get: function get() {
			return this._a.pathname;
		}

		/** @return {string} */

	}, {
		key: 'search',
		get: function get() {
			return this._a.search;
		}

		/** @return {string} */

	}, {
		key: 'hash',
		get: function get() {
			return this._a.hash;
		}
	}]);

	return UrlParser;
}();

var UrlBuilder = function () {
	function UrlBuilder() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
		var hash = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

		_classCallCheck(this, UrlBuilder);

		this._protocol = protocol;
		this._host = host;
		this._port = port;
		this._path = path;
		this._query = query;
		this._hash = hash;
	}

	/**
  * @param {string|null} value
  */


	_createClass(UrlBuilder, [{
		key: 'build',


		/**
   * @return {string}
   */
		value: function build() {
			var origin = (this._protocol ? this._protocol + '//' : '') + (this._host ? this._host + (this._port ? ':' + this._port : '') : '');
			var query = _typeof(this._query) === 'object' ? prefix(buildQuery(this._query), '?') : this._query;
			return joinPath(origin, this._path, query, this._hash);
		}
	}, {
		key: 'protocol',
		set: function set(value) {
			this._protocol = postfix(value, ':');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._protocol;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'host',
		set: function set(value) {
			this._host = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._host;
		}

		/**
   * @param {string|number|null} value
   */

	}, {
		key: 'port',
		set: function set(value) {
			this._port = value;
		}

		/** @return {string|number|null} */
		,
		get: function get() {
			return this._port;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'path',
		set: function set(value) {
			this._path = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._path;
		}

		/**
   * @param {string|object|null} value
   */

	}, {
		key: 'query',
		set: function set(value) {
			this._query = prefix(value, '?');
		}

		/** @return {string|object|null} */
		,
		get: function get() {
			return this._query;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'hash',
		set: function set(value) {
			this._hash = prefix(value, '#');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._hash;
		}
	}]);

	return UrlBuilder;
}();

function prefix(val, prefix) {
	if (val && typeof val === 'string' && !val.startsWith(prefix)) {
		return prefix + val;
	}
	return val;
}

function postfix(val, postfix) {
	if (val && typeof val === 'string' && !val.endsWith(postfix)) {
		return val + postfix;
	}
	return val;
}

/***/ }),

/***/ "GZT1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HH+/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("q/mW"))

/***/ }),

/***/ "I47I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_less__ = __webpack_require__("jj9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy__ = __webpack_require__("hexH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_lazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sections_main__ = __webpack_require__("JhtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections_reviews__ = __webpack_require__("wn5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections_products__ = __webpack_require__("I5MN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sections_articles__ = __webpack_require__("kNst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sections_about_us__ = __webpack_require__("ziQ0");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "main", function() { return __WEBPACK_IMPORTED_MODULE_3__sections_main__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "reviews", function() { return __WEBPACK_IMPORTED_MODULE_4__sections_reviews__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "products", function() { return __WEBPACK_IMPORTED_MODULE_5__sections_products__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "articles", function() { return __WEBPACK_IMPORTED_MODULE_6__sections_articles__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "aboutUs", function() { return __WEBPACK_IMPORTED_MODULE_7__sections_about_us__; });
var ensureWebpBackwardCompatibility = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var isSupported;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_utils__["e" /* isWebpFeatureSupported */])(__WEBPACK_IMPORTED_MODULE_2__core_utils_utils__["a" /* WEBP_FEATURES */].LOSSY);

					case 2:
						isSupported = _context.sent;


						if (!isSupported) {
							// Find all elements marked as having webp background images and add class which can be used in css to replace
							// those images by jpeg/png alternatives
							$('.webp-bg').addClass('webp-bg-fallback');
						}

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function ensureWebpBackwardCompatibility() {
		return _ref.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function init() {
	initAnchors();
	initLazy();
	ensureWebpBackwardCompatibility();
}

function initAnchors() {
	$('[rel=anchor]').click(function () {
		var $target = $($(this).attr('href'));
		if ($target.length > 0) {
			var top = $target.offset().top;
			$('body,html').animate({ scrollTop: top }, 600);
		}
	});
}

function initLazy() {
	/* jquery-lazy for some reason downloads images immediately for element if it's parent has display set to "none"
 *  (in mobile layout last slide in "top products" section has display "none" for example). That's why initially
 *  track only visible elements and then check after window resizing whether there are new ones */
	function getNotHiddenElements() {
		var $elements = $('.lazy-load:visible');
		$elements.removeClass('lazy-load');
		return $elements;
	}

	setTimeout(function () {
		window.lazyLoader = getNotHiddenElements().lazy({ chainable: false, autoDestroy: false });
	});

	$(window).resize(function () {
		var $elements = getNotHiddenElements();
		if ($elements.length) {
			window.lazyLoader.addItems($elements);
		}
	});
}

/***/ }),

/***/ "I5MN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_slick_carousel__ = __webpack_require__("d7nS");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var logger = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_logger__["a" /* newLogger */])('TopProducts');

function init(options) {
	var o = _extends({
		categories: {}
	}, options);

	logger.log('init', o);

	var $section = $('#top-products');
	$section.removeClass('before-slick-init');
	var $navSlider = $section.find('[rel=nav-slider]');
	var $slaveSlider = $section.find('[rel=slave-slider]');

	var viewModel = new ViewModel(o);
	__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.applyBindings(viewModel, $section[0]);

	$navSlider.slick({
		arrows: false,
		variableWidth: true,
		// infinite: true,
		centerMode: true,
		focusOnSelect: true,
		asNavFor: $slaveSlider,
		responsive: [{
			breakpoint: 1160,
			settings: {
				slidesToShow: 3,
				centerMode: true,
				infinite: true,
				arrows: true
			}
		}]
	}).on('click11', '.slick-slide', function () {
		var index = $(this).data('slickIndex');
		$navSlider.slick('slickGoTo', index);
	}).on('afterChange', function (e, s, index) {
		var category = $navSlider.find('.slick-slide[data-slick-index=' + index + '] li').data('category');
		setCategory(category);
		if (window.lazyLoader) {
			window.lazyLoader.update();
		}
	});

	$slaveSlider.slick({
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: $navSlider,
		__responsive: [{
			breakpoint: 1260,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 938,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 750,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 489,
			settings: {
				slidesToShow: 1,
				centerMode: true
			}
		}]
	});

	var category = $navSlider.find('.slick-slide[data-slick-index=0] li').data('category');
	setCategory(category);

	function setCategory(category) {
		logger.log('set category', category);
		// $slaveSlider.slick('slickUnfilter');
		// $slaveSlider.slick('slickFilter', `:has([data-category=${category}])`);
		viewModel.setCategory(category);
	}
}

var ViewModel = function () {
	function ViewModel(option) {
		_classCallCheck(this, ViewModel);

		this.currentCategory = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable();

		var arr = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(option.categories, function (cat) {
			return _extends({
				name: '',
				title: '',
				count: '',
				url: ''
			}, cat);
		});
		this.categories = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.indexBy(arr, 'name');
	}

	_createClass(ViewModel, [{
		key: 'setCategory',
		value: function setCategory(categoryName) {
			var cat = this.categories[categoryName];
			this.currentCategory(cat);
		}
	}]);

	return ViewModel;
}();

/***/ }),

/***/ "JhtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_maininput__ = __webpack_require__("2F9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_slick_carousel__ = __webpack_require__("d7nS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_soon_countdown__ = __webpack_require__("webD");






var logger = Object(__WEBPACK_IMPORTED_MODULE_1_core_utils_logger__["a" /* newLogger */])('Landing/main');

function init(options) {
	initMainInput(options);
	initSlider();
	initDockMenu();

	var $screen = $('#main-screen');
	$screen.find('.toggle-icon').click(function () {
		$screen.find('.menu').toggleClass('pushed');
	});
}

function initMainInput(options) {
	var rootNode = document.getElementById('searchRoot');
	var $container = $('#search');
	var model = new __WEBPACK_IMPORTED_MODULE_2__core_components_maininput__["a" /* MainInput */]({
		containerSelector: $container,
		orderFormSelector: $container.find('.formOrder'),
		checkingTypes: options.checkingTypes
	});
	__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.applyBindings(model, rootNode);
}

function initSlider() {
	var $share_section = $('#main-screen').find('.share-block');
	$share_section.removeClass('before-slick-init');
	var $slider = $share_section.find('.share-slider');
	if ($slider.closest('.single').length > 0) {
		return;
	}
	$slider.slick({
		// fade: true,
		autoplay: true,
		autoplaySpeed: 10000,
		dots: true
	}).on('afterChange', function () {
		var date = $(this).find('.slick-current').find('.share-slide').data('due');
		$('.share-left .soon').soon().setOption('due', date);
	});
}

function initDockMenu() {
	var $container = $('#main-screen').find(".dock-container");
	$container.find(".dock-item").each(function () {
		$(this).hover(function () {
			$(this).prev(".dock-item").addClass("nearby");
			$(this).next(".dock-item").addClass("nearby");
		}, function () {
			$(this).prev(".dock-item").removeClass("nearby");
			$(this).next(".dock-item").removeClass("nearby");
		});
	});

	var $movingLine = $container.find('.moving-line');
	if ($movingLine.length > 0) {
		$container.mouseover(function (e) {
			var offset = $(this).offset();
			var relativeX = e.pageX - offset.left;
			$movingLine.css('left', relativeX);
		});
	}
}

/***/ }),

/***/ "KHeJ":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">${zde.lang('caption_cart_success_low_balance')}</div>\r\n</div>\r\n<div class=\"popup-text\">\r\n\t<div>{{html zde.lang('msg_cart_success_low_balance')}}</div>\r\n\t<div class=\"debt-info\">\r\n\t\t<span class=\"debt-value\">${debt_euro_f}</span>\r\n\t\t<span class=\"debt-details\">(${debt_converted_f} по курсу ${currency_rate_f} грн./&euro;)</span>\r\n\t</div>\r\n\t<br />\r\n\t<div>${zde.lang('txt_cart_address_summary')}</div>\r\n\t<div><strong>Имя:</strong> ${first_name}</div>\r\n\t<div><strong>Фамилия:</strong> ${last_name}</div>\r\n\t<div><strong>Область:</strong> ${region}</div>\r\n\t<div><strong>Город:</strong> ${city}</div>\r\n\t<div><strong>Улица:</strong> ${street}</div>\r\n\t<div><strong>Дом:</strong> ${house_number}</div>\r\n\t<div><strong>Квартира:</strong> ${flat_number}</div>\r\n\t<div><strong>Индекс:</strong> ${post_code}</div>\r\n\t<div><strong>Отделение Новой Почты:</strong> ${address}</div>\r\n\t<div><strong>Телефон:</strong> ${phone}</div>\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<a href=\"${balance_link}\" type=\"button\" class=\"popup-btn active replenish-balance\" >${zde.lang('btn_replenish')}</a>\r\n</div>\r\n"

/***/ }),

/***/ "LDVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartPriceComponents; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartPriceComponents = function () {
    function CartPriceComponents() {
        _classCallCheck(this, CartPriceComponents);

        this._fields = ['price', 'checking'];
        this.price = 0;
        this.checking = 0;
    }

    _createClass(CartPriceComponents, [{
        key: 'total',
        value: function total() {
            var total = 0;
            for (var i = 0; i < this._fields.length; i++) {
                total += this[this._fields[i]];
            }
            return total;
        }

        /**
         * Add given components to the current instance
         * @param {CartPriceComponents} components
         * @param {number} count
         */

    }, {
        key: 'add',
        value: function add(components) {
            var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            for (var i = 0; i < this._fields.length; i++) {
                var field = this._fields[i];
                this[field] += components[field] * count;
            }
        }

        /**
         *
         * @param {number} count
         * @returns {string}
         */

    }, {
        key: 'priceFormatted',
        value: function priceFormatted() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            return this._format(this.price * count);
        }

        /**
         *
         * @param {number} count
         * @returns {string}
         */

    }, {
        key: 'checkingFormatted',
        value: function checkingFormatted() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            return this._format(this.checking * count);
        }

        /**
         *
         * @param {number} count
         * @returns {string}
         */

    }, {
        key: 'totalFormatted',
        value: function totalFormatted() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            return this._format(this.total() * count);
        }
    }, {
        key: '_format',
        value: function _format(value) {
            var formatted = value.toFixed(2);
            return formatted > 0 ? formatted : '0';
        }
    }]);

    return CartPriceComponents;
}();

/***/ }),

/***/ "NPuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleItem; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaleItem = function () {
    function SaleItem(data) {
        _classCallCheck(this, SaleItem);

        this._data = data;
        this._title = ko.pureComputed(function () {
            return data.banner_discount_title + ' ' + data.banner_discount + '% ' + data.page_title;
        });
    }

    _createClass(SaleItem, [{
        key: 'id',
        get: function get() {
            return this._data['page_id'];
        }
    }, {
        key: 'title',
        get: function get() {
            return this._title();
        }
    }, {
        key: 'description',
        get: function get() {
            return this._data['page_title'];
        }
    }, {
        key: 'url',
        get: function get() {
            return this._data['page_url'];
        }
    }]);

    return SaleItem;
}();

/***/ }),

/***/ "OGjV":
/***/ (function(module, exports) {

module.exports = "<label for=\"sizeRadio${sizeId}\"\n\t   class=\"{{if soldOut}}not_available{{else count == 0 || count > 5}}available{{else}}almost_sold_out{{/if}}\"\n\t   title=\"{{if count > 0}}Осталось ${count}{{else}}Такой вариант отсутствует{{/if}}\">\n\t<input type=\"radio\"\n\t       id=\"sizeRadio${sizeId}\"\n\t       value=\"${sizeName}\"\n\t       name=\"size\"\n\t       class=\"labeledInput\"\n\t       link=\"${link}\"\n\t       price=\"${price}\"\n\t       count=\"${count}\"\n\t       soldout=\"${soldOut ? 1 : 0}\"\n\t       {{if soldOut}}disabled1=\"disabled\" {{/if}}\n\tprice=\"${price}\"/>\n\t<span>${sizeName}</span>\n</label>\n"

/***/ }),

/***/ "OVoP":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\n\t<div class=\"popup-title\">Почти у цели!</div>\n</div>\n<div class=\"popup-text\">\n\t<div>Ваш заказ принят, но на балансе не хватает средств для выкупа.</div>\n\t<div>Необходимо пополнить баланс на сумму:</div>\n\t<div class=\"debt-info\">\n\t\t<span class=\"debt-value\">${debt_euro_f}</span>\n\t\t<span class=\"debt-details\">(${debt_converted_f} по курсу ${currency_rate_f} ${currency_sign}/&euro;)</span>\n\t</div>\n</div>\n<div class=\"popup-buttons\">\n\t<a href=\"${balance_link}\" type=\"button\" class=\"popup-btn active replenish-balance\" >\n\t\tПополнить баланс\n\t</a>\n</div>\n{{if debtpc >= debtpc_allowed}}\n<div class=\"popup-text debt-allowed-note\">\n\tОбратите внимание, что при наличии предоплаты свыше <b>${debtpc_allowed_f}</b>\n\tВаш заказ может быть выкуплен сразу или при наличии группы. Ваша предоплата\n\tс учетом данного заказа: <b>${debtpc_f}</b>\n</div>\n{{/if}}\n"

/***/ }),

/***/ "PXy+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("lk5H"))

/***/ }),

/***/ "Q4Fy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RaK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lang;
/* unused harmony export tmpl */
/* harmony export (immutable) */ __webpack_exports__["b"] = pluralize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals__ = __webpack_require__("tXil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_smart_plurals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__("TxBK");




/**
 * Renders phrase
 * @param {string} lang Phrase name
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is FALSE
 * @returns {string} Rendered phrase
 */
function lang(lang) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	var phrase = Object(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* phrases */])()[lang];
	if (!phrase) return lang;
	return tmpl(phrase, data, asHtml);
}

/**
 *
 * @param {string} template
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is TRUE
 * @returns {string}
 */
function tmpl(template) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	if (!data) return template;
	template = '' + template;

	var result = template;
	for (var key in data) {
		if (!data.hasOwnProperty(key)) continue;
		var val = data[key];

		// unwrap value
		if (typeof val === 'function') {
			val = val();
		}

		var keyParam = escapeRegExp(key);
		var pluralRegex = new RegExp("\\[([^\\]]+{" + keyParam + "}[^\\]]+)\\]");
		var m = pluralRegex.exec(template);
		if (m) {
			result = result.replace(pluralRegex, pluralize(val, m[1], key));
		}

		var replacement = asHtml ? '<span class="tmpl-var-' + key + '">' + val + '</span>' : val;
		result = result.split('{' + key + '}').join(replacement);
	}
	return result;
}

/**
 *
 * @param {number} count
 * @param {string} text
 * @param {string} varName
 * @param {string|number|null} varValue
 */
function pluralize(count, text) {
	var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'n';
	var varValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	var parts = text.split('|');
	var pluralRule = __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default.a.Plurals.getRule(LANG);
	var part = pluralRule(count, parts);
	if (part === undefined) {
		part = parts[0];
	}
	var replacement = varValue !== undefined && varValue !== null ? varValue : count;
	return part.split('{' + varName + '}').join(replacement);
}

function escapeRegExp(string) {
	return string.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
}

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.bindingHandlers['lang'] = {
	init: function init() {
		return { 'controlsDescendantBindings': true };
	},
	update: function update(element, valueAccessor) {
		var params = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.unwrap(valueAccessor());
		var o = {
			name: '',
			data: undefined,
			html: undefined
		};
		if (!$.isPlainObject(params)) {
			o.name = params;
		} else {
			$.extend(o, params);
		}
		var args = [o.name, o.data, o.html];
		var val = lang.apply(this, args);
		__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.utils.setHtml(element, val);
	}
};

/***/ }),

/***/ "TV6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cart__ = __webpack_require__("jBH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartpricecomponents__ = __webpack_require__("LDVE");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CartItem = function () {
    function CartItem(item, cart) {
        var _this = this;

        _classCallCheck(this, CartItem);

        this.cart = null;

        for (var property in item) {
            if (property == 'amount' || property == 'checking_id') {
                this[property] = ko.observable(item[property]);
            } else {
                this[property] = item[property];
            }
        }

        this.amount.subscribe(function () {
            return $(window).trigger('cart-item-changed');
        });
        this.checking_id.subscribe(function () {
            return $(window).trigger('cart-item-changed');
        });

        // Additional properties
        this.cart = cart;
        this.priceComponents = ko.computed(function () {
            var components = new __WEBPACK_IMPORTED_MODULE_1__cartpricecomponents__["a" /* CartPriceComponents */]();
            components.price = parseFloat(_this.sum);

            if (_this.cart.checkingTypes[_this.checking_id()] !== undefined) {
                components.checking = parseFloat(_this.cart.checkingTypes[_this.checking_id()].price);
            }

            return components;
        });
        this.canAdd = ko.computed(function () {
            return _this.amount() < _this.cart.maxQuantity && _this.cart.canAdd(_this.priceComponents().price, false);
        });
        this.canSubtract = ko.computed(function () {
            return _this.amount() > 1;
        });
    }
    /** @type {Cart} */


    _createClass(CartItem, [{
        key: "serializeArray",
        value: function serializeArray() {
            var result = {};
            var notSerializableProperties = ['cart', 'priceComponents'];

            for (var property in this) {
                if (notSerializableProperties.indexOf(property) !== -1) {
                    continue;
                }

                result[property] = ko.unwrap(this[property]);
                if (result[property] === undefined) {
                    result[property] = null;
                }
            }

            return result;
        }
    }, {
        key: "navigateToProduct",
        value: function navigateToProduct(item, e) {
            var $target = $(e.target);
            if (!$target.closest('.quantity').length && !$target.closest('.select-wrapper').length) {
                window.open(this.order_id);
            }
        }
    }]);

    return CartItem;
}();

/***/ }),

/***/ "TxBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globals;
/* harmony export (immutable) */ __webpack_exports__["b"] = phrases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var__ = __webpack_require__("dTkA");


var _globals = {};
var _phrases = {};

/**
 * Returns Globals object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object|*} Globals object if no key is provided, otherwise associated value
 */
function globals() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = window.globals || _globals;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/**
 * Returns global Phrases object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object} Phrases object if no key is provided, otherwise associated value
 */
function phrases() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = globals('phrases') || _phrases;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/***/ }),

/***/ "WISg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_numeral__ = __webpack_require__("u2Mx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Settings = function () {
	function Settings(data) {
		_classCallCheck(this, Settings);

		this._data = _extends({}, data); // clone to avoid external modification

		if (typeof __WEBPACK_IMPORTED_MODULE_0_lib_numeral___default.a !== 'undefined') {
			__WEBPACK_IMPORTED_MODULE_0_lib_numeral___default.a.localeData().currency.symbol = this.currency;
		}
	}

	/** @return {string} */


	_createClass(Settings, [{
		key: "convertPrice",


		/**
   * @param {number} price
   * @return {number}
   */
		value: function convertPrice(price) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["c" /* asNumber */])(price) * this.currencyRate;
		}
	}, {
		key: "getCategoryUrl",
		value: function getCategoryUrl(categorySlug) {
			var subcategorySlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.shopUrl, categorySlug, subcategorySlug);
		}
	}, {
		key: "getProductUrl",
		value: function getProductUrl(productUri) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.shopUrl, productUri);
		}
	}, {
		key: "getImageUrl",
		value: function getImageUrl(path) {
			var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full/';

			if (__WEBPACK_IMPORTED_MODULE_1__core_utils_url__["e" /* isAbsolute */](path)) {
				return path;
			}
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.imgUrl, dir, path);
		}
	}, {
		key: "getPreviewImgageUrl",
		value: function getPreviewImgageUrl(path) {
			return this.getImageUrl(path, 'preview/');
		}
	}, {
		key: "getShopUrl",
		value: function getShopUrl(shopSlug) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["g" /* siteUrl */]('shops', shopSlug);
		}
	}, {
		key: "getOfferUrl",
		value: function getOfferUrl(offerId) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["g" /* siteUrl */]('shop/relocate', offerId);
		}
	}, {
		key: "baseUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'base_url', ''));
		}

		/** @return {string} */

	}, {
		key: "shopUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'shop_url', ''));
		}

		/** @return {string} */

	}, {
		key: "catalogApiUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'api_url', this.shopUrl));
		}

		/** @return {string} */

	}, {
		key: "searchApiUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'search_api_url', this.shopUrl));
		}

		/** @return {string} */

	}, {
		key: "imgUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'img_url', ''));
		}

		/** @return {string} */

	}, {
		key: "currency",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'currency', 'EUR'));
		}

		/** @return {number} */

	}, {
		key: "currencyRate",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["c" /* asNumber */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'currency_rate'), 1);
		}

		/** @return {boolean} */

	}, {
		key: "isAdmin",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'is_admin'));
		}

		/** @return {boolean} */

	}, {
		key: "isGerman",
		get: function get() {
			return !!window.IS_GERMAN;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: "useFavorites",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'use_favorites'));
		}

		/**
   * Use offer url as product url
   * @return {boolean}
   */

	}, {
		key: "useOfferUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(this._data['use_offer_url']);
		}

		/**
   * Format for numeral library
   * @return {string}
   */

	}, {
		key: "priceFormat",
		get: function get() {
			return this.currencyRate === 1 ? '0,0.00 $' : '0,0 $';
		}

		/** @return {boolean} */

	}, {
		key: "debug",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'debug'));
		}
	}]);

	return Settings;
}();

/***/ }),

/***/ "X0GP":
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ "XRua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = buildQuery;
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = appendQuery;
/* unused harmony export query */
/* unused harmony export hashQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = decodeQueryString;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This script adds some additional methods to window.location
 *  buildQuery      Helper method for constricting query strings
 *  query           location.query manipulator
 *  hashQuery       location.hash manipulator
 */

var location = window.location;

function buildUrl(pathname, queryString) {
	if (!queryString) {
		return pathname;
	}
	queryString = '' + queryString;
	if (!queryString.startsWith('?')) {
		queryString = '?' + queryString;
	}
	return pathname + queryString;
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @param {boolean} [numeric_prefix]
 * @return {string}
 */
function buildQuery(queryData, numeric_prefix) {
	var value = void 0,
	    key = void 0,
	    tmp = [];
	var arg_separator = "&";

	for (key in queryData) {
		if (!queryData.hasOwnProperty(key)) {
			continue;
		}
		value = queryData[key];
		if (numeric_prefix && !isNaN(key)) {
			key = String(numeric_prefix) + key;
		}
		var _query = http_build_query_helper(urlencode(key), value, arg_separator);
		if (_query !== '') {
			tmp.push(_query);
		}
	}

	return tmp.join(arg_separator);
}

/**
 * Appends given query data to given URL
 * @param {string} url
 * @param {object} queryData
 * @return {string} New url
 */
function addQuery(url, queryData) {
	var q = buildQuery(queryData);
	url = '' + url;
	var m = /^([^?#]*)(\?[^#]+)?(#.+)?$/.exec(url);
	if (!m) {
		return url + '?' + q;
	}
	return (m[1] || '') + (m[2] ? m[2] + '&' + q : '?' + q) + (m[3] || '');
}

/**
 * Appends given query data to given query string
 * @param {string} queryString
 * @param {object} queryData
 * @return {string} New query string
 */
function appendQuery(queryString, queryData) {
	var q = buildQuery(queryData);
	if (!q) {
		return queryString;
	}
	var str = '' + queryString;
	return str.length > 0 ? str + '&' + q : q;
}

/**
 * Manipulates <code>location.search</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.search</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.search</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.search</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function query(key, value, extend) {
	return processQuery('search', key, value, extend);
}

/**
 * Manipulates <code>location.hash</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.hash</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.hash</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.hash</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function hashQuery(key, value, extend) {
	return processQuery('hash', key, value, extend);
}

function processQuery(type, key, value, extend) {
	var queryData = decodeQueryString(location[type].substring(1));
	if (key !== undefined) {
		var isObj = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object';

		if (value === undefined && !isObj) {
			// return value
			return queryData[key] === undefined ? null : queryData[key];
		} else if (!isObj) {
			if (extend === undefined) extend = true;

			// set value to key
			var k = key.toString();
			key = {};
			key[k] = value;
		}

		if (extend) {
			$.extend(queryData, key);
		} else {
			queryData = key;
		}

		// clear data
		var newData = {};
		$.each(queryData, function (key, value) {
			if (value) newData[key] = value;
		});
		queryData = newData;

		location[type] = buildQuery(queryData);
	}
	return queryData;
}

/**
 * Decodes query string like 'a=one&b=two&c[]=three' and returns an object
 * @param string
 * @return {Object}
 */
function decodeQueryString(string) {
	var glue1 = '=',
	    glue2 = '&',
	    array = {},
	    // holds result
	array2 = String(string).replace(/^&?([\s\S]*?)&?$/, '$1').split(glue2),
	    i = void 0,
	    j = void 0,
	    chr = void 0,
	    tmp = void 0,
	    key = void 0,
	    value = void 0,
	    bracket = void 0,
	    keys = void 0,
	    evalStr = void 0,
	    fixStr = function fixStr(str) {
		return decodeURIComponent(str).replace(/([\\"'])/g, '\\$1').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\+/g, ' ');
	};

	for (i = 0; i < array2.length; i++) {
		tmp = array2[i].split(glue1);
		if (tmp.length < 2) {
			tmp = [tmp, ''];
		}
		key = fixStr(tmp[0]);
		value = fixStr(tmp[1]);
		while (key.charAt(0) === ' ') {
			key = key.substr(1);
		}
		if (key.indexOf('\0') !== -1) {
			key = key.substr(0, key.indexOf('\0'));
		}
		if (key && key.charAt(0) !== '[') {
			keys = [];
			bracket = 0;
			for (j = 0; j < key.length; j++) {
				if (key.charAt(j) === '[' && !bracket) {
					bracket = j + 1;
				} else if (key.charAt(j) === ']') {
					if (bracket) {
						if (!keys.length) {
							keys.push(key.substr(0, bracket - 1));
						}
						keys.push(key.substr(bracket, j - bracket));
						bracket = 0;
						if (key.charAt(j + 1) !== '[') {
							break;
						}
					}
				}
			}
			if (!keys.length) {
				keys = [key];
			}
			for (j = 0; j < keys[0].length; j++) {
				chr = keys[0].charAt(j);
				if (chr === ' ' || chr === '.' || chr === '[') {
					keys[0] = keys[0].substr(0, j) + '_' + keys[0].substr(j + 1);
				}
				if (chr === '[') {
					break;
				}
			}
			evalStr = 'array';
			for (j = 0; j < keys.length; j++) {
				key = keys[j];
				if (key !== '' && key !== ' ' || j === 0) {
					key = "'" + key + "'";
				} else {
					key = eval(evalStr + '.push([]);') - 1;
				}
				evalStr += '[' + key + ']';
				if (j !== keys.length - 1 && eval('typeof ' + evalStr) === 'undefined') {
					eval(evalStr + ' = [];');
				}
			}
			evalStr += " = '" + value + "';\n";
			eval(evalStr);
		}
	}

	return array;
}

function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function http_build_query_helper(key, val, arg_separator) {
	var k = void 0,
	    tmp = [];
	if (val === true) {
		val = "1";
	} else if (val === false) {
		val = "0";
	}
	if (val !== null && val !== undefined && val !== '') {
		if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === "object") {
			var start = 0;
			for (k in val) {
				if (!val.hasOwnProperty(k)) {
					continue;
				}
				if (val[k] !== null) {
					var sk = void 0,
					    num = Number(k);
					if (!isNaN(num) && num - start === 0) {
						if (_typeof(val[k]) === "object") {
							sk = num;
						} else {
							sk = '';
						}
						start++;
					} else {
						sk = urlencode(k);
					}
					var part = http_build_query_helper(key + "[" + sk + "]", val[k], arg_separator);
					if (part) {
						tmp.push(part);
					}
				}
			}
			return tmp.join(arg_separator);
		} else if (typeof val !== "function") {
			return key + "=" + urlencode(val);
		} else {
			throw new Error('There was an error processing for http_build_query().');
		}
	} else {
		return '';
	}
}

/***/ }),

/***/ "XVWq":
/***/ (function(module, exports) {

module.exports = "{{if count_by_shop}}\n<div class=\"reviews-line-view\">\n\t<a href=\"${shopInfo.reviewlink}\" target=\"_blank\" class=\"review-link\"></a>\n\t<div class=\"reviews-view-col-1\">\n\t\t<span class=\"rev-count\">${count_by_shop} отзывов</span>\n\t\tна магазин\n\t\t<a href=\"reviews/shop/${shopInfo.name_view}/sort_by/date\" target=\"_blank\">${shopName}</a>\n\t</div>\n\t{{if shopInfo.reviewlink}}\n\t<a class=\"rev-readmore\" href=\"${shopInfo.reviewlink}\" target=\"_blank\">Смотреть &raquo;</a>\n\t{{/if}}\n</div>\n{{/if}}\n"

/***/ }),

/***/ "YdFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_LOGIN", function() { return MODAL_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ASK_REDIRECT", function() { return MODAL_ASK_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CRITICAL_NEWS", function() { return MODAL_CRITICAL_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW", function() { return MODAL_REVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_EDIT", function() { return MODAL_REVIEW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_QUESTION_EDIT", function() { return MODAL_QUESTION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_COMMENT_EDIT", function() { return MODAL_REVIEW_COMMENT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CREATE_COMPUTER_ORDER", function() { return MODAL_CREATE_COMPUTER_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_ORDER_PAGE", function() { return MODAL_FILIALIST_ORDER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EXCLUDE_FROM_PARCEL", function() { return MODAL_FILIALIST_EXCLUDE_FROM_PARCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_FREE_ORDERS_EDIT", function() { return MODAL_FILIALIST_FREE_ORDERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CREATE_TODO", function() { return MODAL_FILIALIST_CREATE_TODO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS", function() { return MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER", function() { return MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EDIT_ASSIGNMENT", function() { return MODAL_FILIALIST_EDIT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA", function() { return MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_BATCH_PAYMENT", function() { return MODAL_FILIALIST_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_PACKAGE_KINDS", function() { return MODAL_FILIALIST_SET_PACKAGE_KINDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES", function() { return MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_REPLENISH_BALANCE", function() { return MODAL_ADMIN_REPLENISH_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_BATCH_PAYMENT", function() { return MODAL_ADMIN_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_IMPORT_BANK_STATEMENT", function() { return MODAL_ADMIN_IMPORT_BANK_STATEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_VALIDATE_INVOICE_CSV", function() { return MODAL_ADMIN_VALIDATE_INVOICE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS", function() { return MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_PACKAGE_INFO", function() { return MODAL_PACKAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_SELECT_SHOP_CATEGORY", function() { return MODAL_SELECT_SHOP_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_modal__ = __webpack_require__("rItL");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
This file contains shortcuts for different kinds of modals
 */



var MODAL_LOGIN = {
	/**
  * @param {Function} onClose Callback accepts one parameter of type {object} - dialog's result
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('login', null, { onClose: onClose });
	}
};

var MODAL_ASK_REDIRECT = {
	/**
  * @param {object} data
  * @return {ZDialog}
  */
	show: function show() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('ask_redirect', data, {
			modal: true
		});
	}
};

var MODAL_CRITICAL_NEWS = {
	/**
  * @param {number} id News ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('critical_news', { id: id }, {
			modal: true,
			onClose: onClose
		});
	}
};

var MODAL_REVIEW = {
	/**
  * @param {number} id
  * @param {number} index
  * @param {*} filter
  * @return {ZDialog}
  */
	show: function show(id) {
		var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review', { id: id, index: index, filter: filter }, { fullscreen: true });
	}
};

var MODAL_REVIEW_EDIT = {
	/**
  * @param {number} id
  * @param {number} packageId
  * @param {Object} initialValues
 * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id) {
		var packageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		var data = _extends({
			id: id,
			package_id: packageId
		}, initialValues);

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_edit', data, { onClose: onClose });
	}
};

var MODAL_QUESTION_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('question_edit', { id: id }, { onClose: onClose });
	}
};

var MODAL_REVIEW_COMMENT_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_comment_edit', { id: id }, { width: 650, onClose: onClose });
	}
};

var MODAL_CREATE_COMPUTER_ORDER = {
	/**
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('create_computer_order', {}, { width: 780, onClose: onClose });
	}
};

var MODAL_FILIALIST_ORDER_PAGE = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_order_page', { id: id }, { type: 'window', onClose: onClose });
	}
};

var MODAL_FILIALIST_EXCLUDE_FROM_PARCEL = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_exclude_from_parcel', { id: id }, { width: 470, onClose: onClose });
	}
};

var MODAL_FILIALIST_FREE_ORDERS_EDIT = {
	/**
  * @param {number} customerId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(customerId) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_free_orders_edit', { customer_id: customerId }, { width: 1300, onClose: onClose });
	}
};

var MODAL_FILIALIST_CREATE_TODO = {
	/**
  * @param {number} id
  * @param {string} type
  * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id, type) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_create_todo', { id: id, type: type }, { width: 600, onClose: onClose });
	}
};

var MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_reassign_packages_to_customers', { ids: ids }, { width: 1800, onClose: onClose });
	}
};

var MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_change_assignment_customer', null, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_EDIT_ASSIGNMENT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_edit_assignment', { id: id }, { width: 500, onClose: onClose });
	}
};

var MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA = {
	/**
  * @param {string} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_get_assignment_meest_data', { id: id }, { width: 450, onClose: onClose });
	}
};

var MODAL_FILIALIST_BATCH_PAYMENT = {
	/**
  * @param {array} ids
 * $param {string} account
  * @param {number} rate
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids, account, rate) {
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_batch_payment', { ids: ids, account: account, rate: rate }, { width: 400, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_PACKAGE_KINDS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_package_kinds', { ids: ids }, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES = {
	/**
  * @param {string[]} cities
  * @param {Object[]} streets
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(cities, streets) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		var data = encodeURIComponent(JSON.stringify({ cities: cities, streets: streets }));
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_meest_address_aliases', { data: data }, { onClose: onClose });
	}
};

var MODAL_ADMIN_REPLENISH_BALANCE = {
	/**
  * @param {number} pendingReplenihmentId
  * @param {number} boundBankTransactionId
  * @param {number} suggestionBondId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(pendingReplenihmentId) {
		var boundBankTransactionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var suggestionBondId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_replenish_balance', {
			pending_replenihment_id: pendingReplenihmentId,
			bound_bank_transaction_id: boundBankTransactionId,
			suggestion_bond_id: suggestionBondId
		}, { onClose: onClose });
	}
};

var MODAL_ADMIN_BATCH_PAYMENT = {
	/**
  * @param {string} accountSource
  * @param {string} accountTarget
  * @param {number} amount
  * @param {number} rate
  * @param {number[]} groupIds
  * @param {number[]} boundBankTransactionIds
  * @param {number} suggestionBondId
  * @param {Function} onClose
  */
	show: function show(accountSource, accountTarget, amount, rate, groupIds, boundBankTransactionIds) {
		var suggestionBondId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
		var onClose = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_batch_payment', {
			account_source: accountSource,
			account_target: accountTarget,
			amount: amount,
			rate: rate,
			group_ids: groupIds,
			bound_bank_transaction_ids: boundBankTransactionIds,
			suggestion_bond_id: suggestionBondId
		}, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_IMPORT_BANK_STATEMENT = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_import_bank_statement', {}, { width: 800, onClose: onClose });
	}
};

var MODAL_ADMIN_VALIDATE_INVOICE_CSV = {
	/**
  * @param {string | null} name
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_validate_invoice_csv', { name: name }, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS = {
	/**
  * @returns {ZDialog}
  */
	show: function show() {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_shop_bank_statement_keywords', {}, { width: 1200 });
	}
};

var MODAL_PACKAGE_INFO = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('package_info', { id: id }, { onClose: onClose });
	}
};

var MODAL_SELECT_SHOP_CATEGORY = {
	show: function show(onClose) {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('select_shop_category', {}, { width: 550, onClose: onClose });
	}
};

/***/ }),

/***/ "YnTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkIsIframe;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["d"] = isTouchScreen;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEBP_FEATURES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isWebpFeatureSupported;
/**
 * @return {boolean} TRUE if current window is an iframe window
 */
function checkIsIframe() {
	return window !== window.top;
}

var _isMobile = 'orientation' in window || navigator.userAgent.indexOf('IEMobile') !== -1;
var _isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;

function isMobile() {
	return _isMobile;
}

function isTouchScreen() {
	return _isTouchScreen;
}

var WEBP_FEATURES = {
	LOSSY: 'lossy',
	LOSSLESS: 'lossless',
	ALPHA: 'alpha',
	ANIMATION: 'animation'
};

function isWebpFeatureSupported(feature) {
	return new Promise(function (resolve, reject) {
		if (!Object.values(WEBP_FEATURES).includes(feature)) {
			reject('Invalid feature name');
			return;
		}

		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function () {
			var result = img.width > 0 && img.height > 0;
			resolve(result);
		};
		img.onerror = function () {
			resolve(false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	});
}

/*export class MobileDetect {
	static Android = navigator.userAgent.match(/Android/i);
	static BlackBerry = navigator.userAgent.match(/BlackBerry/i);
	static iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	static Opera = navigator.userAgent.match(/Opera Mini/i);
	static Windows = navigator.userAgent.match(/IEMobile/i);
	static Any = MobileDetect.Android || MobileDetect.BlackBerry || MobileDetect.iOS || MobileDetect.Opera || MobileDetect.Windows;
}*/

/***/ }),

/***/ "ZuML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_less__ = __webpack_require__("Q4Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__popup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialog__ = __webpack_require__("fokk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * The same as {@link openHtmlDialog()} but with name='popup' enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openPopup(content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return Object(__WEBPACK_IMPORTED_MODULE_1__dialog__["openHtmlDialog"])(content, _extends({ name: 'popup' }, options));
}

/***/ }),

/***/ "cMPG":
/***/ (function(module, exports) {

module.exports = "<div class=\"order-sizes\">\n\t{{tmpl(variants) 'co-variant-item'}}\n</div>\n<div class=\"status\"></div>\n"

/***/ }),

/***/ "d7nS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slick_carousel__ = __webpack_require__("vqpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel_slick_slick_less__ = __webpack_require__("GZT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel_slick_slick_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slick_carousel_slick_slick_less__);



/***/ }),

/***/ "dM69":
/***/ (function(module, exports) {

module.exports = "<div class=\"order-sizes\">\n\t{{tmpl(sizes) 'co-size-item'}}\n</div>\n<div class=\"status\"></div>"

/***/ }),

/***/ "dTkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isset */
/* harmony export (immutable) */ __webpack_exports__["e"] = element;
/* unused harmony export elementOrDefault */
/* harmony export (immutable) */ __webpack_exports__["f"] = elementOrDash;
/* harmony export (immutable) */ __webpack_exports__["g"] = orDefault;
/* harmony export (immutable) */ __webpack_exports__["c"] = asNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = asBoolean;
/* harmony export (immutable) */ __webpack_exports__["d"] = asString;
/* harmony export (immutable) */ __webpack_exports__["h"] = trim;
/* harmony export (immutable) */ __webpack_exports__["a"] = asArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);


/**
 * Is a given variable defined and has value?
 * @param {*} val
 * @return {boolean} <code>false</code> if given value is <code>undefined</code> or <code>null</code>, otherwise <code>true</code>
 */
function isset(val) {
  return !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(val) && !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isNull(val);
}

/**
 * Returns object's property or array's index if exists and default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function element(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDefault(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) && object[key] !== null ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or "&mdash;" value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDash(object, key) {
  return elementOrDefault(object, key, '&mdash;');
}

/**
 * Returns value if it's not <code>undefined</code> or <code>null</code>, otherwise defaultValue
 * @param {*} value
 * @param {*} defaultValue
 * @return {*}
 */
function orDefault(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return isset(value) ? value : defaultValue;
}

/**
 * Converts given value to number using standard javascript converter: <code>+value</code>
 * @param {*} value Input value
 * @param {number} defaultValue
 * @return {number} Either converted value if it's not <code>NaN</code> and default value otherwise
 */
function asNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = +value;
  return !isNaN(value) ? value : 0;
}

/**
 * Converts given value to boolean using such algo:
 * - string <code>"0"</code> results in <code>false</code>;
 * - string <code>"false"</code> results in <code>false</code>;
 * - string <code>"null"</code> results in <code>false</code>;
 * - empty object results in <code>false</code>;
 * - empty array results in <code>false</code>;
 * - other values go through standard javascript converter: <code>!!value</code>
 * @param {*} value Input value
 * @return {boolean} Converted value
 */
function asBoolean(value) {
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isBoolean(value)) return value;
  if (value === '0') return false;
  if (value === 'false') return false;
  if (value === 'null') return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  return !!value;
}

/**
 * Converts given value to string using standard javascript converter: <code>''+value</code>
 * except that <code>null</code> and <code>undefined</code> values will be converted to empty string.
 * @param {*} value Input value
 * @return {string} Converted value
 */
function asString(value) {
  if (value === null || __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(value)) return '';
  return '' + value;
}

/**
 * Converts given value to string using {@link asString()} and trims whitespace characters.
 * @param {string|*} value
 * @return {string} Converted and trimmed value
 */
function trim(value) {
  return asString(value).trim();
}

/**
 * If input value is an array - it will be returned as is.
 * In other cases input value will be converted to string and either split with given delimiter
 * or just returned as a single array element.
 * @param {array|string} value
 * @param {string} delimiter
 * @return {array}
 */
function asArray(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!value) return [];
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value)) return value;
  value = asString(value);
  return delimiter ? value.split(delimiter) : [value];
}

/***/ }),

/***/ "f5X1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_model_products__ = __webpack_require__("1zZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_model_settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_model_lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_model_reviews__ = __webpack_require__("50IF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_data__ = __webpack_require__("m9tG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_utils_lang__ = __webpack_require__("RaK1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_model_debuginfo__ = __webpack_require__("EfVR");
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }














var logger = __WEBPACK_IMPORTED_MODULE_6__core_utils_logger__["a" /* newLogger */]('Quicksearch');

/** @type {QuickSearchViewModel} */
var model = void 0;

// use local debugInfo instance to avoid overriding existing one
// if this code is executing on shop catalog page
var debugInfo = new __WEBPACK_IMPORTED_MODULE_11__common_model_debuginfo__["a" /* DebugInfo */]();

/**
 *
 * @param {object} options
 * @return {QuickSearchViewModel}
 */
function init(options) {
	logger.log('init', options);
	model = new QuickSearchViewModel();
	model.init(options);
	return model;
}

var QuickSearchViewModel = function () {

	/**
  * @type {Settings}
  */
	function QuickSearchViewModel() {
		var _this = this;

		_classCallCheck(this, QuickSearchViewModel);

		this.criteria = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this.hasFocus = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.isResultsVisible = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.settings = null;
		this.results = null;
		this._xhr = null;
		this._debugInfoSearchCriteria = null;

		this._criteriaTrimmed = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return (_this.criteria() || '').trim();
		});
		this._filterRequest = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(this._criteriaTrimmed).extend({ rateLimit: { timeout: 300, method: "notifyWhenChangesStop" } });
		this.settings = __WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */];
		this.results = new Results(__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */]);

		this.results.onShowAll(function () {
			_this.handleSubmit();
		});
		this.results.onCategoryItemClick( /** @type {CategoryResultItem} */function (item) {
			location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].shopUrl, item.uri, { search: _this._criteriaTrimmed() });
		});
		this.results.onKeywordItemClick( /** @type {KeywordItem} */function (item) {
			if (item.type != 'keyword') {
				location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].shopUrl, _defineProperty({}, item.type, item.id));
			} else {
				location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].shopUrl, { search: item.title });
			}
		});
		this.results.onReviewsShowAllClick(function () {
			location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */]('reviews', { search: _this._criteriaTrimmed() });
		});

		this.handleSubmit = this.handleSubmit.bind(this);
	}
	/**
  * @type {Results}
  */


	_createClass(QuickSearchViewModel, [{
		key: 'init',
		value: function init(options) {
			var _this2 = this;

			var o = _extends({
				criteria: null
			}, options);

			this.criteria(o.criteria);

			this._filterRequest.subscribe(function (criteria) {
				_this2._doQuery(criteria);
			});
			this._criteriaTrimmed.subscribe(function (query) {
				_this2._toggleResults(!!query, true);
			});
			this.hasFocus.subscribe(function (hasFocus) {
				if (hasFocus && _this2.hasCriteria) {
					_this2._toggleResults(true);
					if (!_this2.results.isInitialized()) {
						_this2._doQuery();
					}
				}
			});

			//test
			// this.hasFocus(true);
		}
	}, {
		key: '_toggleResults',
		value: function _toggleResults(show) {
			var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (reset) {
				this.results.reset();
			}
			this.isResultsVisible(show);
		}
	}, {
		key: 'closeResults',
		value: function closeResults() {
			this._toggleResults(false);
		}
	}, {
		key: '_doQuery',
		value: function _doQuery() {
			var _this3 = this;

			var criteria = '' + this._criteriaTrimmed();
			logger.log("Do search", criteria);

			if (this._xhr) {
				this._xhr.abort();
			}

			if (!criteria || criteria.length < 3) {
				return;
			}

			this._xhr = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].searchApiUrl, { criteria: criteria }, function (response) {
				logger.log("new data", response);
				debugInfo.setSearchCriteria(criteria);
				_this3.results.init(response ? response : { error: true });
			}, 'json').fail(function (xhr, status) {
				if (status != 'abort') {
					_this3.results.init({ error: true });
				}
			}).always(function () {
				_this3._xhr = null;
			});

			if (window.fbq) {
				fbq('track', 'Search', {
					search_string: criteria
				});
			}
		}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit() {
			location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].shopUrl, { search: this._criteriaTrimmed() });
		}
	}, {
		key: 'reset',
		value: function reset() {
			location.href = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].shopUrl);
		}
	}, {
		key: 'hasCriteria',
		get: function get() {
			return !!this._criteriaTrimmed();
		}
	}, {
		key: 'isActive',
		get: function get() {
			return this.hasFocus() || this.isResultsVisible();
		}
	}]);

	return QuickSearchViewModel;
}();

var Results = function () {
	/** @type {ReviewResults} */
	function Results(settings) {
		var _this4 = this;

		_classCallCheck(this, Results);

		this.products = null;
		this.categories = new CategoryResults();
		this.keywords = new KeywordResults();
		this.reviews = null;
		this.isInitialized = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.isEmpty = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this4.products.empty && _this4.reviews.empty;
		});
		this.isNotEmpty = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return !_this4.isEmpty();
		});
		this.error = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		this.isLoading = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return !_this4.isInitialized();
		});
		this.isResultsVisible = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this4.isInitialized() && _this4.isNotEmpty();
		});
		this._onShowAll = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		this.products = new ProductResults(settings);
		this.reviews = new ReviewResults(settings);
	}
	/** @type {ProductResults} */


	_createClass(Results, [{
		key: 'init',
		value: function init(data) {
			this.error(data.error);
			if (!data.error) {
				this.products.init({
					items: data.products || [],
					scores: data.productsScores,
					total: data.productsTotalCount
				});
				this.categories.init(data.productCategories || []);
				this.keywords.init(data);
				this.reviews.init({
					items: data.reviews || [],
					scores: data.reviewsScores,
					total: data.reviewsTotalCount
				});
			}
			this.isInitialized(true);
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.isInitialized(false);
		}
	}, {
		key: 'onCategoryItemClick',
		value: function onCategoryItemClick(callback) {
			this.categories.onItemClick(callback);
		}
	}, {
		key: 'onReviewsShowAllClick',
		value: function onReviewsShowAllClick(callback) {
			this.reviews.onShowAll(callback);
		}
	}, {
		key: 'onKeywordItemClick',
		value: function onKeywordItemClick(callback) {
			this.keywords.onItemClick(callback);
		}
	}, {
		key: 'onShowAll',
		value: function onShowAll(callback) {
			this._onShowAll.add(callback);
		}
	}, {
		key: 'handleShowAllClick',
		value: function handleShowAllClick() {
			this._onShowAll.fire();
		}
	}]);

	return Results;
}();

var CategoryResults = function (_BaseList) {
	_inherits(CategoryResults, _BaseList);

	function CategoryResults() {
		_classCallCheck(this, CategoryResults);

		return _possibleConstructorReturn(this, (CategoryResults.__proto__ || Object.getPrototypeOf(CategoryResults)).apply(this, arguments));
	}

	_createClass(CategoryResults, [{
		key: 'newItem',
		value: function newItem(itemData) {
			return new CategoryResultItem(itemData);
		}
	}]);

	return CategoryResults;
}(__WEBPACK_IMPORTED_MODULE_7__common_model_lists__["a" /* BaseList */]);

var CategoryResultItem = function () {
	function CategoryResultItem(data) {
		_classCallCheck(this, CategoryResultItem);

		this._data = data;
		if (data['subcategory_name']) {
			this._uri = __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](data['category_name'], data['subcategory_name']);
		} else {
			this._uri = data['category_name'];
		}
	}

	_createClass(CategoryResultItem, [{
		key: 'categoryTitle',
		get: function get() {
			return this._data['category_title'];
		}
	}, {
		key: 'subcategoryTitle',
		get: function get() {
			return this._data['subcategory_title'];
		}
	}, {
		key: 'count',
		get: function get() {
			return this._data['count'];
		}
	}, {
		key: 'uri',
		get: function get() {
			return this._uri;
		}
	}]);

	return CategoryResultItem;
}();

var KeywordResults = function (_BaseList2) {
	_inherits(KeywordResults, _BaseList2);

	function KeywordResults() {
		_classCallCheck(this, KeywordResults);

		return _possibleConstructorReturn(this, (KeywordResults.__proto__ || Object.getPrototypeOf(KeywordResults)).apply(this, arguments));
	}

	_createClass(KeywordResults, [{
		key: 'init',
		value: function init(data) {
			var items = [];

			if (data.shops && data.shops.length > 0) {
				var item = data.shops[0];
				items.push(_extends({}, item, {
					type: 'shop'
				}));
			}
			if (data.brands && data.brands.length > 0) {
				var _item = data.brands[0];
				items.push(_extends({}, _item, {
					type: 'brand'
				}));
			}
			if (data.keywords) {
				__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.each(data.keywords, function (item) {
					items.push(_extends({}, item, {
						type: 'keyword'
					}));
				});
			}

			return _get(KeywordResults.prototype.__proto__ || Object.getPrototypeOf(KeywordResults.prototype), 'init', this).call(this, items);
		}
	}, {
		key: 'newItem',
		value: function newItem(itemData) {
			return new KeywordItem(itemData);
		}
	}]);

	return KeywordResults;
}(__WEBPACK_IMPORTED_MODULE_7__common_model_lists__["a" /* BaseList */]);

var KeywordItem = function () {
	function KeywordItem(data) {
		_classCallCheck(this, KeywordItem);

		this._data = data;
	}

	_createClass(KeywordItem, [{
		key: 'id',
		get: function get() {
			return this._data['id'];
		}
	}, {
		key: 'title',
		get: function get() {
			return this._data['title'];
		}
	}, {
		key: 'type',
		get: function get() {
			return this._data['type'];
		}
	}, {
		key: 'typeName',
		get: function get() {
			switch (this.type) {
				case 'shop':
					return Object(__WEBPACK_IMPORTED_MODULE_10__core_utils_lang__["a" /* lang */])('shop_filter_shop');
				case 'brand':
					return Object(__WEBPACK_IMPORTED_MODULE_10__core_utils_lang__["a" /* lang */])('shop_filter_brand');
				default:
					return null;
			}
		}
	}]);

	return KeywordItem;
}();

var ProductResults = function (_ProductList) {
	_inherits(ProductResults, _ProductList);

	function ProductResults() {
		_classCallCheck(this, ProductResults);

		return _possibleConstructorReturn(this, (ProductResults.__proto__ || Object.getPrototypeOf(ProductResults)).apply(this, arguments));
	}

	_createClass(ProductResults, [{
		key: 'newItem',
		value: function newItem(itemData) {
			return new ProductResultItem(itemData, this.settings);
		}
	}]);

	return ProductResults;
}(__WEBPACK_IMPORTED_MODULE_4__common_model_products__["b" /* ProductList */]);

var ProductResultItem = function (_ProductItem) {
	_inherits(ProductResultItem, _ProductItem);

	function ProductResultItem() {
		_classCallCheck(this, ProductResultItem);

		return _possibleConstructorReturn(this, (ProductResultItem.__proto__ || Object.getPrototypeOf(ProductResultItem)).apply(this, arguments));
	}

	_createClass(ProductResultItem, [{
		key: 'showDebugInfo',
		value: function showDebugInfo() {
			if (__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].debug && this.score) {
				debugInfo.show('product', this.id);
			}
		}
	}]);

	return ProductResultItem;
}(__WEBPACK_IMPORTED_MODULE_4__common_model_products__["a" /* ProductItem */]);

var ReviewResults = function (_ReviewList) {
	_inherits(ReviewResults, _ReviewList);

	function ReviewResults() {
		var _ref;

		var _temp, _this9, _ret;

		_classCallCheck(this, ReviewResults);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this9 = _possibleConstructorReturn(this, (_ref = ReviewResults.__proto__ || Object.getPrototypeOf(ReviewResults)).call.apply(_ref, [this].concat(args))), _this9), _this9._onShowAll = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks(), _temp), _possibleConstructorReturn(_this9, _ret);
	}

	_createClass(ReviewResults, [{
		key: 'onShowAll',
		value: function onShowAll(callback) {
			this._onShowAll.add(callback);
		}
	}, {
		key: 'showAll',
		value: function showAll() {
			this._onShowAll.fire();
		}
	}, {
		key: 'newItem',
		value: function newItem(itemData) {
			return new ReviewResultItem(itemData, this.settings);
		}
	}]);

	return ReviewResults;
}(__WEBPACK_IMPORTED_MODULE_8__common_model_reviews__["b" /* ReviewList */]);

var ReviewResultItem = function (_ReviewItem) {
	_inherits(ReviewResultItem, _ReviewItem);

	function ReviewResultItem() {
		_classCallCheck(this, ReviewResultItem);

		return _possibleConstructorReturn(this, (ReviewResultItem.__proto__ || Object.getPrototypeOf(ReviewResultItem)).apply(this, arguments));
	}

	_createClass(ReviewResultItem, [{
		key: 'showDebugInfo',
		value: function showDebugInfo() {
			if (__WEBPACK_IMPORTED_MODULE_9__common_data__["b" /* settings */].debug && this.score) {
				debugInfo.show('review', this.id);
			}
		}
	}]);

	return ReviewResultItem;
}(__WEBPACK_IMPORTED_MODULE_8__common_model_reviews__["a" /* ReviewItem */]);

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('qs-results', {
	template: __webpack_require__("igeC")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('qs-products', {
	template: __webpack_require__("oJe9")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('qs-categories', {
	template: __webpack_require__("l1+7")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('qs-keywords', {
	template: __webpack_require__("xlbI")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('qs-reviews', {
	template: __webpack_require__("r4Qy")
});

/***/ }),

/***/ "foaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reloadNpOffices;
function reloadNpOffices($select, city, company) {
    var valueOrCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var officeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    if ($select.length) {
        $select.prop('disabled', true);
        $select.children().remove();

        $.get('delivery/getNPCityOfficesAjax', { city: city, company: company, type: officeType }, null, 'json').done(function (response) {
            if (response.success) {
                $.each(response.data, function (value, text) {
                    var $new = $('<option>', { value: value, text: text });
                    $select.append($new);
                });
                $select.prop('disabled', false);
                if (valueOrCallback) {
                    if ($.isFunction(valueOrCallback)) {
                        valueOrCallback();
                    } else {
                        $select.val(valueOrCallback);
                        $select.trigger('change').trigger('chosen:updated');
                    }
                } else {
                    var $first = $($select.children()[0]);
                    $first.attr('selected', 'selected');
                    $select.trigger('change').trigger('chosen:updated');
                }
            }
        });
    }
}

/***/ }),

/***/ "fokk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createIframeDialog"] = createIframeDialog;
/* harmony export (immutable) */ __webpack_exports__["createHtmlDialog"] = createHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["openHtmlDialog"] = openHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["createWindowDialog"] = createWindowDialog;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dialogManager", function() { return dialogManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less__ = __webpack_require__("vBks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_var__ = __webpack_require__("dTkA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var logger = Object(__WEBPACK_IMPORTED_MODULE_3__utils_logger__["a" /* newLogger */])('ZDialog');

/**
 * Creates new dialog with IFrame with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createIframeDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'iframe', __width: 800 }, options));
}

/**
 * Creates new dialog instance.
 * autoOpen option is false by default, so you should either call open() method
 * or override autoOpen option
 * @param {*} content HTML content. Can be either valid HTML string, or DOM node, or jQuery object
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog} Dialog instance
 */
function createHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: content, type: 'html', showCloseButton: true }, options));
}

/**
 * The same as {@link createHtmlDialog()} but with autoOpen enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return createHtmlDialog(content, _extends({ autoOpen: true }, options));
}

/**
 * Creates new dialog as new window with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createWindowDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'window' }, options));
}

// add some helper functions to jQuery
$.extend($.fn, {
	/**
  * Calls {@link openHtmlDialog()} with source element as content
  * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
  */
	zdialog: function zdialog() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		var $el = $(this);
		var $placeholder = $('<div style="display: none !important;"></div>').insertAfter($el);
		var isInDom = $el.closest(document.documentElement);
		var isVisible = $el.css('display') != 'none';
		if (isInDom) {
			$el.detach();
		}
		if (!isVisible) {
			$el.show();
		}
		var dialog = createHtmlDialog($el, options);
		dialog.onBeforeClose(function () {
			$el.detach();
		});
		dialog.onClose(function () {
			if (isInDom) {
				$el.insertAfter($placeholder);
			}
			if (!isVisible) {
				$el.hide();
			}
			$placeholder.remove();
		});
		dialog.open();
		$el.data('zdialogInstance', dialog);
		return this;
	},

	/**
  * Returns ZDialog instance for given element (if the dialog was created with {@link jQuery.fn.zdialog} function)
  * @return {ZDialog}
  */
	zdialogInstance: function zdialogInstance() {
		return this.data('zdialogInstance');
	}
});

// FOR TESTING
/*import {MODAL_ASK_REDIRECT, MODAL_CRITICAL_NEWS, MODAL_LOGIN, MODAL_PACKAGE_INFO, MODAL_REVIEW} from "../modals";
$('.logo').click(function(e) {
	e.preventDefault();
	const queue = [];
	const showNext = () => {
		if (queue.length > 0) {
			queue.shift()();
		}
	};
	const onOpen = () => {};
	// queue.push(() => MODAL_REVIEW.show(104625).onOpen(showNext));
	// queue.push(() => MODAL_LOGIN.show().onOpen(showNext));
	// queue.push(() => MODAL_PACKAGE_INFO.show(1803110691).onOpen(showNext));
	// queue.push(() => MODAL_ASK_REDIRECT.show().onOpen(showNext));
	// queue.push(() => MODAL_CRITICAL_NEWS.show(312).onOpen(showNext));
	queue.push(() => openHtmlDialog('<div rel="show-next" style="width: 400px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 1000px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 1500px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 400px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 2500px; height: 2500px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	showNext();

	$(document).on('click', '.zdialog-html > div', showNext);
});*/

/**
 * @param {object} options
 * @return {ZDialog}
 */
var newDialog = function newDialog(options) {
	return new ZDialog(options);
};

// force use newDialog function from top window
var key = '__zdialog_newDialog';
if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* checkIsIframe */])()) {
	newDialog = window.top[key];
} else {
	window.top[key] = newDialog;
}

/**
 * Dialog class
 */

var ZDialog = function () {
	/** @type {JQuery.Callbacks} */

	/** @type {JQuery.Callbacks} */

	/** @type {HeightWatcher} */
	function ZDialog(options) {
		_classCallCheck(this, ZDialog);

		this._width = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._height = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._isModal = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isCloseBtnVisible = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isOpened = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isClosed = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isHidden = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._contentHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._iframeHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._opened = false;
		this._onOpen = $.Callbacks();
		this._onClose = $.Callbacks();
		this._onBeforeClose = $.Callbacks();
		this._result = null;

		var o = _extends({}, ZDialog.defaults, options);

		this._name = o.name;
		this._o = o;
		this._isModal(!!o.modal);
		this._isCloseBtnVisible(!!o.showCloseButton);
		this._width(o.width);
		this._height(o.height);

		if (o.onOpen) {
			this._onOpen.add(o.onOpen);
		}
		if (o.onClose) {
			this._onClose.add(o.onClose);
		}

		if (o.autoOpen) {
			this.open();
		}
	}
	/** @type {JQuery.Callbacks} */


	// options


	_createClass(ZDialog, [{
		key: "open",
		value: function open() {
			var _this = this;

			if (this.isOpened) {
				return;
			}
			this._isClosed(false);
			this._isHidden(false);
			this._result = null;
			if (this.type === 'window') {
				this._wnd = window.open(this.content);
				this._wnd.addEventListener('DOMContentLoaded', function () {
					return _this._handleWindowReady();
				});
				this._wnd.onbeforeunload = function () {
					if (!_this.isClosed) {
						_this.close();
					}
				};
				this._isLoading(true);
			} else if (!dialogManager.isRegistered(this)) {
				if (this.isFullScreen) {
					this._width('');
					this._height('');
					this._contentHeight('');
					this._iframeHeight('');
				}
				if (this.type === 'iframe') {
					this._isLoading(true);
					if (!this.isAutoHeight) {
						this._contentHeight(this.height);
						this._iframeHeight(this.height);
					} else {
						this._contentHeight('');
					}
				} else {
					this._contentHeight(this.height);
					this._isOpened(true);
					setTimeout(function () {
						return _this._onOpen.fireWith(_this);
					}, 0);
				}
				dialogManager.register(this);
			} else if (this._isHidden()) {
				dialogManager.show(this);
			}
		}
	}, {
		key: "close",
		value: function close() {
			var _this2 = this;

			if (this.isClosed) {
				return;
			}
			this._onBeforeClose.fireWith(this, [this._result]);
			this._isOpened(false);
			this._isHidden(false);
			this._isClosed(true);
			if (this.type === 'window') {
				if (this._wnd) {
					this._wnd.close();
					window.top.focus();
					this._wnd = null;
					setTimeout(function () {
						return _this2._onClose.fireWith(_this2, [_this2._result]);
					}, 0);
				}
			} else if (dialogManager.isRegistered(this)) {
				if (this._heightWatcher) {
					this._heightWatcher.off();
				}
				dialogManager.unregister(this);
				setTimeout(function () {
					return _this2._onClose.fireWith(_this2, [_this2._result]);
				}, 0);
			}
		}
	}, {
		key: "hide",
		value: function hide() {
			if (this.type === 'window') {
				logger.error('Method is not supported for current dialog type');
			} else if (dialogManager.isRegistered(this)) {
				this._isOpened(false);
				this._isHidden(true);
				dialogManager.hide(this);
			}
		}
	}, {
		key: "closeWithResult",
		value: function closeWithResult(result) {
			this.result = result;
			this.close();
		}
	}, {
		key: "updatePosition",
		value: function updatePosition() {
			if (this.type === 'iframe') {
				this._contentHeight(this.iframeHeight);
			}
		}

		/** @return {string} */

	}, {
		key: "handleIframeLoad",
		value: function handleIframeLoad(item, e) {
			var _this3 = this;

			logger.log('loaded', e);
			this._isLoading(false);

			if (!this.isFullScreen && this.isAutoHeight) {
				this._heightWatcher = new HeightWatcher(e.target, function (newHeight) {
					logger.log("new height = " + newHeight);
					_this3._iframeHeight(newHeight);
					if (!_this3.contentHeight) {
						_this3._contentHeight(newHeight);
					}
					_this3._isOpened(true);
					setTimeout(function () {
						return _this3._onOpen.fireWith(_this3);
					}, 0);
				});
			} else {
				this._isOpened(true);
				setTimeout(function () {
					return _this3._onOpen.fireWith(_this3);
				}, 0);
			}

			// inject this instance to iframe
			e.target.contentWindow.dialogInstance = this;

			// apply special classes
			$(e.target.contentWindow.document.body).toggleClass('zdialog-layout-modal', this.isModal).toggleClass('zdialog-layout-autoheight', this.isAutoHeight).toggleClass('zdialog-layout-fullscreen', this.isFullScreen);

			// triger event inside iframe
			e.target.contentWindow.$(e.target.contentWindow.document).trigger('zdialog-shown');
		}
	}, {
		key: "_handleWindowReady",
		value: function _handleWindowReady(e) {
			var _this4 = this;

			logger.log('loaded', e);
			this._isLoading(false);
			this._isOpened(true);

			// inject this instance to iframe
			this._wnd.dialogInstance = this;
			$(this._wnd.document.body).addClass('zdialog-layout-window');

			setTimeout(function () {
				return _this4._onOpen.fireWith(_this4);
			}, 0);
		}
	}, {
		key: "handleCloseClick",
		value: function handleCloseClick(item, e) {
			var $target = $(e.target);
			if ($target.is('[data-dialog-result]')) {
				this.result = $target.data('dialogResult');
			}
			this.close();
		}
	}, {
		key: "handleBackdropClick",
		value: function handleBackdropClick() {
			if (dialogManager.isTopmost(this) && !this.isModal) {
				this.close();
			}
		}
	}, {
		key: "onOpen",
		value: function onOpen(callback) {
			this._onOpen.add(callback);
		}
	}, {
		key: "offOpen",
		value: function offOpen(callback) {
			this._onOpen.remove(callback);
		}
	}, {
		key: "onClose",
		value: function onClose(callback) {
			this._onClose.add(callback);
		}
	}, {
		key: "offClose",
		value: function offClose(callback) {
			this._onClose.remove(callback);
		}
	}, {
		key: "onBeforeClose",
		value: function onBeforeClose(callback) {
			this._onBeforeClose.add(callback);
		}
	}, {
		key: "offBeforeClose",
		value: function offBeforeClose(callback) {
			this._onBeforeClose.remove(callback);
		}
	}, {
		key: "name",
		get: function get() {
			return this._name;
		}

		/** @return {string} */

	}, {
		key: "type",
		get: function get() {
			return this._o.type;
		}

		/** @return {string} */

	}, {
		key: "content",
		get: function get() {
			return this._o.content;
		}

		/** @return {string} */

	}, {
		key: "title",
		get: function get() {
			return this._o.title;
		}

		/** @return {number} */

	}, {
		key: "width",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "height",
		get: function get() {
			return this._height();
		}

		/** @return {number|string} */

	}, {
		key: "minWidth",
		get: function get() {
			return this._o.minWidth;
		}

		/** @return {number|string} */

	}, {
		key: "maxWidth",
		get: function get() {
			return this._o.maxWidth;
		}

		/** @return {number|string} */

	}, {
		key: "contentWidth",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "contentHeight",
		get: function get() {
			return this._contentHeight();
		}

		/** @return {number} */

	}, {
		key: "iframeHeight",
		get: function get() {
			return this._iframeHeight();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isOpened",
		get: function get() {
			return this._isOpened();
		}

		/** @return {boolean} */

	}, {
		key: "isClosed",
		get: function get() {
			return this._isClosed();
		}

		/** @return {boolean} */

	}, {
		key: "isHidden",
		get: function get() {
			return this._isHidden();
		}

		/** @return {boolean} */

	}, {
		key: "isModal",
		get: function get() {
			return this._isModal();
		}

		/** @return {boolean} */

	}, {
		key: "isCloseBtnVisible",
		get: function get() {
			return this._isCloseBtnVisible();
		}

		/** @type {boolean} */

	}, {
		key: "isFullScreen",
		get: function get() {
			return this._o.fullscreen;
		}

		/** @type {boolean} */

	}, {
		key: "isAutoHeight",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this.height) === '' || this.height === 'auto';
		}

		/** @return {*} */

	}, {
		key: "result",
		get: function get() {
			return this._result;
		}

		/**
   * @param {*} value
   */
		,
		set: function set(value) {
			this._result = value;
		}

		/**
   * @return {*}
   */

	}, {
		key: "customData",
		get: function get() {
			return this._o.custom;
		}

		/**
   * @return {string}
   */

	}, {
		key: "cssClass",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this._o.cssClass);
		}
	}]);

	return ZDialog;
}();

ZDialog.defaults = {
	name: '',
	type: 'iframe', // iframe, html
	content: '',
	title: '',
	buttons: [],
	modal: false,
	autoOpen: false,
	showCloseButton: false,

	width: '',
	height: '',
	fullscreen: false,
	cssClass: '',

	custom: null,

	//events
	onOpen: null,
	onClose: null
};

var DialogManager = function () {
	/** @type {KnockoutObservableArray<ZDialog>} */
	function DialogManager() {
		var _this5 = this;

		_classCallCheck(this, DialogManager);

		this._counter = 0;
		this._dialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observableArray([]);
		this._isClosing = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._initialized = false;
		this._wrapper = new WindowWrapper();

		this._$html = $('html');
		this._$body = $('body');

		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.any(_this5.dialogs, function (d) {
				return d.isLoading;
			});
		});

		this._visibleDialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return _this5.dialogs.filter(function (d) {
				return !d.isHidden;
			});
		});
	}

	/**
  * @param {ZDialog} dialog
  */


	_createClass(DialogManager, [{
		key: "register",
		value: function register(dialog) {
			if (this.isRegistered(dialog)) {
				return;
			}

			this._dialogs.push(dialog);
			this._checkMarkupAfterOpen();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "unregister",
		value: function unregister(dialog) {
			if (this._dialogs.remove(dialog).length === 0) {
				// nothing has been removed
				return;
			}
			this._checkMarkupAfterClose();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "hide",
		value: function hide(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterClose();
			}
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "show",
		value: function show(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterOpen();
			}
		}
	}, {
		key: "_checkMarkupAfterOpen",
		value: function _checkMarkupAfterOpen() {
			if (this._isClosing()) {
				clearTimeout(this._timeout);
				this._timeout = null;
				this._isClosing(false);
			} else if (this.visibleDialogs.length === 1 && !this._initialized) {
				this._wrapper.on();

				if (!this._$el) {
					this._$el = $("<div class=\"zdialog-wrapper\" data-bind=\"component: {name: 'zdialog-wrapper', params: $data}, \n\t\t\t\t\t\t\t\t\t\tcss: {'zdialog-loading': isLoading, 'zdialog-closing': isClosing}\"></div>");
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.applyBindings(this, this._$el[0]);
					this._$el.appendTo('body');
				} else {
					this._$el.show();
				}
				this._initialized = true;
			}
		}
	}, {
		key: "_checkMarkupAfterClose",
		value: function _checkMarkupAfterClose() {
			var _this6 = this;

			if (!this._isClosing() && this.visibleDialogs.length === 0 && this._initialized) {
				// no dialogs left
				this._isClosing(true);
				this._timeout = setTimeout(function () {
					_this6._wrapper.off();
					// logger.log('remove container');
					_this6._$el.remove();
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.cleanNode(_this6._$el[0]);
					_this6._$el = null;
					_this6._initialized = false;
					_this6._isClosing(false);
				}, 300);
			}
		}

		/**
   * @param {ZDialog} dialog
   * @return {boolean}
   */

	}, {
		key: "isRegistered",
		value: function isRegistered(dialog) {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.contains(this.dialogs, dialog);
		}
	}, {
		key: "handleBeforeRemove",
		value: function handleBeforeRemove(node) {
			var $node = $(node);
			$node.remove();
			/*if (node.nodeType === 3) {
   	$node.remove();
   	return;
   }
   $node.addClass('zdialog-closing');
   setTimeout(() => $node.remove(), 300);*/
		}

		/** @return {ZDialog[]} */

	}, {
		key: "getTopmostDialog",
		value: function getTopmostDialog() {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.last(this.visibleDialogs.filter(function (d) {
				return !d.isLoading;
			}));
		}
	}, {
		key: "isTopmost",
		value: function isTopmost(dialog) {
			return dialog === this.getTopmostDialog();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "getDialogClass",
		value: function getDialogClass(dialog) {
			var css = [];
			if (dialog.isModal) {
				css.push('zdialog-modal');
			}
			if (dialog.isFullScreen) {
				css.push('zdialog-fullscreen');
			}
			if (this.isTopmost(dialog)) {
				css.push('zdialog-topmost');
			} else if (this.visibleDialogs.length > 1) {
				css.push('zdialog-overlapped');
			}
			if (dialog.isLoading) {
				css.push('zdialog-loading');
			}
			if (dialog.isOpened) {
				css.push('zdialog-opened');
			}
			if (dialog.isHidden) {
				css.push('zdialog-hidden');
			}
			if (dialog.name) {
				css.push('zdialog-instance-' + dialog.name);
			}
			if (dialog.cssClass) {
				css.push(dialog.cssClass);
			}
			return css.join(' ');
		}
	}, {
		key: "dialogs",
		get: function get() {
			return this._dialogs();
		}

		/** @return {ZDialog[]} */

	}, {
		key: "visibleDialogs",
		get: function get() {
			return this._visibleDialogs();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isClosing",
		get: function get() {
			return this._isClosing();
		}
	}]);

	return DialogManager;
}();

var HeightWatcher = function () {
	function HeightWatcher($iframe, callback) {
		var _this7 = this;

		_classCallCheck(this, HeightWatcher);

		this._currHeight = 0;
		this._event = $.Callbacks();

		this._event.add(callback);
		this._ibody = $($iframe)[0].contentWindow.document.body;
		// this.updateHeight();
		setTimeout(function () {
			_this7.updateHeight();
			_this7._interval = setInterval(function () {
				return _this7.updateHeight();
			}, 50);
		}, 0);
	}

	_createClass(HeightWatcher, [{
		key: "updateHeight",
		value: function updateHeight() {
			// const newHeight = this._ibody.offsetHeight;
			var newHeight = this.getHeight();
			if (newHeight !== this._currHeight) {
				this._currHeight = newHeight;
				this._event.fire(newHeight);
			}
		}
	}, {
		key: "getHeight",
		value: function getHeight() {
			var height = this._ibody.scrollHeight;
			$(this._ibody).find('iframe:visible').filter(function () {
				return $(this).css('visibility') !== 'hidden';
			}).each(function () {
				var iHeight = $(this).height();
				if (iHeight > height) {
					height = iHeight;
				}
			});
			return height;
		}
	}, {
		key: "off",
		value: function off() {
			clearInterval(this._interval);
			this._event.empty();
		}
	}]);

	return HeightWatcher;
}();

var WindowWrapper = function () {
	function WindowWrapper() {
		_classCallCheck(this, WindowWrapper);

		this._$wnd = $(window);
		this._$html = $('html');
		this._$head = $('head');
		this._scrollTop = 0;
		this._scrollLeft = 0;

		this._$scrollBarStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		this._$positionStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		// this._useFixedLayout = /(iPod|iPhone|iPad)/.test(navigator.userAgent);
		this._useFixedLayout = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["c" /* isMobile */])(); ///(iPod|iPhone|iPad)/.test(navigator.userAgent);
	}

	_createClass(WindowWrapper, [{
		key: "on",
		value: function on() {
			if (this._useFixedLayout) {
				this._scrollTop = this._$wnd.scrollTop();
				this._scrollLeft = this._$wnd.scrollLeft();
				this._applyPositionStyle();
				this._$wnd.scrollTop(0).scrollLeft(0);
			}
			this._applyScrollbarStyle();

			this._$html.toggleClass('zdialog-scrollbar-fix', this._hasScrollBar()).toggleClass('zdialog-position-fix', this._useFixedLayout).addClass('zdialog-open');
		}
	}, {
		key: "off",
		value: function off() {
			this._$html.removeClass('zdialog-scrollbar-fix').removeClass('zdialog-position-fix').removeClass('zdialog-open');
			if (this._useFixedLayout) {
				this._$wnd.scrollTop(this._scrollTop).scrollLeft(this._scrollLeft);
			}
		}
	}, {
		key: "_applyScrollbarStyle",
		value: function _applyScrollbarStyle() {
			var scrollBarWidth = getScrollBarWidth();
			// language=CSS
			this._$scrollBarStyle.html("\n.zdialog-scrollbar-fix {\n\tpadding-right: " + scrollBarWidth + "px;\n}\n");
		}
	}, {
		key: "_applyPositionStyle",
		value: function _applyPositionStyle() {
			// language=CSS
			this._$positionStyle.html("\n.zdialog-position-fix {\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100%;\n\ttop: -" + this._scrollTop + "px;\n\tleft: -" + this._scrollLeft + "px;\n}\n");
		}
	}, {
		key: "_hasScrollBar",
		value: function _hasScrollBar() {
			return hasScrollBar(this._$html);
		}
	}]);

	return WindowWrapper;
}();

function getScrollBarWidth() {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
	    widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
	$outer.remove();
	return 100 - widthWithScroll;
}

function hasScrollBar(el) {
	var $el = $(el);
	return $el.length > 0 ? $el[0].scrollHeight > $(window).height() : false;
}

var dialogManager = new DialogManager();

__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-wrapper', {
	template: "\n<div class=\"zdialog-overlay\"></div>\n<div class=\"zdialog-loader\"></div>\n<div data-bind=\"foreach: {data: dialogs, beforeRemove: handleBeforeRemove}\">\n\t<div class=\"zdialog-container\">\n\t\t<div class=\"zdialog\" data-bind=\"component: {name: 'zdialog', params: $data}, height: contentHeight, \n\t\t\t\t\t\t\t\t\t\tcss: $parent.getDialogClass($data)\"></div>\n\t</div>\n</div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog', {
	template: "\n<div class=\"zdialog-backdrop\" data-bind=\"click: handleBackdropClick\"></div>\n<div class=\"zdialog-content\" data-bind=\"css: 'zdialog-content-' + type, \n\t\t\t\t\t\t\t\t\t\tcomponent: {name: 'zdialog-content-' + type, params: $data},\n\t\t\t\t\t\t\t\t\t\twidth: contentWidth\"></div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-iframe', {
	template: "\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<iframe class=\"zdialog-iframe\" frameborder=\"0\" vspace=\"0\" hspace=\"0\" scrolling=\"auto\"\n\t\tdata-bind=\"attr: {src: content}, event: {load: handleIframeLoad}, height: iframeHeight\"></iframe>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-html', {
	template: "\n<!-- ko if: title -->\n<h2 class=\"zdialog-title\">\n\t<span data-bind=\"html: title\"></span>\n\t<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n</h2>\n<!-- /ko -->\n<!-- ko ifnot: title -->\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<!-- /ko -->\n<div class=\"zdialog-html\" data-bind=\"html: content, on: {events: 'click', selector: '[rel=close-dialog]', handler: handleCloseClick}\"></div>\n".trim()
});

/***/ }),

/***/ "hexH":
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - v1.7.10
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * $("img.lazy").lazy();
 */

;(function(window, undefined) {
    "use strict";

    // noinspection JSUnresolvedVariable
    /**
     * library instance - here and not in construct to be shorter in minimization
     * @return void
     */
    var $ = window.jQuery || window.Zepto,

    /**
     * unique plugin instance id counter
     * @type {number}
     */
    lazyInstanceId = 0,

    /**
     * helper to register window load for jQuery 3
     * @type {boolean}
     */    
    windowLoaded = false;

    /**
     * make lazy available to jquery - and make it a bit more case-insensitive :)
     * @access public
     * @type {function}
     * @param {object} settings
     * @return {LazyPlugin}
     */
    $.fn.Lazy = $.fn.lazy = function(settings) {
        return new LazyPlugin(this, settings);
    };

    /**
     * helper to add plugins to lazy prototype configuration
     * @access public
     * @type {function}
     * @param {string|Array} names
     * @param {string|Array|function} [elements]
     * @param {function} loader
     * @return void
     */
    $.Lazy = $.lazy = function(names, elements, loader) {
        // make second parameter optional
        if ($.isFunction(elements)) {
            loader = elements;
            elements = [];
        }

        // exit here if parameter is not a callable function
        if (!$.isFunction(loader)) {
            return;
        }

        // make parameters an array of names to be sure
        names = $.isArray(names) ? names : [names];
        elements = $.isArray(elements) ? elements : [elements];

        var config = LazyPlugin.prototype.config,
            forced = config._f || (config._f = {});

        // add the loader plugin for every name
        for (var i = 0, l = names.length; i < l; i++) {
            if (config[names[i]] === undefined || $.isFunction(config[names[i]])) {
                config[names[i]] = loader;
            }
        }

        // add forced elements loader
        for (var c = 0, a = elements.length; c < a; c++) {
            forced[elements[c]] = names[0];
        }
    };

    /**
     * contains all logic and the whole element handling
     * is packed in a private function outside class to reduce memory usage, because it will not be created on every plugin instance
     * @access private
     * @type {function}
     * @param {LazyPlugin} instance
     * @param {object} config
     * @param {object|Array} items
     * @param {object} events
     * @param {string} namespace
     * @return void
     */
    function _executeLazy(instance, config, items, events, namespace) {
        /**
         * a helper to trigger the 'onFinishedAll' callback after all other events
         * @access private
         * @type {number}
         */
        var _awaitingAfterLoad = 0,

        /**
         * visible content width
         * @access private
         * @type {number}
         */
        _actualWidth = -1,

        /**
         * visible content height
         * @access private
         * @type {number}
         */
        _actualHeight = -1,

        /**
         * determine possibly detected high pixel density
         * @access private
         * @type {boolean}
         */
        _isRetinaDisplay = false, 

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _afterLoad = 'afterLoad',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _load = 'load',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _error = 'error',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _img = 'img',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _src = 'src',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _srcset = 'srcset',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _sizes = 'sizes',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _backgroundImage = 'background-image';

        /**
         * initialize plugin
         * bind loading to events or set delay time to load all items at once
         * @access private
         * @return void
         */
        function _initialize() {
            // detect actual device pixel ratio
            // noinspection JSUnresolvedVariable
            _isRetinaDisplay = window.devicePixelRatio > 1;

            // prepare all initial items
            items = _prepareItems(items);

            // if delay time is set load all items at once after delay time
            if (config.delay >= 0) {
                setTimeout(function() {
                    _lazyLoadItems(true);
                }, config.delay);
            }

            // if no delay is set or combine usage is active bind events
            if (config.delay < 0 || config.combined) {
                // create unique event function
                events.e = _throttle(config.throttle, function(event) {
                    // reset detected window size on resize event
                    if (event.type === 'resize') {
                        _actualWidth = _actualHeight = -1;
                    }

                    // execute 'lazy magic'
                    _lazyLoadItems(event.all);
                });

                // create function to add new items to instance
                events.a = function(additionalItems) {
                    additionalItems = _prepareItems(additionalItems);
                    items.push.apply(items, additionalItems);
                };

                // create function to get all instance items left
                events.g = function() {
                    // filter loaded items before return in case internal filter was not running until now
                    return (items = $(items).filter(function() {
                        return !$(this).data(config.loadedName);
                    }));
                };

                // create function to force loading elements
                events.f = function(forcedItems) {
                    for (var i = 0; i < forcedItems.length; i++) {
                        // only handle item if available in current instance
                        // use a compare function, because Zepto can't handle object parameter for filter
                        // var item = items.filter(forcedItems[i]);
                        /* jshint loopfunc: true */
                        var item = items.filter(function() {
                            return this === forcedItems[i];
                        });

                        if (item.length) {
                            _lazyLoadItems(false, item);   
                        }
                    }
                };

                // load initial items
                _lazyLoadItems();

                // bind lazy load functions to scroll and resize event
                // noinspection JSUnresolvedVariable
                $(config.appendScroll).on('scroll.' + namespace + ' resize.' + namespace, events.e);
            }
        }

        /**
         * prepare items before handle them
         * @access private
         * @param {Array|object|jQuery} items
         * @return {Array|object|jQuery}
         */
        function _prepareItems(items) {
            // fetch used configurations before loops
            var defaultImage = config.defaultImage,
                placeholder = config.placeholder,
                imageBase = config.imageBase,
                srcsetAttribute = config.srcsetAttribute,
                loaderAttribute = config.loaderAttribute,
                forcedTags = config._f || {};

            // filter items and only add those who not handled yet and got needed attributes available
            items = $(items).filter(function() {
                var element = $(this),
                    tag = _getElementTagName(this);

                return !element.data(config.handledName) && 
                       (element.attr(config.attribute) || element.attr(srcsetAttribute) || element.attr(loaderAttribute) || forcedTags[tag] !== undefined);
            })

            // append plugin instance to all elements
            .data('plugin_' + config.name, instance);

            for (var i = 0, l = items.length; i < l; i++) {
                var element = $(items[i]),
                    tag = _getElementTagName(items[i]),
                    elementImageBase = element.attr(config.imageBaseAttribute) || imageBase;

                // generate and update source set if an image base is set
                if (tag === _img && elementImageBase && element.attr(srcsetAttribute)) {
                    element.attr(srcsetAttribute, _getCorrectedSrcSet(element.attr(srcsetAttribute), elementImageBase));
                }

                // add loader to forced element types
                if (forcedTags[tag] !== undefined && !element.attr(loaderAttribute)) {
                    element.attr(loaderAttribute, forcedTags[tag]);
                }

                // set default image on every element without source
                if (tag === _img && defaultImage && !element.attr(_src)) {
                    element.attr(_src, defaultImage);
                }

                // set placeholder on every element without background image
                else if (tag !== _img && placeholder && (!element.css(_backgroundImage) || element.css(_backgroundImage) === 'none')) {
                    element.css(_backgroundImage, "url('" + placeholder + "')");
                }
            }

            return items;
        }

        /**
         * the 'lazy magic' - check all items
         * @access private
         * @param {boolean} [allItems]
         * @param {object} [forced]
         * @return void
         */
        function _lazyLoadItems(allItems, forced) {
            // skip if no items where left
            if (!items.length) {
                // destroy instance if option is enabled
                if (config.autoDestroy) {
                    // noinspection JSUnresolvedFunction
                    instance.destroy();
                }

                return;
            }

            var elements = forced || items,
                loadTriggered = false,
                imageBase = config.imageBase || '',
                srcsetAttribute = config.srcsetAttribute,
                handledName = config.handledName;

            // loop all available items
            for (var i = 0; i < elements.length; i++) {
                // item is at least in loadable area
                if (allItems || forced || _isInLoadableArea(elements[i])) {
                    var element = $(elements[i]),
                        tag = _getElementTagName(elements[i]),
                        attribute = element.attr(config.attribute),
                        elementImageBase = element.attr(config.imageBaseAttribute) || imageBase,
                        customLoader = element.attr(config.loaderAttribute);

                        // is not already handled 
                    if (!element.data(handledName) &&
                        // and is visible or visibility doesn't matter
                        (!config.visibleOnly || element.is(':visible')) && (
                        // and image source or source set attribute is available
                        (attribute || element.attr(srcsetAttribute)) && (
                            // and is image tag where attribute is not equal source or source set
                            (tag === _img && (elementImageBase + attribute !== element.attr(_src) || element.attr(srcsetAttribute) !== element.attr(_srcset))) ||
                            // or is non image tag where attribute is not equal background
                            (tag !== _img && elementImageBase + attribute !== element.css(_backgroundImage))
                        ) ||
                        // or custom loader is available
                        customLoader))
                    {
                        // mark element always as handled as this point to prevent double handling
                        loadTriggered = true;
                        element.data(handledName, true);

                        // load item
                        _handleItem(element, tag, elementImageBase, customLoader);
                    }
                }
            }

            // when something was loaded remove them from remaining items
            if (loadTriggered) {
                items = $(items).filter(function() {
                    return !$(this).data(handledName);
                });
            }
        }

        /**
         * load the given element the lazy way
         * @access private
         * @param {object} element
         * @param {string} tag
         * @param {string} imageBase
         * @param {function} [customLoader]
         * @return void
         */
        function _handleItem(element, tag, imageBase, customLoader) {
            // increment count of items waiting for after load
            ++_awaitingAfterLoad;

            // extended error callback for correct 'onFinishedAll' handling
            var errorCallback = function() {
                _triggerCallback('onError', element);
                _reduceAwaiting();

                // prevent further callback calls
                errorCallback = $.noop;
            };

            // trigger function before loading image
            _triggerCallback('beforeLoad', element);

            // fetch all double used data here for better code minimization
            var srcAttribute = config.attribute,
                srcsetAttribute = config.srcsetAttribute,
                sizesAttribute = config.sizesAttribute,
                retinaAttribute = config.retinaAttribute,
                removeAttribute = config.removeAttribute,
                loadedName = config.loadedName,
                elementRetina = element.attr(retinaAttribute);

            // handle custom loader
            if (customLoader) {
                // on load callback
                var loadCallback = function() {
                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(config.loaderAttribute);
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // remove item from waiting queue and possibly trigger finished event
                    // it's needed to be asynchronous to run after filter was in _lazyLoadItems
                    setTimeout(_reduceAwaiting, 1);

                    // prevent further callback calls
                    loadCallback = $.noop;
                };

                // bind error event to trigger callback and reduce waiting amount
                element.off(_error).one(_error, errorCallback)

                // bind after load callback to element
                .one(_load, loadCallback);

                // trigger custom loader and handle response
                if (!_triggerCallback(customLoader, element, function(response) {
                    if(response) {
                        element.off(_load);
                        loadCallback();
                    }
                    else {
                        element.off(_error);
                        errorCallback();
                    }
                })) {
                    element.trigger(_error);
                }
            }

            // handle images
            else {
                // create image object
                var imageObj = $(new Image());

                // bind error event to trigger callback and reduce waiting amount
                imageObj.one(_error, errorCallback)

                // bind after load callback to image
                .one(_load, function() {
                    // remove element from view
                    element.hide();

                    // set image back to element
                    // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                    if (tag === _img) {
                        element.attr(_sizes, imageObj.attr(_sizes))
                               .attr(_srcset, imageObj.attr(_srcset))
                               .attr(_src, imageObj.attr(_src));
                    }
                    else {
                        element.css(_backgroundImage, "url('" + imageObj.attr(_src) + "')");
                    }

                    // bring it back with some effect!
                    element[config.effect](config.effectTime);

                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(srcAttribute + ' ' + srcsetAttribute + ' ' + retinaAttribute + ' ' + config.imageBaseAttribute);

                        // only remove 'sizes' attribute, if it was a custom one
                        if (sizesAttribute !== _sizes) {
                            element.removeAttr(sizesAttribute);
                        }
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // cleanup image object
                    imageObj.remove();

                    // remove item from waiting queue and possibly trigger finished event
                    _reduceAwaiting();
                });

                // set sources
                // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                var imageSrc = (_isRetinaDisplay && elementRetina ? elementRetina : element.attr(srcAttribute)) || '';
                imageObj.attr(_sizes, element.attr(sizesAttribute))
                        .attr(_srcset, element.attr(srcsetAttribute))
                        .attr(_src, imageSrc ? imageBase + imageSrc : null);

                // call after load even on cached image
                imageObj.complete && imageObj.trigger(_load); // jshint ignore : line
            }
        }

        /**
         * check if the given element is inside the current viewport or threshold
         * @access private
         * @param {object} element
         * @return {boolean}
         */
        function _isInLoadableArea(element) {
            var elementBound = element.getBoundingClientRect(),
                direction    = config.scrollDirection,
                threshold    = config.threshold,
                vertical     = // check if element is in loadable area from top
                               ((_getActualHeight() + threshold) > elementBound.top) &&
                               // check if element is even in loadable are from bottom
                               (-threshold < elementBound.bottom),
                horizontal   = // check if element is in loadable area from left
                               ((_getActualWidth() + threshold) > elementBound.left) &&
                               // check if element is even in loadable area from right
                               (-threshold < elementBound.right);

            if (direction === 'vertical') {
                return vertical;
            }
            else if (direction === 'horizontal') {
                return horizontal;
            }

            return vertical && horizontal;
        }

        /**
         * receive the current viewed width of the browser
         * @access private
         * @return {number}
         */
        function _getActualWidth() {
            return _actualWidth >= 0 ? _actualWidth : (_actualWidth = $(window).width());
        }

        /**
         * receive the current viewed height of the browser
         * @access private
         * @return {number}
         */
        function _getActualHeight() {
            return _actualHeight >= 0 ? _actualHeight : (_actualHeight = $(window).height());
        }

        /**
         * get lowercase tag name of an element
         * @access private
         * @param {object} element
         * @returns {string}
         */
        function _getElementTagName(element) {
            return element.tagName.toLowerCase();
        }

        /**
         * prepend image base to all srcset entries
         * @access private
         * @param {string} srcset
         * @param {string} imageBase
         * @returns {string}
         */
        function _getCorrectedSrcSet(srcset, imageBase) {
            if (imageBase) {
                // trim, remove unnecessary spaces and split entries
                var entries = srcset.split(',');
                srcset = '';

                for (var i = 0, l = entries.length; i < l; i++) {
                    srcset += imageBase + entries[i].trim() + (i !== l - 1 ? ',' : '');
                }
            }

            return srcset;
        }

        /**
         * helper function to throttle down event triggering
         * @access private
         * @param {number} delay
         * @param {function} callback
         * @return {function}
         */
        function _throttle(delay, callback) {
            var timeout,
                lastExecute = 0;

            return function(event, ignoreThrottle) {
                var elapsed = +new Date() - lastExecute;

                function run() {
                    lastExecute = +new Date();
                    // noinspection JSUnresolvedFunction
                    callback.call(instance, event);
                }

                timeout && clearTimeout(timeout); // jshint ignore : line

                if (elapsed > delay || !config.enableThrottle || ignoreThrottle) {
                    run();
                }
                else {
                    timeout = setTimeout(run, delay - elapsed);
                }
            };
        }

        /**
         * reduce count of awaiting elements to 'afterLoad' event and fire 'onFinishedAll' if reached zero
         * @access private
         * @return void
         */
        function _reduceAwaiting() {
            --_awaitingAfterLoad;

            // if no items were left trigger finished event
            if (!items.length && !_awaitingAfterLoad) {
                _triggerCallback('onFinishedAll');
            }
        }

        /**
         * single implementation to handle callbacks, pass element and set 'this' to current instance
         * @access private
         * @param {string|function} callback
         * @param {object} [element]
         * @param {*} [args]
         * @return {boolean}
         */
        function _triggerCallback(callback, element, args) {
            if ((callback = config[callback])) {
                // jQuery's internal '$(arguments).slice(1)' are causing problems at least on old iPads
                // below is shorthand of 'Array.prototype.slice.call(arguments, 1)'
                callback.apply(instance, [].slice.call(arguments, 1));
                return true;
            }

            return false;
        }

        // if event driven or window is already loaded don't wait for page loading
        if (config.bind === 'event' || windowLoaded) {
            _initialize();
        }

        // otherwise load initial items and start lazy after page load
        else {
            // noinspection JSUnresolvedVariable
            $(window).on(_load + '.' + namespace, _initialize);
        }  
    }

    /**
     * lazy plugin class constructor
     * @constructor
     * @access private
     * @param {object} elements
     * @param {object} settings
     * @return {object|LazyPlugin}
     */
    function LazyPlugin(elements, settings) {
        /**
         * this lazy plugin instance
         * @access private
         * @type {object|LazyPlugin|LazyPlugin.prototype}
         */
        var _instance = this,

        /**
         * this lazy plugin instance configuration
         * @access private
         * @type {object}
         */
        _config = $.extend({}, _instance.config, settings),

        /**
         * instance generated event executed on container scroll or resize
         * packed in an object to be referenceable and short named because properties will not be minified
         * @access private
         * @type {object}
         */
        _events = {},

        /**
         * unique namespace for instance related events
         * @access private
         * @type {string}
         */
        _namespace = _config.name + '-' + (++lazyInstanceId);

        // noinspection JSUndefinedPropertyAssignment
        /**
         * wrapper to get or set an entry from plugin instance configuration
         * much smaller on minify as direct access
         * @access public
         * @type {function}
         * @param {string} entryName
         * @param {*} [value]
         * @return {LazyPlugin|*}
         */
        _instance.config = function(entryName, value) {
            if (value === undefined) {
                return _config[entryName];
            }

            _config[entryName] = value;
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * add additional items to current instance
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.addItems = function(items) {
            _events.a && _events.a($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * get all left items of this instance
         * @access public
         * @returns {object}
         */
        _instance.getItems = function() {
            return _events.g ? _events.g() : {};
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all items in loadable area right now
         * by default without throttle
         * @access public
         * @type {function}
         * @param {boolean} [useThrottle]
         * @return {LazyPlugin}
         */
        _instance.update = function(useThrottle) {
            _events.e && _events.e({}, !useThrottle); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force element(s) to load directly, ignoring the viewport
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.force = function(items) {
            _events.f && _events.f($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all available items right now
         * this call ignores throttling
         * @access public
         * @type {function}
         * @return {LazyPlugin}
         */
        _instance.loadAll = function() {
            _events.e && _events.e({all: true}, true); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * destroy this plugin instance
         * @access public
         * @type {function}
         * @return undefined
         */
        _instance.destroy = function() {
            // unbind instance generated events
            // noinspection JSUnresolvedFunction, JSUnresolvedVariable
            $(_config.appendScroll).off('.' + _namespace, _events.e);
            // noinspection JSUnresolvedVariable
            $(window).off('.' + _namespace);

            // clear events
            _events = {};

            return undefined;
        };

        // start using lazy and return all elements to be chainable or instance for further use
        // noinspection JSUnresolvedVariable
        _executeLazy(_instance, _config, elements, _events, _namespace);
        return _config.chainable ? elements : _instance;
    }

    /**
     * settings and configuration data
     * @access public
     * @type {object|*}
     */
    LazyPlugin.prototype.config = {
        // general
        name               : 'lazy',
        chainable          : true,
        autoDestroy        : true,
        bind               : 'load',
        threshold          : 500,
        visibleOnly        : false,
        appendScroll       : window,
        scrollDirection    : 'both',
        imageBase          : null,
        defaultImage       : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        placeholder        : null,
        delay              : -1,
        combined           : false,

        // attributes
        attribute          : 'data-src',
        srcsetAttribute    : 'data-srcset',
        sizesAttribute     : 'data-sizes',
        retinaAttribute    : 'data-retina',
        loaderAttribute    : 'data-loader',
        imageBaseAttribute : 'data-imagebase',
        removeAttribute    : true,
        handledName        : 'handled',
        loadedName         : 'loaded',

        // effect
        effect             : 'show',
        effectTime         : 0,

        // throttle
        enableThrottle     : true,
        throttle           : 250,

        // callbacks
        beforeLoad         : undefined,
        afterLoad          : undefined,
        onError            : undefined,
        onFinishedAll      : undefined
    };

    // register window load event globally to prevent not loading elements
    // since jQuery 3.X ready state is fully async and may be executed after 'load' 
    $(window).on('load', function() {
        windowLoaded = true;
    });
})(window);

/***/ }),

/***/ "iOFR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "igeC":
/***/ (function(module, exports) {

module.exports = "<div class=\"loading\" data-bind=\"visible: isLoading\"></div>\n\n<div class=\"error\" data-bind=\"visible: error, lang: 'err_503'\"></div>\n\n<div class=\"title\" data-bind=\"visible: isInitialized() && !error()\">\n\t<div data-bind=\"visible: isEmpty, lang: 'shop_search_no_result'\"></div>\n\t<div data-bind=\"visible: isNotEmpty\">\n\t\t<span class=\"search-results-title\"\n\t\t\t  data-bind=\"lang: {name: 'shop_search_results_found', data: {count: products.total}, html: true}\"></span>\n\t\t<button class=\"btn-show-all-results\"\n\t\t\t\tdata-bind=\"click: handleShowAllClick, lang: 'shop_search_btn_show_all'\"></button>\n\t</div>\n</div>\n\n<div class=\"search-results\" data-bind=\"visible: isResultsVisible\">\n\t<div class=\"sr-row sr-col sr-products\" data-bind=\"component: {name: 'qs-products', params: products}\"></div>\n\t<div class=\"sr-col sr-keywords\" data-bind=\"component: {name: 'qs-keywords', params: keywords}\"></div>\n\t<div class=\"sr-row sr-row-fixed\">\n\t\t<div class=\"sr-col sr-categories\" data-bind=\"component: {name: 'qs-categories', params: categories}\"></div>\n\t\t<div class=\"sr-col sr-reviews\" data-bind=\"component: {name: 'qs-reviews', params: reviews}\"></div>\n\t</div>\n\n</div>\n"

/***/ }),

/***/ "j9FC":
/***/ (function(module, exports) {

module.exports = "{{if packageGroup}}\n{{each packageGroup}}\n{{if count_by_group}}\n<div class=\"reviews-line-view\">\n\t<a href=\"${reviewlink}\" target=\"_blank\" class=\"review-link\"></a>\n\t<div class=\"reviews-view-col-1\"><span class=\"rev-count\">${count_by_group} отзывов</span>\n\t\tв категории товаров\n\t\t<a href=\"/reviews/shop/${shopInfo.name_view}/package_group/${id}/sort_by/date\" target=\"_blank\">${name}</a>\n\t\tв магазине ${shopName}\n\t</div>\n\t{{if reviewlink}}\n\t<a class=\"rev-readmore\" href=\"${reviewlink}\" target=\"_blank\">Смотреть &raquo;</a>\n\t{{/if}}\n</div>\n{{/if}}\n{{/each}}\n{{/if}}\n"

/***/ }),

/***/ "jBH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_widgets_loading__ = __webpack_require__("l4Yc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_widgets_popup__ = __webpack_require__("ZuML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cartitem__ = __webpack_require__("TV6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartshopview__ = __webpack_require__("ju/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartpricecomponents__ = __webpack_require__("LDVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_delivery_data_form_utils__ = __webpack_require__("foaU");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }











var cartKey = 'cart';

var Cart = function () {
    function Cart(options) {
        var _this = this;

        var autoUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, Cart);

        this.irGroupId = ko.observable(null);
        this.maxPrice = 100;
        this.maxQuantity = Number.MAX_SAFE_INTEGER;
        this.items = ko.observableArray();
        this.shopViews = ko.observableArray();
        this.additionalInfo = ko.observable(null);
        this.termsAccepted = ko.observable(false);
        this.passportTermsAccepted = ko.observable(false);
        this.checkingTypes = null;
        this.irWeightPrice = null;
        this._previousAddresses = [];
        this.totalPriceComponents = ko.pureComputed(function () {
            var sum = new __WEBPACK_IMPORTED_MODULE_7__cartpricecomponents__["a" /* CartPriceComponents */]();

            _this.items().forEach(function (item) {
                return sum.add(item.priceComponents(), item.amount());
            });

            return sum;
        });
        this.shippingPrice = ko.pureComputed(function () {
            return _this.shopViews().reduce(function (sum, view) {
                return sum + view.shippingPrice();
            }, 0);
        });
        this.total = ko.pureComputed(function () {
            var result = _this.totalPriceComponents().total() + _this.shippingPrice();
            return result.toFixed(2);
        });
        this.isShippingPriceUnknown = ko.pureComputed(function () {
            return _this.shopViews().reduce(function (result, view) {
                return result || view.isShippingPriceUnknown();
            }, false);
        });
        this.moneyLeft = ko.pureComputed(function () {
            return _this.maxPrice - _this.totalPriceComponents().price;
        });
        this.isSubmitting = ko.observable(false);
        this.isEmpty = ko.pureComputed(function () {
            return _this.items().length === 0;
        });
        this.canCreateOrder = ko.pureComputed(function () {
            return !_this.isSubmitting() && !_this.isEmpty() && _this.termsAccepted() && _this.passportTermsAccepted() && _this.shopViews().reduce(function (result, view) {
                return result && view.isMinPriceReached();
            }, true);
        });

        registerTemplates();
        var o = _extends({
            checkingTypes: {},
            irWeightPrice: 0,
            previousAddresses: []
        }, options);

        this.checkingTypes = o.checkingTypes;
        this.irWeightPrice = parseFloat(o.irWeightPrice);
        this._previousAddresses = o.previousAddresses;

        if (autoUpdate) {
            // Reload data when changed in storage
            $(window).on('storage', function (e) {
                if (e.originalEvent.key == cartKey) {
                    _this.load();
                }
            });

            // Reload data when changed externally
            $(window).on('cart-updated-externally', function () {
                return _this.load();
            });

            // Save changed data to storage
            $(window).on('cart-item-changed', function () {
                return _this.save();
            });
        }

        if (this._previousAddresses.length) {
            var $form = $('.delivery-form');
            var $previousAddressSelect = $('#previousAddressSelect');
            var $npOfficeSelect = $('select[name=np_office]');

            $previousAddressSelect.change(function (e, data) {

                if (data.selected) {
                    (function () {
                        var address = _this._previousAddresses.find(function (a) {
                            return a.id == data.selected;
                        });

                        if (address) {
                            for (var prop in address) {
                                if (['customer_id', 'np_city_description', 'np_office_description', 'last_used_date', 'np_office_ref'].includes(prop)) {
                                    continue;
                                }
                                if (prop == 'np_city_ref') {
                                    $form.find("[name=np_city]").val(address.np_city_ref).trigger('chosen:updated');
                                    $form.find("[name=np_city]").closest('.form-row').addClass('z-valid');
                                    Object(__WEBPACK_IMPORTED_MODULE_8__blocks_delivery_data_form_utils__["a" /* reloadNpOffices */])($form.find("[name=np_office]"), address.np_city_ref, 'novaposhta', function () {
                                        return _this.setFormNpOffice(address.np_office_ref);
                                    });
                                } else {
                                    $form.find("[name=" + prop + "]").val(address[prop]).trigger('chosen:updated');
                                }
                            }

                            $form.valid();
                        }
                    })();
                } else {
                    $form.find('input').val('');
                    $form.find('.form-row').removeClass('z-valid');
                    $form.find('[name=np_office]').children().remove();
                    $form.find('[name=np_office]').append("<option disabled>\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434</option>");
                    $form.find('[name=np_city],[name=np_office]').val('').trigger('chosen:updated');
                }
            });

            $npOfficeSelect.change(function () {
                if ($npOfficeSelect.val()) {
                    $npOfficeSelect.closest('.form-row').removeClass('z-notice');
                    $('.delivery-form').validate().element($npOfficeSelect);
                }
            });

            $form.find('input,[name=np_office],[name=np_city]').keyup(function () {
                return $previousAddressSelect.val('').trigger('chosen:updated');
            });
        }
    }

    _createClass(Cart, [{
        key: "load",
        value: function load() {
            var rawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var data = this.loadData(rawData);

            this.items.removeAll();
            this.items.pushAll(data.items);
            this.irGroupId(data.irGroupId || null);
            this.updateShopViews();
        }

        /**
         * @param {CartItem} item
         * @return {boolean}
         */

    }, {
        key: "addItem",
        value: function addItem(item) {
            var result = false;

            try {
                if (this.canAdd(item.sum * item.amount())) {
                    // If this product already exist, merge
                    var merged = false;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = this.items()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var cItem = _step.value;

                            var match = cItem.order_id == item.order_id && cItem.additional_customer == item.additional_customer && cItem.additional_customer_raw == item.additional_customer_raw && cItem.size == item.size && cItem.variant == item.variant && cItem.sale_id == item.sale_id;
                            if (match) {
                                cItem.amount(parseInt(cItem.amount()) + parseInt(item.amount()));
                                merged = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    ;

                    if (!merged) {
                        this.items.push(item);
                        this.updateShopViews();
                    }
                    this.save();
                    result = true;
                }
            } catch (e) {
                console.log(e);
            }

            return result;
        }

        /** @param {CartItem} item */

    }, {
        key: "deleteItem",
        value: function deleteItem(item) {
            this.items.remove(item);
            if (this.items().length > 0) {
                this.updateShopViews();
                this.save();
            } else {
                this.clear();
            }
        }
    }, {
        key: "clear",
        value: function clear() {
            this.additionalInfo(null);
            this.shopViews.removeAll();
            this.items.removeAll();
            Cart._clearData();
        }
    }, {
        key: "save",
        value: function save() {
            Cart._saveData(this.getData());
        }
    }, {
        key: "post",
        value: function post() {
            var _this2 = this;

            if (IS_LOGGED_IN) {
                this._postOrders();
            } else {
                __WEBPACK_IMPORTED_MODULE_3__core_modals__["MODAL_LOGIN"].show(function (data) {
                    if (data) {
                        _this2._postOrders();
                    }
                });
            }
        }
    }, {
        key: "_postOrders",
        value: function _postOrders() {
            var _this3 = this;

            var $deliveryForm = $('.delivery-form');
            var groups = this.shopViews().map(function (view) {
                return {
                    items: view.items().map(function (item) {
                        return item.serializeArray();
                    }),
                    shop: view.shop,
                    // sale_id: view.selectedSaleId().length ? view.selectedSaleId()[0].id : null,
                    shipping_price: view.shippingPrice()
                };
            });
            var data = {
                groups: groups,
                additional_info: this.additionalInfo(),
                delivery_data: {},
                ir_group_id: this.irGroupId(),
                raw_cart_data: JSON.stringify(this.getData())
            };

            if (!$deliveryForm.valid()) {
                return;
            }

            $deliveryForm.serializeArray().forEach(function (item) {
                return data.delivery_data[item.name] = item.value;
            });

            this.isSubmitting(true);
            __WEBPACK_IMPORTED_MODULE_0__core_widgets_loading__["a" /* default */].show();

            $.post(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('packages/save_orders_individual'), { data: data }, null, 'json').done(function (response) {
                if (response && response.success) {
                    _this3._showSuccessMessage(response, data.delivery_data);
                    _this3.clear();
                    if (window.fbq) fbq('track', 'AddToCart');
                } else {
                    var error = response && response.error ? response.error : 'Ошибка';
                    __WEBPACK_IMPORTED_MODULE_2__core_widgets_notifier__["a" /* Notifier */].error(error);
                }
            }).always(function () {
                __WEBPACK_IMPORTED_MODULE_0__core_widgets_loading__["a" /* default */].hide();
                _this3.isSubmitting(false);
            }).fail(function () {
                return __WEBPACK_IMPORTED_MODULE_2__core_widgets_notifier__["a" /* Notifier */].errorXHR();
            });
        }
    }, {
        key: "canAdd",
        value: function canAdd(price) {
            var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (reload) {
                this.load();
            }
            return this.totalPriceComponents().price + Number(price) <= this.maxPrice;
        }
    }, {
        key: "redirectToOrderForm",
        value: function redirectToOrderForm() {
            window.location = Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('create_order_individual');
        }
    }, {
        key: "updateShopViews",
        value: function updateShopViews() {
            var _this4 = this;

            var itemShops = new Set(this.items().map(function (item) {
                return item.custom_sender_name;
            }));
            var viewShops = new Set(this.shopViews().map(function (view) {
                return view.shop;
            }));

            // Delete empty views
            this.shopViews().forEach(function (view) {
                if (!itemShops.has(view.shop)) {
                    _this4.shopViews.remove(view);
                }
            });

            // Add missing views
            this.items().forEach(function (item) {
                if (!viewShops.has(item.custom_sender_name)) {
                    _this4.shopViews.push(new __WEBPACK_IMPORTED_MODULE_6__cartshopview__["a" /* CartShopView */](item.custom_sender_name, item.shopInfo, _this4));
                    viewShops.add(item.custom_sender_name);
                }
            });
        }

        /**
         * @param {Object} data
         * @param {Object} deliveryData
         * @private
         */

    }, {
        key: "_showSuccessMessage",
        value: function _showSuccessMessage(data, deliveryData) {
            var ci = data.currency_info;
            var tmpl = data.low_balance ? 'cs-popup-success-low-balance' : 'cs-popup-success';
            var tmplData = _extends({}, deliveryData, {
                balance_link: Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('balance'),
                debt_euro_f: numeral(data.debt).format('0.00') + ' &euro;',
                debt_converted_f: numeral(data.debt * ci.rate).format('0.00') + ' ' + ci.sign,
                currency_rate_f: numeral(ci.rate).format('0.00'),
                currency_sign: ci.sign
            });
            Object(__WEBPACK_IMPORTED_MODULE_1__core_widgets_popup__["a" /* openPopup */])($.tmpl(tmpl, tmplData), {
                onClose: function onClose() {
                    return window.location = Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('show_user_parcels/all');
                },
                cssClass: 'create-order-popup'
            });
        }

        /**
         * @param {Object}|null data
         * @return {Object}
         * */

    }, {
        key: "loadData",
        value: function loadData() {
            var _this5 = this;

            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!data) {
                var jsonData = localStorage.getItem(cartKey);
                data = jsonData === null ? Cart._getDummyData() : JSON.parse(jsonData);
            }

            data.items = data.items.map(function (item) {
                return new __WEBPACK_IMPORTED_MODULE_5__cartitem__["a" /* CartItem */](item, _this5);
            });

            return data;
        }

        /** @return {Object} */

    }, {
        key: "getData",
        value: function getData() {
            return {
                irGroupId: this.irGroupId(),
                items: this.items().map(function (item) {
                    return item.serializeArray();
                }),
                total: this.total()
            };
        }

        /**
         * @param float value
         * @returns string
         */

    }, {
        key: "formatPrice",
        value: function formatPrice(value) {
            var formatted = value !== null ? value.toFixed(2) : 0;
            return formatted > 0 ? formatted : '0';
        }

        /**
         * @param int id
         * @param string serializedData
         */

    }, {
        key: "editOrder",
        value: function editOrder(irGroupId, serializedData) {
            if (irGroupId && serializedData) {
                var data = JSON.parse(serializedData);
                data.irGroupId = irGroupId;

                // Load data to recalculate total price and save it
                this.load(data);
                this.save();

                // Redirect to cart page
                setTimeout(function () {
                    return window.location = Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('cart');
                });
            }
        }
    }, {
        key: "setFormNpOffice",
        value: function setFormNpOffice(officeRef) {
            var $select = $('select[name=np_office]');
            if ($select.length) {
                var newValue = '';
                var isNpOfficeNotAvailable = false;

                if (officeRef) {
                    if ($select.find("option[value='" + officeRef + "']").length) {
                        newValue = officeRef;
                    } else {
                        isNpOfficeNotAvailable = true;
                    }
                }

                $select.val(newValue).trigger('change').trigger('chosen:updated');
                if (isNpOfficeNotAvailable) {
                    $select.closest('.form-row').addClass('z-notice');
                } else {
                    $select.closest('.form-row').removeClass('z-notice');
                }
            }
        }
    }], [{
        key: "clearData",
        value: function clearData() {
            Cart._clearData();
            $(window).trigger('cart-updated-externally');
        }

        /** @param {Object} data */

    }, {
        key: "_saveData",
        value: function _saveData(data) {
            var jsonData = JSON.stringify(data);
            localStorage.setItem(cartKey, jsonData);

            // Trigger event to notify listeners in the current window
            $(window).trigger('cart-updated');
        }
    }, {
        key: "_clearData",
        value: function _clearData() {
            Cart._saveData(Cart._getDummyData());
        }

        /** @return {Object} */

    }, {
        key: "_getDummyData",
        value: function _getDummyData(data) {
            return { items: [], total: 0, irGroupId: null };
        }
    }]);

    return Cart;
}();

function registerTemplates() {
    $.template('cs-popup-success', __webpack_require__("4zkK"));
    $.template('cs-popup-success-low-balance', __webpack_require__("KHeJ"));
}

/***/ }),

/***/ "jj9x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ju/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartShopView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cart__ = __webpack_require__("jBH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__saleitem__ = __webpack_require__("NPuM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartpricecomponents__ = __webpack_require__("LDVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_url__ = __webpack_require__("FYi7");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CartShopView = function () {
    function CartShopView(shop, shopInfo, cart) {
        var _this = this;

        _classCallCheck(this, CartShopView);

        this.cart = null;

        this.cart = cart;
        this.shop = shop;
        this.shopInfo = shopInfo;

        this.sales = ko.observableArray([]).indexBy('id');
        // this.selectedSaleId = ko.observable([]);

        this.items = ko.computed(function () {
            return _this.cart.items().filter(function (item) {
                return item.custom_sender_name === _this.shop;
            });
        });

        this.shopDisplayName = ko.pureComputed(function () {
            return _this.shopInfo !== null ? _this.shopInfo.name_for_markup : _this.shop;
        });

        // this._selectedSale = ko.pureComputed(
        //     () => this.selectedSaleId() ? this.sales.get(this.selectedSaleId()) : null
        // );

        this.totalPriceComponents = ko.pureComputed(function () {
            var sum = new __WEBPACK_IMPORTED_MODULE_2__cartpricecomponents__["a" /* CartPriceComponents */]();

            _this.items().forEach(function (item) {
                return sum.add(item.priceComponents(), item.amount());
            });

            return sum;
        });

        this.shippingPrice = ko.pureComputed(function () {
            var result = 0;

            if (_this.shopInfo !== null && _this.shopInfo.name !== undefined) {
                var _shopInfo = _this.shopInfo;

                if (_shopInfo.shiping !== null) {
                    var shipping = parseFloat(_shopInfo.shiping);
                    if (_shopInfo.shiping_free !== null) {
                        var shippingFree = parseFloat(_shopInfo.shiping_free);
                        result = shippingFree == 0 || shippingFree > 0 && _this.totalPriceComponents().price < shippingFree ? shipping : 0;
                    } else {
                        result = shipping;
                    }
                }
            }

            return result;
        });

        this.freeShippingFrom = ko.pureComputed(function () {
            var result = null;

            if (_this.shopInfo !== null && _this.shopInfo.name !== undefined && _this.shopInfo.shiping_free !== null) {
                var shippingFree = parseFloat(_this.shopInfo.shiping_free);
                if (shippingFree > 0) {
                    result = shippingFree;
                }
            }
            return result;
        });

        this.total = ko.pureComputed(function () {
            var result = _this.totalPriceComponents().total() + _this.shippingPrice();
            return result.toFixed(2);
        });

        this.minPrice = ko.pureComputed(function () {
            return _this.items().length && _this.shopInfo && _this.shopInfo.min_order !== undefined ? parseFloat(_this.shopInfo.min_order) : null;
        });

        this.isShippingPriceUnknown = ko.pureComputed(function () {
            var result = true;
            if (_this.items().length && _this.shopInfo !== null && _this.shopInfo.name !== undefined) {
                var shopsWithUnknownShippingPrice = ['amazon.de', 'calida-shop.de', 'ebay.de', 'camper', 'de.allyouneed.com'];
                result = shopsWithUnknownShippingPrice.indexOf(_this.shopInfo.name) !== -1;
            }
            return result;
        });

        this.isMinPriceReached = ko.pureComputed(function () {
            return !_this.minPrice() || _this.totalPriceComponents().price >= _this.minPrice();
        });

        this._loadSales();
    }

    /** @return {SaleItem} */

    /** @type {Cart} */


    _createClass(CartShopView, [{
        key: "saleItemAfterRender",
        value: function saleItemAfterRender() {
            $('.sale-select').chosen('destroy').chosen();
        }
    }, {
        key: "itemAfterRender",
        value: function itemAfterRender(row) {
            var $row = $(row);
            var $amountInput = $row.find('.quantity input');

            $row.find('select[rel=chosen]').chosen();
            $row.find('.quantity [rel=delta]').click(function () {
                var $this = $(this);
                if (!$this.hasClass('disabled')) {
                    var oldValue = parseInt($amountInput.val());
                    var min = parseInt($amountInput.attr('min') || 1);
                    var max = parseInt($amountInput.attr('max') || Number.MAX_SAFE_INTEGER);
                    var delta = parseInt($this.data('value'));
                    var newVal = Math.max(min, Math.min(max, oldValue + delta));
                    $amountInput.val(newVal).trigger("change");
                }
            });
        }

        /**
         * @param float value
         * @returns string
         */

    }, {
        key: "formatPrice",
        value: function formatPrice(value) {
            return this.cart.formatPrice(value);
        }
    }, {
        key: "_loadSales",
        value: function _loadSales() {
            var _this2 = this;

            $.get(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */])('packages/get_available_sales'), { shop_name: this.shop, is_individual_redeem: 1 }, null, 'json').done(function (response) {
                if (response.success) {
                    _this2.sales(response.sales.map(function (item) {
                        return new __WEBPACK_IMPORTED_MODULE_1__saleitem__["a" /* SaleItem */](item);
                    }));
                }
            });
        }
    }, {
        key: "selectedSale",
        get: function get() {
            return this._selectedSale();
        }
    }]);

    return CartShopView;
}();

/***/ }),

/***/ "kNst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_slick_carousel__ = __webpack_require__("d7nS");



var logger = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_logger__["a" /* newLogger */])('Articles');

function init() {
	var $section = $('#articles');
	$section.removeClass('before-slick-init');
	var $navSlider = $section.find('[rel=nav-slider]');
	var $slaveSlider = $section.find('[rel=slave-slider]');

	$navSlider.slick({
		arrows: false,
		variableWidth: true,
		// infinite: true,
		centerMode: true,
		focusOnSelect: true,
		asNavFor: $slaveSlider,
		responsive: [{
			breakpoint: 1160,
			settings: {
				slidesToShow: 3,
				centerMode: true,
				infinite: true,
				arrows: true
			}
		}]
	}).on('click11', '.slick-slide', function () {
		var index = $(this).data('slickIndex');
		$navSlider.slick('slickGoTo', index);
	}).on('afterChange11', function (e, s, index) {
		var category = $navSlider.find('.slick-slide[data-slick-index=' + index + '] li').data('category');
		setCategory(category);
	}).on('afterChange', function () {
		if (window.lazyLoader) {
			window.lazyLoader.update();
		}
	});

	$slaveSlider.slick({
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: $navSlider,
		__responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 938,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 750,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 489,
			settings: {
				slidesToShow: 1,
				centerMode: true
			}
		}]
	});

	// const category = $navSlider.find(`.slick-slide[data-slick-index=0] li`).data('category');
	// setCategory(category);

	function setCategory(category) {
		logger.log('set category', category);
		$slaveSlider.slick('slickUnfilter');
		$slaveSlider.slick('slickFilter', ':has([data-category=' + category + '])');
	}
}

/***/ }),

/***/ "l1+7":
/***/ (function(module, exports) {

module.exports = "<div class=\"title\"><span>Категории, удовлетворяющие запросу:</span></div>\n<ul class=\"category-list parametric-list\" data-bind=\"foreach: items.slice(0, 6)\">\n\t<li data-bind=\"click: $parent.handleClick\">\n\t\t<a>\n\t\t\t<!-- ko if: subcategoryTitle -->\n\t\t\t<span class=\"subcategory-name\" data-bind=\"text: subcategoryTitle\"></span>\n\t\t\t(<span class=\"category-name\" data-bind=\"text: categoryTitle\"></span>)\n\t\t\t<!-- /ko -->\n\n\t\t\t<!-- ko ifnot: subcategoryTitle -->\n\t\t\t<span data-bind=\"text: categoryTitle\"></span>\n\t\t\t<!-- /ko -->\n\n\t\t\t<span class=\"counter\"><span data-bind=\"text: count\"></span> товаров</span>\n\t\t</a>\n\t</li>\n</ul>"

/***/ }),

/***/ "l4Yc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less__ = __webpack_require__("iOFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loading_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var $el = void 0;
var counter = 0;
var iframeOverride = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.zde.loading : {};

/* harmony default export */ __webpack_exports__["a"] = (_extends({
	/**
  * Shows loading spinner
  */
	show: function show() {
		if (!$el) {
			$el = $('<div class="zloader"></div>').appendTo('body');
			/*$el = $(`<div class="zloader2">
   <div></div>
   <div></div>
   <div></div>
   </div>`).appendTo('body');*/
		}
		counter++;
	},

	/**
  * Shows loading spinner
  */
	hide: function hide() {
		if ($el && --counter <= 0) {
			$el.addClass('zloader-closing');
			// let animation finish and remove the element
			var $element = $el;
			setTimeout(function () {
				$element.remove();
			}, 1000);
			$el = null;
			counter = 0;
		}
	}

}, iframeOverride));

/***/ }),

/***/ "lk5H":
/***/ (function(module, exports) {

module.exports = "/*!\n\tAutosize 4.0.0\n\tlicense: MIT\n\thttp://www.jacklmoore.com/autosize\n*/\n!function(e,t){if(\"function\"==typeof define&&define.amd)define([\"exports\",\"module\"],t);else if(\"undefined\"!=typeof exports&&\"undefined\"!=typeof module)t(exports,module);else{var n={exports:{}};t(n.exports,n),e.autosize=n.exports}}(this,function(e,t){\"use strict\";function n(e){function t(){var t=window.getComputedStyle(e,null);\"vertical\"===t.resize?e.style.resize=\"none\":\"both\"===t.resize&&(e.style.resize=\"horizontal\"),s=\"content-box\"===t.boxSizing?-(parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)):parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth),isNaN(s)&&(s=0),l()}function n(t){var n=e.style.width;e.style.width=\"0px\",e.offsetWidth,e.style.width=n,e.style.overflowY=t}function o(e){for(var t=[];e&&e.parentNode&&e.parentNode instanceof Element;)e.parentNode.scrollTop&&t.push({node:e.parentNode,scrollTop:e.parentNode.scrollTop}),e=e.parentNode;return t}function r(){var t=e.style.height,n=o(e),r=document.documentElement&&document.documentElement.scrollTop;e.style.height=\"\";var i=e.scrollHeight+s;return 0===e.scrollHeight?void(e.style.height=t):(e.style.height=i+\"px\",u=e.clientWidth,n.forEach(function(e){e.node.scrollTop=e.scrollTop}),void(r&&(document.documentElement.scrollTop=r)))}function l(){r();var t=Math.round(parseFloat(e.style.height)),o=window.getComputedStyle(e,null),i=\"content-box\"===o.boxSizing?Math.round(parseFloat(o.height)):e.offsetHeight;if(i!==t?\"hidden\"===o.overflowY&&(n(\"scroll\"),r(),i=\"content-box\"===o.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight):\"hidden\"!==o.overflowY&&(n(\"hidden\"),r(),i=\"content-box\"===o.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight),a!==i){a=i;var l=d(\"autosize:resized\");try{e.dispatchEvent(l)}catch(e){}}}if(e&&e.nodeName&&\"TEXTAREA\"===e.nodeName&&!i.has(e)){var s=null,u=e.clientWidth,a=null,c=function(){e.clientWidth!==u&&l()},p=function(t){window.removeEventListener(\"resize\",c,!1),e.removeEventListener(\"input\",l,!1),e.removeEventListener(\"keyup\",l,!1),e.removeEventListener(\"autosize:destroy\",p,!1),e.removeEventListener(\"autosize:update\",l,!1),Object.keys(t).forEach(function(n){e.style[n]=t[n]}),i.delete(e)}.bind(e,{height:e.style.height,resize:e.style.resize,overflowY:e.style.overflowY,overflowX:e.style.overflowX,wordWrap:e.style.wordWrap});e.addEventListener(\"autosize:destroy\",p,!1),\"onpropertychange\"in e&&\"oninput\"in e&&e.addEventListener(\"keyup\",l,!1),window.addEventListener(\"resize\",c,!1),e.addEventListener(\"input\",l,!1),e.addEventListener(\"autosize:update\",l,!1),e.style.overflowX=\"hidden\",e.style.wordWrap=\"break-word\",i.set(e,{destroy:p,update:l}),t()}}function o(e){var t=i.get(e);t&&t.destroy()}function r(e){var t=i.get(e);t&&t.update()}var i=\"function\"==typeof Map?new Map:function(){var e=[],t=[];return{has:function(t){return e.indexOf(t)>-1},get:function(n){return t[e.indexOf(n)]},set:function(n,o){e.indexOf(n)===-1&&(e.push(n),t.push(o))},delete:function(n){var o=e.indexOf(n);o>-1&&(e.splice(o,1),t.splice(o,1))}}}(),d=function(e){return new Event(e,{bubbles:!0})};try{new Event(\"test\")}catch(e){d=function(e){var t=document.createEvent(\"Event\");return t.initEvent(e,!0,!1),t}}var l=null;\"undefined\"==typeof window||\"function\"!=typeof window.getComputedStyle?(l=function(e){return e},l.destroy=function(e){return e},l.update=function(e){return e}):(l=function(e,t){return e&&Array.prototype.forEach.call(e.length?e:[e],function(e){return n(e,t)}),e},l.destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],o),e},l.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],r),e}),t.exports=l});"

/***/ }),

/***/ "m137":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateOrderForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_public_js_jquery_autosize_min_js__ = __webpack_require__("PXy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_public_js_jquery_autosize_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_public_js_jquery_autosize_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_var__ = __webpack_require__("dTkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_lang__ = __webpack_require__("RaK1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__ = __webpack_require__("l4Yc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_widgets_popup__ = __webpack_require__("ZuML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_model_cart__ = __webpack_require__("jBH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_model_cartitem__ = __webpack_require__("TV6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_model_saleitem__ = __webpack_require__("NPuM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lib_numeral__ = __webpack_require__("u2Mx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lib_numeral__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
















var logger = Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_logger__["a" /* newLogger */])('CreateOrderForm');

var CreateOrderForm = function () {
	function CreateOrderForm(selector, options) {
		var _this = this;

		_classCallCheck(this, CreateOrderForm);

		this._onSuccess = $.Callbacks();
		this._onLoad = $.Callbacks();
		this._rawProduct = null;
		this._currentSize = null;
		this._xhr = null;
		this.isIndividual = ko.observable(false);
		this.isLoading = ko.observable(false);
		this.isLoaded = ko.observable(false);
		this.error = ko.observable();
		this.currentUrl = ko.observable(null);
		this.orderName = ko.observable('');
		this.priceRaw = ko.observable('');
		this.stockRaw = ko.observable('').trimmed();
		this.additionalInfo = ko.observable('').trimmed();
		this.amount = ko.observable(1);
		this.checkingType = ko.observable('');
		this.selectedSaleId = ko.observable('');
		this._shopInfo = null;
		this.orderNameReadOnly = ko.observable(false);
		this.priceReadOnly = ko.observable(false);
		this.stockRawRequired = ko.observable(false);
		this.isStockRawNoticeVisible = ko.observable(false);
		this.isVariantsVisible = ko.observable(false);
		this.isSizesVisible = ko.observable(false);
		this.isVariantSoldOut = ko.observable(false);
		this.isSizeSoldOut = ko.observable(false);
		this.isProductSoldOut = ko.observable(false);
		this.sales = ko.observableArray([]).indexBy('id');
		this.orderDisabled = ko.observable(false);
		this.orderDisabledMessage = ko.observable(null);
		this.submitDisabled = ko.observable(false);
		this.canAdd = ko.observable(true);
		this.maxPrice = ko.observable(0);
		this._hiddenFields = {};
		this._idOrders = [];

		this.$form = $(selector);

		if (this.$form.length !== 1 || !this.$form.is('form')) {
			logger.error('Invalid form selector');
			return;
		}

		this.o = _extends({
			individual: false,

			checkingTypes: {},
			irParcelPrice: null,

			selectedSize: null,
			productName: null,
			productCost: null,

			orderId: null,
			orderData: null, // result of orderProduct call

			amount: 1

		}, options);

		this.amount(this.o.amount);

		this._cart = new __WEBPACK_IMPORTED_MODULE_10__common_model_cart__["a" /* Cart */]({
			checkingTypes: this.o.checkingTypes,
			irParcelPrice: this.o.irParcelPrice

		}, false);

		this.isIndividual(this.o.individual);

		this._prepare();

		this.price = ko.computed(function () {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["c" /* asNumber */])((_this.priceRaw() + '').replace(',', '.'));
		});
		this.price.subscribe(function () {
			_this._updateComission();
		});
		this.amount.subscribe(function () {
			_this._setPrice();
		});
		this.isCheckingAdviceVisible = ko.pureComputed(function () {
			return _this.price() > 50 && !_this.checkingType();
		});
		this._selectedSale = ko.pureComputed(function () {
			return _this.selectedSaleId() ? _this.sales.get(_this.selectedSaleId()) : null;
		});

		this.canContinue = ko.pureComputed(function () {
			return !_this.submitDisabled() && !_this.orderDisabled() && !(_this.isSizeSoldOut() && _this.isIndividual()) && _this.canAdd();
		});

		if (this.o.orderId && this.o.orderData) {
			this.$form.find('input[name=order_id]').val(this.o.orderId);
			this._processResponse(this.o.orderData);
		}
	}

	/** @type {JQuery.Callbacks} */


	// options


	// fields


	_createClass(CreateOrderForm, [{
		key: '_prepare',
		value: function _prepare() {
			var _this2 = this;

			prepareValidators();
			registerTemplates();

			this.$form.find('.product-image').fancybox({ padding: 5, type: 'image' });
			this.$form.find('select[rel=chosen]').chosen();

			this._validator = this.$form.validate({
				ignore: '[type=hidden]',
				submitHandler: function submitHandler() {
					if (_this2.isLoaded() && !_this2.submitDisabled()) {
						_this2._submit();
					}
				},
				// errorPlacement: () => {},
				highlight: function highlight(element, errorClass, validClass) {
					// logger.log('highlight', element, errorClass, validClass);
					$(element).closest('.link-order-row').removeClass('error valid').addClass(errorClass).removeClass(validClass);
				},
				unhighlight: function unhighlight(element, errorClass, validClass) {
					// logger.log('unhighlight', element, errorClass, validClass);
					$(element).closest('.link-order-row').removeClass('error valid').removeClass(errorClass).addClass(validClass);
				}
			});

			window.orderValidator = this._validator;

			// form.reset() does not affect hidden fields
			// so we should take care of them
			this.$form.find('input[type=hidden]').each(function (i, input) {
				_this2._hiddenFields[$(input).attr('name')] = $(input).attr('value');
			});

			autosize(this.$form.find('textarea[name=additional_customer_raw]'));
		}
	}, {
		key: '_reset',
		value: function _reset() {
			var _this3 = this;

			this.isLoaded(false);
			this.error('');
			this._setOrderName('');
			this._setPrice('');
			this.stockRaw('');
			this.additionalInfo('');
			this.amount(1);
			this.checkingType('');
			this.sales([]);
			this._validator.resetForm();
			this.currentUrl(null);
			$.each(this._hiddenFields, function (key, val) {
				_this3.$form.find('input[type=hidden][name=' + key + ']').val(val);
			});
			autosize.update(this.$form.find('textarea[name=additional_customer_raw]').val(''));
		}
	}, {
		key: '_showOrderSuccessMessage',
		value: function _showOrderSuccessMessage(serverResponse) {
			var data = _extends({
				balance_link: Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */])('balance'),
				status: 'on_hold',
				low_balance: false,
				debt: 0,
				debtpc: 0,
				debtpc_allowed: 1,
				currency_info: {
					rate: 1,
					sign: ''
				}
			}, serverResponse);
			var ci = data.currency_info;
			var tmpl = data.low_balance ? 'co-popup-success-low-balance' : 'co-popup-success';
			var tmplData = _extends({}, data, {
				debt_euro_f: __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default()(data.debt).format('0.00') + ' &euro;',
				debt_converted_f: __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default()(data.debt * ci.rate).format('0.00') + ' ' + ci.sign,
				currency_rate_f: __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default()(ci.rate).format('0.00'),
				debtpc_f: __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default()(data.debtpc).format('0%'),
				debtpc_allowed_f: __WEBPACK_IMPORTED_MODULE_13_lib_numeral___default()(data.debtpc_allowed).format('0%'),
				currency_sign: ci.sign
			});
			Object(__WEBPACK_IMPORTED_MODULE_9__core_widgets_popup__["a" /* openPopup */])($.tmpl(tmpl, tmplData), {
				cssClass: 'create-order-popup'
			});
		}
	}, {
		key: '_showCartSuccessMessage',
		value: function _showCartSuccessMessage() {
			var tmplData = {};
			Object(__WEBPACK_IMPORTED_MODULE_9__core_widgets_popup__["a" /* openPopup */])($.tmpl('cart-popup-success', tmplData), {
				cssClass: 'add-to-cart-success-popup'
			});
		}
	}, {
		key: 'process',
		value: function process(url) {
			var _this4 = this;

			this._reset();
			this.currentUrl(url);
			var $form = this.$form;

			if (this._xhr) {
				this._xhr.abort();
			}

			var link = $.trim(url);
			link = link.replace(/\s/g, '%20').replace('tablet.hm.com/', 'www.hm.com/').replace('m.hm.com/', 'www.hm.com/');
			if (!/^https?:\/\//i.test(link)) {
				return false;
			}

			var individual = this.isIndividual() ? 1 : 0;
			var shop_id = $form.find('input[name=shop_id]').val();
			var fromShop = $form.find('input[name=fromShop]');
			fromShop = fromShop.length > 0 ? fromShop.val() : 0;
			$form.find('input[name=order_id]').val(link);

			this.isLoading(true);

			this._xhr = $.post(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */])('c_and_a/orderProduct'), { link: link, shop_id: shop_id, fromShop: fromShop, individual: individual }, function (response) {
				if (response) {
					var result = _this4._processResponse(response);
					_this4._onLoad.fire(result);
				} else {
					_this4.error('Ошибка');
					_this4._onLoad.fire(false);
				}
			}, 'json').always(function () {
				_this4.isLoading(false);
				_this4._xhr = null;
			}).fail(function (xhr, status) {
				if (status != 'abort') {
					_this4.error('Ошибка');
					_this4._onLoad.fire(false);
				}
			});

			return true;
		}
	}, {
		key: '_processResponse',
		value: function _processResponse(response) {
			var _this5 = this;

			var self = this;
			var $form = this.$form;
			var o = this.o;

			this.stockRawRequired(true);
			this.isStockRawNoticeVisible(false);
			this.isVariantsVisible(false);
			this.isSizesVisible(false);
			this.isVariantSoldOut(false);
			this.isSizeSoldOut(false);
			this.isProductSoldOut(false);
			this.orderDisabled(response.orderDisabled);
			this.orderDisabledMessage(response.orderDisabled ? response.orderDisabledMessage : null);
			// If chat message is set, open the chat
			if (response.orderDisabled && response.orderDisabledChatMessage !== undefined && window.jivo_api !== undefined) {
				jivo_api.showProactiveInvitation(response.orderDisabledChatMessage);
			}

			$form.find('.product-image,.wrap-variants-simple').hide();
			this._updateComission(0);
			this._rawProduct = null;
			var localImage = $form.find('input[name=productImage]').val();

			$form.find('.reviewsByProduct').html($.tmpl('co-reviews-by-product', response));
			$form.find('.reviewsByGroup').html($.tmpl('co-reviews-by-group', response));
			$form.find('.reviewsByShop').html($.tmpl('co-reviews-by-shop', response));

			$form.find('.wrap-rev-stats').toggle(response.count_by_shop != '0');

			$form.find('input[name=custom_sender_name]').val(response.shopName);
			$form.find('[name=comission]').val(response.comission);
			$form.find('[name=min_commission]').val(response.minCommission);

			if (response.name) {
				if (response.error) {
					this.error(response.error);
					return false;
				}

				this._setOrderName(response.name);

				if (response.stock && !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(response.stock)) {
					$form.find('.wrap-variants').html($.tmpl('co-variants', response));
					$form.find('input[name=variant]').change(function () {
						var $variantInput = $(this);
						var variantId = $variantInput.attr('variantId');
						var sizes = response.stock[variantId];
						$form.find('.wrap-sizes').html($.tmpl('co-sizes', { sizes: sizes }));
						$form.find('input[name=size]').change(function () {
							var $sizeInput = $(this);
							self._currentSize = $sizeInput.attr('id');
							self._setPrice();
							self._checkSubmitDisable();
							self.isSizeSoldOut($sizeInput.attr('soldout') == 1);
						});

						var $current = $form.find('#' + self._currentSize);
						if ($current.not(':disabled').length > 0) {
							$current.prop('checked', true).change();
						} else {
							$form.find('input[name=size]:first').prop('checked', true).change();
						}

						var image = $variantInput.attr('image');
						if (image) {
							self._showOrHideImageBlock('show');
							$form.find('.product-image img').attr('src', image).show();
							$form.find('.product-image').attr('href', $variantInput.attr('full_image')).show();
							$form.find("input[name=save_image]").val(image);
							$form.find("input[name=save_image_big]").val($variantInput.attr('full_image'));
						} else {
							self._showOrHideImageBlock('hide');
						}

						if (response.shopName == 'sportspar.de') {
							var selectedVariant = response.variants.find(function (v) {
								return v.id == variantId;
							});
							self._setOrderName(selectedVariant.name);
						}

						self.isVariantSoldOut($variantInput.attr('soldout') == 1);

						self._setPrice();
						self._checkSubmitDisable();
					});
					$form.find('#variantRadio' + response.selected).prop('checked', true).change();
					self.isVariantsVisible(true);
					//								setPrice();
					$form.find('[name=additional_customer_raw]').attr({ placeholder: zde.lang('txt_order_products_details_parsed_placeholder') }).height('170px');
					self.stockRawRequired(false);

					if (o.selectedSize) {
						$form.find('input[name=size][value="' + o.selectedSize + '"]').prop('checked', true).change();
					} else {
						var $sizes = $form.find('input[name=size]').not(':disabled');
						if ($sizes.length > 0) {
							var $sizeS = response.selectedSize ? $form.find('#sizeRadio' + response.selectedSize) : $($sizes[0]);
							$sizeS.prop('checked', true).change();
						}
						if (response.selected !== undefined && response.selected !== null) {
							$form.find('label[for*="variantRadio' + response.selected + '"]').click();
						} else {
							$form.find('label[for*="variantRadio"]:first').click();
						}
						if (response.selectedSize !== undefined && response.selectedSize !== null) {
							$form.find('label[for*="sizeRadio' + response.selectedSize + '"]').click();
						} else {
							$form.find('label[for*="sizeRadio0"]:first').click();
						}
					}

					self._setPrice();

					self.isSizesVisible(!response.isOneSize || response.stock[Object.keys(response.stock)[0]][0].sizeName !== 'no size');
				} else {
					response.i = 0;
					$form.find('.wrap-variants-simple').html($.tmpl('co-variants-simple', response)).show();
					self._setPrice(response.price);
					if (o.selectedSize) {
						self.stockRaw('Размер: ' + o.selectedSize);
					} else {
						$form.find('[name=additional_customer_raw]').attr({ placeholder: 'Введите сюда дополнительную информацию, если нужно...' });
					}

					self.isProductSoldOut(!!response.soldOut);

					if (response.image) {
						self._showOrHideImageBlock('show');
						$form.find('.product-image img').attr('src', response.image).show();
						$form.find('.product-image').attr('href', response.image).show();
						$form.find("input[name=save_image]").val(response.image);
						$form.find("input[name=save_image_big]").val(response.image);
					} else {
						self._showOrHideImageBlock('hide');
					}
				}

				self._rawProduct = response;
			} else {
				if (response.order_name) {
					this._setOrderName(response.order_name);
				} else {
					if (o.productName) {
						this._setOrderName(o.productName);
					}
					if (o.productCost) {
						self._setPrice(o.productCost);
					}
				}

				if (o.selectedSize) {
					self.stockRaw('Размер: ' + o.selectedSize);
				}

				$form.find('[name=additional_customer_raw]').attr({ placeholder: zde.lang('txt_order_products_details_not_parsed_placeholder') }).height('170px');

				if (localImage) {
					self._showOrHideImageBlock('show');
					$form.find('.product-image img').attr('src', localImage).show();
					$form.find('.product-image').attr('href', localImage).show();
					$form.find("input[name=save_image]").val(localImage);
					$form.find("input[name=save_image_big]").val(localImage);
				} else {
					self._showOrHideImageBlock('hide');
				}
				self._updateComission(0);
			}

			self.sales(__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.map(response.sales, function (s) {
				return new __WEBPACK_IMPORTED_MODULE_12__common_model_saleitem__["a" /* SaleItem */](s);
			}));

			self._shopInfo = response.shopInfo !== undefined ? response.shopInfo : null;

			// do some actions after knockout has finished with DOM manipulation
			setTimeout(function () {
				$form.find('select[rel=chosen]').trigger('chosen:updated');
				_this5._validateFields();
			});

			this.isLoaded(true);

			if (this.isIndividual()) {
				this._cart.load();
				this.maxPrice(this._cart.maxPrice);
			} else {
				this.submitDisabled(false);
				if (window.fbq) fbq('track', 'InitiateCheckout');
			}

			return true;
		}

		/**
   * Validate name and price fields if they are filled to make validator mark them as valid
   * @private
   */

	}, {
		key: '_validateFields',
		value: function _validateFields() {
			if (this.orderName()) {
				this._validator.element(this.$form.find('[name=order_name]'));
			}
			if (this.price()) {
				this._validator.element(this.$form.find('[name=sum]'));
			}
		}
	}, {
		key: '_tempSubmit',
		value: function _tempSubmit() {
			var _this6 = this;

			var isAvailableHnm = this._shopInfo && this._shopInfo.name === 'hm.com' && !this.isSizeSoldOut();
			if (isAvailableHnm) {
				Object(__WEBPACK_IMPORTED_MODULE_9__core_widgets_popup__["a" /* openPopup */])($.tmpl('hnm-temporary-unavailable', {}), {
					onClose: function onClose(result) {
						if (result === 'ok') {
							_this6._submit();
						}
					}
				});
			} else {
				this._submit();
			}
		}
	}, {
		key: '_submit',
		value: function _submit() {
			var _this7 = this;

			var $form = this.$form;
			var additionalItems = [];

			if (this._rawProduct) {

				if (this._rawProduct.stock) {
					var $variant = $form.find('input[name=variant]:checked');
					var $size = $form.find('input[name=size]:checked');
					if ($variant.length == 0 || $size.length == 0) {
						return;
					}

					var size = $.trim($size.val());
					var url = this._rawProduct.shopUrl;
					var sizeLink = $size.attr('link');
					if (sizeLink) {
						if (sizeLink.match(/^http.+/g)) {
							url = sizeLink;
						} else {
							url += sizeLink;
						}
					}

					$form.find('input[name=order_id]').val(url);

					var count = $size.attr('count');
					additionalItems.push('Цвет: ' + $.trim($variant.val()));
					$form.find('[name="hiddenColor"]').val($.trim($variant.val()));
					if (!(this._rawProduct.isOneSize && size === 'no size')) {
						additionalItems.push('Размер: ' + size);
						$form.find('[name="hiddenSize"]').val($.trim($size.val()));
					}
					additionalItems.push('Артикул: ' + $.trim($variant.attr('artnum')));
					if ($size.attr('soldout') == 1) {
						additionalItems.push('Нет в наличии');
						$form.find('[name=sold_out]').val('1');
					} else if (count > 0) {
						additionalItems.push('Остаток: ' + count);
					}
				} else {
					$form.find('[pattr]').each(function () {
						var val = $(this).find('option:selected').val();
						additionalItems.push($(this).attr('pattr') + ': ' + val);
					});
					if (this._rawProduct.soldOut) {
						additionalItems.push('Нет в наличии');
						$form.find('[name=sold_out]').val('1');
					}
				}
			} else {
				if (!this.isStockRawNoticeVisible() && !this.stockRaw()) {
					this.isStockRawNoticeVisible(true);
					return;
				}
			}

			var additional = additionalItems.join('; ');

			var addcItems = [];
			if (this.stockRaw()) {
				addcItems.push(this.stockRaw());
			}
			if (this.additionalInfo()) {
				addcItems.push(this.additionalInfo());
			}
			var addc = addcItems.join(';\r\n');

			if (additional && addc) {
				additional += ';\r\n' + addc;
			} else if (addc) {
				additional = addc;
			}
			$form.find('[name=additional_customer]').val(additional);

			if (!IS_LOGGED_IN) {
				__WEBPACK_IMPORTED_MODULE_7__core_modals__["MODAL_LOGIN"].show(function (data) {
					if (data) {
						$form.find('input[name=customer_id]').val(data.id);
						_this7._submitForm();
					}
				});
			} else {
				this._submitForm();
			}
		}
	}, {
		key: '_submitForm',
		value: function _submitForm() {
			__WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__["a" /* default */].show();
			this.submitDisabled(true);

			if (this.isIndividual()) {
				this._addToCart();
			} else {
				var amount = Number(this.$form.find('[name=amount]').val());
				this._idOrders = [];
				this._saveOrder(amount);
			}
		}
	}, {
		key: '_saveOrder',
		value: function _saveOrder(number) {
			var _this8 = this;

			$.post(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_url__["g" /* siteUrl */])('save_order'), this.$form.serialize(), function (response) {
				if (response && response.success) {
					_this8._idOrders.push(response.id);

					if (number > 1) {
						_this8._saveOrder(number - 1);
					} else {
						// last submit
						var image = encodeURIComponent(_this8.$form.find("input[name=save_image]").val()),
						    image_big = encodeURIComponent(_this8.$form.find("input[name=save_image_big]").val());
						$.ajax('packages/save_img', {
							data: { ids: _this8._idOrders, img: image, img_big: image_big },
							complete: function complete() {
								// submit complete
								__WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__["a" /* default */].hide();
								_this8.submitDisabled(false);
								_this8.isLoaded(false);
								_this8._showOrderSuccessMessage(response);
								_this8._onSuccess.fire();
							}
						});
						if (window.fbq) fbq('track', 'AddToCart');
					}
				} else {
					var error = response && response.error ? response.error : 'Ошибка';
					__WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__["a" /* default */].hide();
					__WEBPACK_IMPORTED_MODULE_8__core_widgets_notifier__["a" /* Notifier */].error(error);
					_this8.submitDisabled(false);
				}
			}, 'json').fail(function () {
				__WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__["a" /* default */].hide();
				__WEBPACK_IMPORTED_MODULE_8__core_widgets_notifier__["a" /* Notifier */].errorXHR();
				_this8.submitDisabled(false);
			});
		}
	}, {
		key: '_addToCart',
		value: function _addToCart() {
			var dataArr = this.$form.serializeArray();
			var data = {};

			for (var i = 0; i < dataArr.length; i++) {
				var key = dataArr[i].name;
				data[key] = dataArr[i].value;
			}
			data.sum = data.sum.toString().replace(',', '.');
			data.shopInfo = this._shopInfo ? __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.pick(this._shopInfo, ['id', 'name', 'name_for_markup', 'shiping', 'shiping_free', 'min_order', 'free_ship', 'free_ship_availible']) : null;

			// Saving cart items
			var result = this._cart.addItem(new __WEBPACK_IMPORTED_MODULE_11__common_model_cartitem__["a" /* CartItem */](data, this._cart));

			// Saving complete
			__WEBPACK_IMPORTED_MODULE_6__core_widgets_loading__["a" /* default */].hide();
			this.submitDisabled(false);
			if (result) {
				this.isLoaded(false);
				this._showCartSuccessMessage();
				this._onSuccess.fire();
				if (window.fbq) fbq('track', 'InitiateCheckout');
			} else {
				__WEBPACK_IMPORTED_MODULE_8__core_widgets_notifier__["a" /* Notifier */].error(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_lang__["a" /* lang */])('msg_ir_cart_max_price_exceeded') + ' ' + this.maxPrice() + ' &euro;');
			}
		}
	}, {
		key: '_checkSubmitDisable',
		value: function _checkSubmitDisable() {
			var product = this.$form.find('input[name=size]:checked');
			this.submitDisabled(product.length === 0);
		}
	}, {
		key: '_setOrderName',
		value: function _setOrderName(name) {
			name = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(name).trim();
			this.orderName(name);
			this.orderNameReadOnly(name !== '');
		}
	}, {
		key: '_setPrice',
		value: function _setPrice(price) {
			if (price === undefined) {
				var $size = this.$form.find('input[name=size]:checked');
				price = $size.length > 0 ? $size.attr('price') : '';
			}
			this.priceRaw(price);
			this.priceReadOnly(this.price() !== 0);
			this._updateComission(price);
			this.canAdd(!this.isIndividual() || this._cart.canAdd(price * this.amount()));
		}
	}, {
		key: '_updateComission',
		value: function _updateComission(price) {
			var comission = parseFloat(this.$form.find('input[name=comission]').val());
			var minCommission = parseFloat(this.$form.find('input[name=min_commission]').val());

			price = parseFloat(price === undefined ? this.price() : price);
			var com = price * (comission / 100);

			if (comission > 0.001) {
				com = Math.max(com, minCommission);
			}

			if (isNaN(com)) {
				com = 0;
			}
			this.$form.find('[name=comission_euro]').text(com.toFixed(2).replace('.', ','));
		}
	}, {
		key: '_showOrHideImageBlock',
		value: function _showOrHideImageBlock(type) {
			if (type == 'show') {
				this.$form.find('.parrentImageBlock').show();
				this.$form.find('.upperImageBlock').show();
			} else {
				this.$form.find('.parrentImageBlock').hide();
				this.$form.find('.upperImageBlock').hide();
			}
		}
	}, {
		key: 'onSuccess',
		get: function get() {
			return this._onSuccess;
		}

		/** @type {JQuery.Callbacks} */

	}, {
		key: 'onLoad',
		get: function get() {
			return this._onLoad;
		}

		/** @return {SaleItem} */

	}, {
		key: 'selectedSale',
		get: function get() {
			return this._selectedSale();
		}

		/** @type {JQueryValidation.Validator} */

	}]);

	return CreateOrderForm;
}();

function prepareValidators() {
	$.validator.methods.url = function (value, element) {
		// contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
		return this.optional(element) || /^https?:\/\/[\w\d_.-]+\.[\w\d_-]+(?:\/.*|)$/i.test(value);
	};

	$.validator.methods.number = function (value, element) {
		return this.optional(element) || /^[-+]?(?:\d+)(?:[.,]\d*)?$/.test(value);
	};
}

function registerTemplates() {
	$.template('co-variants', __webpack_require__("cMPG"));
	$.template('co-variant-item', __webpack_require__("59Ni"));
	$.template('co-sizes', __webpack_require__("dM69"));
	$.template('co-size-item', __webpack_require__("OGjV"));
	$.template('co-variants-simple', __webpack_require__("qcNp"));
	$.template('co-reviews-by-group', __webpack_require__("j9FC"));
	$.template('co-reviews-by-product', __webpack_require__("5sk8"));
	$.template('co-reviews-by-shop', __webpack_require__("XVWq"));
	$.template('co-popup-success', __webpack_require__("sS8O"));
	$.template('co-popup-success-low-balance', __webpack_require__("OVoP"));
	$.template('cart-popup-success', __webpack_require__("mdy+"));
	$.template('hnm-temporary-unavailable', __webpack_require__("w7lQ"));
}

/***/ }),

/***/ "m9tG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debugInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_globals__ = __webpack_require__("TxBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_debuginfo__ = __webpack_require__("EfVR");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var logger = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_logger__["a" /* newLogger */])('Shop');

var shopData = _extends({
	categories: [],
	categoryGroups: []

}, Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_globals__["a" /* globals */])('shopData'));
logger.log('data', shopData);

/** @type {Settings} */
var settings = new __WEBPACK_IMPORTED_MODULE_2__model_settings__["a" /* Settings */](Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_globals__["a" /* globals */])('shopSettings'));
logger.log('settings', settings);

/** @type {DebugInfo} */
var debugInfo = new __WEBPACK_IMPORTED_MODULE_3__model_debuginfo__["a" /* DebugInfo */]();

// todo: move this code out of here
// force offer links open in new window
(function () {
	var url = settings.getOfferUrl('');
	$(document).on('click', "a[href^=\"" + url + "\"]:not([target])", function (e) {
		if (!e.isDefaultPrevented()) {
			e.preventDefault();
			window.open($(this).attr('href'));
		}
	});
})();

/***/ }),

/***/ "mdy+":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">${zde.lang('msg_product_added_to_the_cart')}</div>\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\">${zde.lang('btn_ir_continue')}</button>\r\n\t<a class=\"popup-btn active\" href=\"${site_url('cart')}\">${zde.lang('btn_ir_go_to_order_page')}</a>\r\n</div>\r\n"

/***/ }),

/***/ "oJe9":
/***/ (function(module, exports) {

module.exports = "<div class=\"product-list\" data-bind=\"foreach: items.slice(0, 7)\">\n\t<div class=\"product-list-item\">\n\t\t<div class=\"main\">\n\t\t\t<a class=\"link\" data-bind=\"attr: {href: url}\">\n\t\t\t\t<!-- ko if: previewImage -->\n\t\t\t\t<span class=\"img loading\" style=\"background-image: url('/public/images/loader_bg.gif')\"></span>\n\t\t\t\t<span class=\"img\" data-bind=\"attr: {style: 'background-image: url(\\'' + previewImage + '\\')'}\"></span>\n\t\t\t\t<!-- /ko -->\n\n\t\t\t\t<!-- ko ifnot: previewImage -->\n\t\t\t\t<span class=\"img noimg\" style=\"background-image: url('/public/images/noimage.png')\"></span>\n\t\t\t\t<!-- /ko -->\n\n\t\t\t\t<span class=\"favorite\" data-bind=\"visible: isFavorite\"></span>\n\n\t\t\t\t<span class=\"title\" data-bind=\"text: title, attr: {title: title}\"></span>\n\n\t\t\t\t<span class=\"price\">\n\t\t\t\t\t<span class=\"\" data-bind=\"css: {'new': priceOld}\">\n\t\t\t\t\t\t<span data-bind=\"numeral: {value: price, format: $parent.settings.priceFormat}\"></span>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"old\" data-bind=\"visible: priceOld\">\n\t\t\t\t\t\t<span data-bind=\"numeral: {value: priceOld, format: $parent.settings.priceFormat}\"></span>\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\n\t\t\t\t<span class=\"discount\" data-bind=\"visible: discount > 0\">\n\t\t\t\t\t-<span data-bind=\"text: discount\"></span>%\n\t\t\t\t</span>\n\n\t\t\t\t<!-- ko if: $data.score -->\n\t\t\t\t<span class=\"score\" title=\"lucene score\" data-bind=\"text: score, click: showDebugInfo\"></span>\n\t\t\t\t<!-- /ko -->\n\t\t\t</a>\n\t\t</div>\n\t</div>\n</div>"

/***/ }),

/***/ "oN+n":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),

/***/ "og09":
/***/ (function(module, exports) {

module.exports = toastr;

/***/ }),

/***/ "q/mW":
/***/ (function(module, exports) {

module.exports = "/* Soon v1.9.0 - Soon, Animated Responsive Countdowns, jQuery\n * Copyright (c) 2016 Rik Schennink - http://rikschennink.nl/products/soon\n */\n!function(a,b,c){function d(){H!==window.innerWidth&&(H=window.innerWidth,g())}function e(a,b,c,d){var e=parseInt(getComputedStyle(document.documentElement).fontSize,10)/16,f=parseInt(getComputedStyle(b).fontSize,10)/16/e,g=d/b.scrollWidth,h=g*f;return 4>h?(a.style.fontSize=\"\",c.redraw(),!1):(a.style.fontSize=h+\"rem\",a.setAttribute(\"data-scale-rounded\",Math.round(h).toString()),c.redraw(),!0)}function f(a,b){if(!B.isSlow()){for(var c,d,f=window.getComputedStyle(a.parentNode),g=parseInt(f.getPropertyValue(\"padding-left\"),10),h=parseInt(f.getPropertyValue(\"padding-right\"),10),i=a.parentNode.clientWidth-g-h,j=a.getAttribute(\"data-scale-max\"),k=a.getAttribute(\"data-scale-hide\"),l=j?I.indexOf(j):J,m=a.querySelectorAll(\".soon-group-sub\"),n=0,o=m.length,p=a.querySelector(\".soon-group\");o>n;n++)m[n].style.display=\"\";if(\"fit\"===j||\"fill\"===j){if(e(a,p,b,i))return;l=0}c=l;do a.setAttribute(\"data-scale\",I[c]),c++;while(p.scrollWidth>i&&I[c]);if(c!==l&&b.redraw(),!(p.scrollWidth<=i||\"none\"===k)){n=0,d=!1;do{if(\"0\"!==m[n].getAttribute(\"data-value\"))break;m[n].style.display=\"none\",d=!0,n++}while(p.scrollWidth>i&&o>n);if(d&&b.redraw(),\"empty\"!==k){n=o-1,d=!1;do m[n].style.display=\"none\",d=!0,n--;while(p.scrollWidth>i&&n>0);d&&b.redraw()}}}}function g(){for(var a=K.length-1;a>=0;a--)f(K[a].node,K[a].presenter)}function h(a){for(var b=0,c=K.length;c>b;b++)if(K[b].node===a)return b;return null}function i(a){for(var b=0,c=L.length;c>b;b++)if(L[b].node===a)return b;return null}function j(a){var b=h(a);return null===b?null:K[b]}function k(a){-1===a.className.indexOf(\"soon\")&&(a.className+=\" soon\"),B.supportsAnimation()||(a.className+=\" soon-no-animation\");var b=a.getAttribute(\"data-layout\");(!b||-1===b.indexOf(\"group\")&&-1===b.indexOf(\"line\"))&&(b||(b=\"\"),a.setAttribute(\"data-layout\",b+\" group\")),B.isSlow()&&(a.removeAttribute(\"data-visual\"),a.setAttribute(\"data-view\",\"text\"),a.className+=\" soon-slow-browser\")}function l(a,b,c){b[c]&&!a.getAttribute(\"data-\"+c)&&a.setAttribute(\"data-\"+c,b[c])}function m(a,b){return a.getAttribute(\"data-\"+b)}function n(a,b){var c=null!==a.due||null!==a.since,d=null;if(c)if(a.since){var e=a.now?a.now.valueOf():(new Date).valueOf();d=D.chain(function(b){return a.now?-b:b},D.offset(e),D.diff(a.since.valueOf()),function(a){return Math.abs(a)},function(a){return Math.max(0,a)},function(b){return a.callback.onTick(b,a.since),b},D.event(function(a){return 0===a},b),D.duration(new Date(e),a.since,a.format,a.cascade))}else d=D.chain(D.offset(a.now.valueOf()),D.diff(a.due.valueOf()),function(a){return Math.max(0,a)},function(b){return a.callback.onTick(b,a.due),b},D.event(function(a){return 0>=a},b),D.duration(a.now,a.due,a.format,a.cascade));else d=function(){var a=new Date;return[a.getHours(),a.getMinutes(),a.getSeconds()]},a.format=[\"h\",\"m\",\"s\"],a.separator=\":\";return d}function o(a,b){for(var c,d,e,f,g,h,i,j=null!==a.due||null!==a.since,k=n(a,b),l={type:\"group\",options:{transform:k,presenters:[]}},m=[],o=a.format.length,r=0;o>r;r++)h=a.format[r],i=r,c={type:\"group\",options:{className:\"soon-group-sub\",presenters:[]}},a.visual&&(c.options.presenters.push(p(a,h)),a.reflect&&c.options.presenters.push(p(a,h,\"soon-reflection\"))),d={type:\"text\",options:{className:\"soon-label\"}},d.options.transform=a.singular?D.plural(a.label[h],a.label[h+\"_s\"]):function(b){return function(){return a.label[b+\"_s\"]}}(h),e=q(a,h),f=null,a.reflect&&!a.visual&&(f=q(a,h,\"soon-reflection\")),c.options.presenters.push(e),f&&c.options.presenters.push(f),j&&c.options.presenters.push(d),a.separator&&(g={type:\"group\",options:{className:\"soon-group-separator\",presenters:[c]}},0!==i&&(a.reflect&&g.options.presenters.unshift({type:\"text\",options:{className:\"soon-separator soon-reflection\",transform:function(){return a.separator}}}),g.options.presenters.unshift({type:\"text\",options:{className:\"soon-separator\",transform:function(){return a.separator}}})),c=g),m.push(c);return l.options.presenters=m,l}function p(a,b,c){var d=a.visual.split(\" \"),e=d[0];return d.shift(),{type:e,options:{className:\"soon-visual \"+(c||\"\"),transform:D.chain(D.progress(B.MAX[b]),D.cap()),modifiers:d,animate:\"ms\"!==b}}}function q(a,b,c){var d=[];return a.face&&(d=a.face.split(\" \"),d.shift()),a.chars?{type:\"repeater\",options:{delay:\"text\"===a.view?0:50,className:\"soon-value \"+(c||\"\"),transform:D.chain(D.pad(a.padding[b]),D.chars()),presenter:{type:a.view,options:{modifiers:d}}}}:{type:\"group\",options:{className:\"soon-group-sub-sub soon-value \"+(c||\"\"),transform:D.pad(a.padding[b]),presenters:[{type:a.view,options:{modifiers:d}}]}}}function r(a,b,c,d){K.push({node:a,ticker:b,presenter:c,options:d})}function s(a){return new(t(a.type))(a.options||{})}function t(a){return C[a.charAt(0).toUpperCase()+a.slice(1)]}function u(a,b){var c=a.getElementsByClassName?a.getElementsByClassName(\"soon-placeholder\"):a.querySelectorAll(\"soon-placeholder\");c.length&&(c[0].innerHTML=\"\",a=c[0]);var d=s(b);return a.appendChild(d.getElement()),d}function v(a,b,c,d){var e=new F(function(a){b.setValue(a)},{rate:c});return r(a,e,b,d),e.start(),f(a,b),e}function w(a){var b,c,d=[\"labels\",\"padding\"],e=2,f={since:m(a,\"since\"),due:m(a,\"due\"),now:m(a,\"now\"),face:m(a,\"face\"),visual:m(a,\"visual\"),format:m(a,\"format\"),singular:\"true\"===m(a,\"singular\"),reflect:\"true\"===m(a,\"reflect\"),scaleMax:m(a,\"scale-max\"),scaleHide:m(a,\"scale-hide\"),separateChars:!(\"false\"===m(a,\"separate-chars\")),cascade:!(\"false\"===m(a,\"cascade\")),separator:m(a,\"separator\"),padding:!(\"false\"===m(a,\"padding\")),eventComplete:m(a,\"event-complete\"),eventTick:m(a,\"event-tick\")};for(var g in M)if(M.hasOwnProperty(g))for(b=M[g],c=0;e>c;c++)f[d[c]+b.option]=m(a,d[c]+\"-\"+b.option.toLowerCase());return A.create(a,f)}function x(a){var b;if(0===a.indexOf(\"in \")){var c=a.match(N),d=parseInt(c[1],10),e=c[2];return b=new Date,-1!==e.indexOf(\"hour\")?b.setHours(b.getHours()+d):-1!==e.indexOf(\"minute\")?b.setMinutes(b.getMinutes()+d):-1!==e.indexOf(\"second\")&&b.setSeconds(b.getSeconds()+d),b}if(-1!==a.indexOf(\"at \")){b=new Date;var f=b.getTime(),g=-1!==a.indexOf(\"reset\");a=a.replace(\"reset \",\"\");var h=a.split(\"at \"),i=h[1].match(O),j=parseInt(i[1],10),k=i[2]?parseInt(i[2],10):0,l=i[3]?parseInt(i[3],10):0,m=h[1].split(\" zone \");if(m&&(m=m[1]),h[0].length){var n=B.getDayIndex(h[0]),o=(n+7-b.getDay())%7;b.setDate(b.getDate()+o)}b.setHours(j),b.setMinutes(k),b.setSeconds(l),b.setMilliseconds(0),g&&f>=b.getTime()&&b.setHours(j+(h[0].length?168:24));var p=B.pad,q=b.getFullYear()+\"-\"+p(b.getMonth()+1)+\"-\"+p(b.getDate()),r=p(b.getHours())+\":\"+p(b.getMinutes())+\":\"+p(b.getSeconds());a=q+\"T\"+r+(m||\"\")}return B.isoToDate(a)}function y(a,b){if(0===b.indexOf(a))return\"\";if(\"w\"===a&&-1!==b.indexOf(\"M\"))return\"\";if(\"d\"===a){if(-1!==b.indexOf(\"w\"))return\"\";if(-1!==b.indexOf(\"M\"))return\"00\"}return null}function z(a,b,c){if(c&&-1!==G.indexOf(a))return c;var d=function(c){return function(){c(),A.destroy(a),A.create(a,b)}}(c);return G.push(a),d}if(document.querySelectorAll&&!a.Soon){var A={},B={},C={},D={},E={timer:0,cbs:[],register:function(a){E.cbs.push(a)},deregister:function(a){for(var b=E.cbs.length-1;b>=0;b--)E.cbs[b]===a&&E.cbs.splice(b,1)},onresize:function(){clearTimeout(E.timer),E.timer=setTimeout(function(){E.resize()},100)},resize:function(){for(var a=0,b=E.cbs.length;b>a;a++)E.cbs[a]()},init:function(){a.addEventListener&&a.addEventListener(\"resize\",E.onresize,!1)}};E.init(),Function.prototype.bind||(Function.prototype.bind=function(a){if(\"function\"!=typeof this)throw new TypeError(\"Function.prototype.bind - what is trying to be bound is not callable\");var b=Array.prototype.slice.call(arguments,1),c=this,d=function(){},e=function(){return c.apply(this instanceof d&&a?this:a,b.concat(Array.prototype.slice.call(arguments)))};return d.prototype=this.prototype,e.prototype=new d,e}),Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){var c;if(null==this)throw new TypeError('\"this\" is null or not defined');var d=Object(this),e=d.length>>>0;if(0===e)return-1;var f=+b||0;if(1/0===Math.abs(f)&&(f=0),f>=e)return-1;for(c=Math.max(f>=0?f:e-Math.abs(f),0);e>c;){if(c in d&&d[c]===a)return c;c++}return-1}),function(){function a(a){this.el=a;for(var b=a.className.replace(/^\\s+|\\s+$/g,\"\").split(/\\s+/),c=0;c<b.length;c++)d.call(this,b[c])}function b(a,b,c){Object.defineProperty?Object.defineProperty(a,b,{get:c}):a.__defineGetter__(b,c)}if(!(\"undefined\"==typeof window.Element||\"classList\"in document.documentElement)){var c=Array.prototype,d=c.push,e=c.splice,f=c.join;a.prototype={add:function(a){this.contains(a)||(d.call(this,a),this.el.className=this.toString())},contains:function(a){return-1!=this.el.className.indexOf(a)},item:function(a){return this[a]||null},remove:function(a){if(this.contains(a)){for(var b=0;b<this.length&&this[b]!=a;b++);e.call(this,b,1),this.el.className=this.toString()}},toString:function(){return f.call(this,\" \")},toggle:function(a){return this.contains(a)?this.remove(a):this.add(a),this.contains(a)}},window.DOMTokenList=a,b(Element.prototype,\"classList\",function(){return new a(this)})}}(),function(){for(var a=0,b=[\"webkit\",\"moz\"],c=0;c<b.length&&!window.requestAnimationFrame;++c)window.requestAnimationFrame=window[b[c]+\"RequestAnimationFrame\"],window.cancelAnimationFrame=window[b[c]+\"CancelAnimationFrame\"]||window[b[c]+\"CancelRequestAnimationFrame\"];window.requestAnimationFrame||(window.requestAnimationFrame=function(b){var c=(new Date).getTime(),d=Math.max(0,16-(c-a)),e=window.setTimeout(function(){b(c+d)},d);return a=c+d,e}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)})}(),B=function(){function a(){if(!window.getComputedStyle)return!1;var a,b=document.createElement(\"div\"),d={webkitTransform:\"-webkit-transform\",OTransform:\"-o-transform\",msTransform:\"-ms-transform\",MozTransform:\"-moz-transform\",transform:\"transform\"};document.body.insertBefore(b,null);for(var e in d)b.style[e]!==c&&(b.style[e]=\"translate3d(1px,1px,1px)\",a=window.getComputedStyle(b).getPropertyValue(d[e]));return document.body.removeChild(b),a!==c&&a.length>0&&\"none\"!==a}function b(){var a=!1,b=\"animation\",d=\"\",e=\"Webkit Moz O ms Khtml\".split(\" \"),f=\"\",g=0,h=document.body,i=e.length;if(h.style.animationName!==c&&(a=!0),a===!1)for(;i>g;g++)if(h.style[e[g]+\"AnimationName\"]!==c){f=e[g],b=f+\"Animation\",d=\"-\"+f.toLowerCase()+\"-\",a=!0;break}return a}var d,e,f=\"textContent\"in document.documentElement,g=function(a){var b,c,d=/^(\\d{4}\\-\\d\\d\\-\\d\\d([tT ][\\d:\\.]*)?)([zZ]|([+\\-])(\\d\\d):(\\d\\d))?$/,e=d.exec(a)||[];if(e[1]){b=e[1].split(/\\D/);for(var f=0,g=b.length;g>f;f++)b[f]=parseInt(b[f],10)||0;return b[1]-=1,b=new Date(Date.UTC.apply(Date,b)),b.getDate()?(e[5]&&(c=60*parseInt(e[5],10),e[6]&&(c+=parseInt(e[6],10)),\"+\"==e[4]&&(c*=-1),c&&b.setUTCMinutes(b.getUTCMinutes()+c)),b):Number.NaN}return Number.NaN},h=new Date(\"2015-01-01T12:00:00.123+01:00\"),i=isNaN(h)?function(a){return g(a)}:function(a){return new Date(a)};\"undefined\"!=typeof document.hidden?(e=\"hidden\",d=\"visibilitychange\"):\"undefined\"!=typeof document.mozHidden?(e=\"mozHidden\",d=\"mozvisibilitychange\"):\"undefined\"!=typeof document.msHidden?(e=\"msHidden\",d=\"msvisibilitychange\"):\"undefined\"!=typeof document.webkitHidden&&(e=\"webkitHidden\",d=\"webkitvisibilitychange\");var j=!1,k=1,l=1e3*k,m=60*l,n=60*m,o=24*n,p=7*o,q={MAX:{y:100,M:12,w:52,d:365,h:24,m:60,s:60,ms:1e3},AMOUNT:{w:p,d:o,h:n,m:m,s:l,ms:k},NAMES:{y:\"years\",M:\"months\",w:\"weeks\",d:\"days\",h:\"hours\",m:\"minutes\",s:\"seconds\",ms:\"milliseconds\"},FORMATS:[\"y\",\"M\",\"w\",\"d\",\"h\",\"m\",\"s\",\"ms\"],CIRC:2*Math.PI,QUART:.5*Math.PI,DAYS:[\"su\",\"mo\",\"tu\",\"we\",\"th\",\"fr\",\"sa\"],setText:null,documentVisibilityEvent:d,pad:function(a){return(\"00\"+a).slice(-2)},getDayIndex:function(a){return this.DAYS.indexOf(a.substr(0,2))},isSlow:function(){return!f},supportsAnimation:function(){return j=b()&&a(),q.supportsAnimation=function(){return j},j},toArray:function(a){return Array.prototype.slice.call(a)},toBoolean:function(a){return\"string\"==typeof a?\"true\"===a:a},isoToDate:function(a){if(a.match(/(Z)|([+\\-][0-9]{2}:?[0-9]*$)/g))return i(a);a+=-1!==a.indexOf(\"T\")?\"Z\":\"\";var b=i(a);return this.dateToLocal(b)},dateToLocal:function(a){return new Date(a.getTime()+6e4*a.getTimezoneOffset())},prefix:function(){for(var a,b=[\"webkit\",\"Moz\",\"ms\",\"O\"],c=0,d=b.length,e=document.createElement(\"div\").style;d>c;c++)if(a=b[c]+\"Transform\",a in e)return b[c];return null}(),setTransform:function(a,b){a.style[this.prefix+\"Transform\"]=b,a.style.transform=b},setTransitionDelay:function(a,b){a.style[this.prefix+\"TransitionDelay\"]=b+\",\"+b+\",\"+b,a.style.TransitionDelay=b+\",\"+b+\",\"+b},getShadowProperties:function(a){if(a=a?a.match(/(-?\\d+px)|(rgba\\(.+\\))|(rgb\\(.+\\))|(#[abcdef\\d]+)/g):null,!a)return null;for(var b,c=0,d=a.length,e=[];d>c;c++)-1!==a[c].indexOf(\"px\")?e.push(parseInt(a[c],10)):b=a[c];return e.push(b),5===e.length&&e.splice(3,1),e},getDevicePixelRatio:function(){return window.devicePixelRatio||1},isDocumentHidden:function(){return e?document[e]:!1},triggerAnimation:function(a,b){a.classList.remove(b),window.requestAnimationFrame(function(){a.offsetLeft,a.classList.add(b)})},getBackingStoreRatio:function(a){return a.webkitBackingStorePixelRatio||a.mozBackingStorePixelRatio||a.msBackingStorePixelRatio||a.oBackingStorePixelRatio||a.backingStorePixelRatio||1},setShadow:function(a,b,c,d,e){a.shadowOffsetX=b,a.shadowOffsetY=c,a.shadowBlur=d,a.shadowColor=e},getColorBetween:function(a,b,c){function d(a,b){return a+Math.round((b-a)*c)}function e(a){a=Math.min(a,255),a=Math.max(a,0);var b=a.toString(16);return b.length<2&&(b=\"0\"+b),b}return\"#\"+e(d(a.r,b.r))+e(d(a.g,b.g))+e(d(a.b,b.b))},getGradientColors:function(a,b,c){for(var d=[],e=0,f=c,g=1/(f-1),h=0;f>e;e++)d[e]=this.getColorBetween(a,b,h),h+=g;return d},hexToRgb:function(a){var b=/^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i.exec(a);return b?{r:parseInt(b[1],16),g:parseInt(b[2],16),b:parseInt(b[3],16)}:null},drawGradientArc:function(a,b,c,d,e,f,g,h,i,j,k,l,m){if(!(g>h)){l&&this.drawArc(a,b,c,d,e,f,g,h,i,\"transparent\",l,m);for(var n,o,p,q,r,s,t,u=this.hexToRgb(j),v=this.hexToRgb(k),w=this.hexToRgb(this.getColorBetween(u,v,(g-e)/f)),x=this.hexToRgb(this.getColorBetween(u,v,(h-e)/f)),y=h-g,z=Math.ceil(30*y),A=this.getGradientColors(w,x,z),B=-this.QUART+this.CIRC*g,C=A.length,D=0,E=this.CIRC*y/C;C>D;D++)o=A[D],p=A[D+1]||o,q=b+Math.cos(B)*d,s=b+Math.cos(B+E)*d,r=c+Math.sin(B)*d,t=c+Math.sin(B+E)*d,a.beginPath(),n=a.createLinearGradient(q,r,s,t),n.addColorStop(0,o),n.addColorStop(1,p),a.lineCap=m,a.strokeStyle=n,a.arc(b,c,d,B-.005,B+E+.005),a.lineWidth=i,a.stroke(),a.closePath(),B+=E}},drawArc:function(a,b,c,d,e,f,g,h,i,j,k,l){if(!(g>h)){if(null!==j.gradient.colors&&\"follow\"===j.gradient.type)return void this.drawGradientArc(a,b,c,d,e,f,g,h,i,j.gradient.colors[0],j.gradient.colors[1],k,l);if(k){var m=\"transparent\"===j.fill?9999:0;a.save(),a.translate(m,0),this.setShadow(a,k[0]-m,k[1],k[2],k[3])}if(a.beginPath(),a.lineWidth=i,a.arc(b,c,d,-this.QUART+this.CIRC*g,-this.QUART+this.CIRC*h,!1),j.gradient.colors){var n=\"horizontal\"===j.gradient.type?a.createLinearGradient(0,d,2*d,d):a.createLinearGradient(d,0,d,2*d);n.addColorStop(0,j.gradient.colors[0]),n.addColorStop(1,j.gradient.colors[1]),a.strokeStyle=n}else a.strokeStyle=\"transparent\"===j.fill?\"#000\":j.fill;a.lineCap=l,a.stroke(),k&&a.restore()}},drawRing:function(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p){d+e>1&&(d-=-1+d+e,c+=.5*e);var q=c,r=c+d,s=b*d,t=.5-Math.abs(-.5+b),u=c+(s-t*e),v=c+(s+(1-t)*e);(g||k)&&(p?(this.drawArc(a,f,f,g,c,d,v,r,h,i,j,o),this.drawArc(a,f,f,k,c,d,q,u,l,m,n,o)):(this.drawArc(a,f,f,g,c,d,q,u,h,i,j,o),this.drawArc(a,f,f,k,c,d,v,r,l,m,n,o)))},setTextContent:function(){return f?function(a,b){a.textContent=b}:function(a,b){a.innerText=b}}()};return q}(),D.cap=function(a,b){return a=a||0,b=b||1,function(c){return Math.min(Math.max(c,a),b)}},D.chain=function(a){return function(){var b,c=a.toArray(arguments),d=c.length;return function(a){for(b=0;d>b;b++)a=c[b](a);return a}}}(B),D.chars=function(){return function(a){return(a+\"\").split(\"\")}},D.diff=function(a){return function(b){return a-b}},D.duplicate=function(a){var b,c=new Array(a);return function(d){for(b=a;b--;)c[b]=d;return c}},D.duration=function(a){function b(a,b){return a.setMonth(a.getMonth()+b),a}function c(a){return new Date(a.valueOf())}function d(a,b){return-1!==b.indexOf(a)}function e(a,d){var e,f,g=12*(d.getFullYear()-a.getFullYear())+(d.getMonth()-a.getMonth()),h=b(c(a),g);return 0>d-h?(e=b(c(a),g-1),f=(d-h)/(h-e)):(e=b(c(a),g+1),f=(d-h)/(e-h)),-(g+f)}var f=a.FORMATS,g=f.length,h={M:1,y:12};return function(i,j,k,l){var m=d(\"M\",k),n=d(\"y\",k);return function(j){var o,p,q,r,s,t,u=0,v=[];for((m||n||!l)&&(o=new Date(i.valueOf()+j),p=e(o,i),t=m?Math.floor(p):12*Math.floor(p/12),j=o.valueOf()-b(c(i),t).valueOf());g>u;u++)r=f[u],2>u?(q=Math.floor(p/h[r]),d(r,k)?(p-=q*h[r],v.push(Math.max(0,q))):l||(p-=q*h[r])):(s=a.AMOUNT[r],q=Math.floor(j/s),d(r,k)?(j%=s,v.push(Math.max(0,q))):l||(j%=s));return v}}}(B),D.event=function(a,b){return function(c){return a(c)&&b(),c}},D.modulate=function(a){return function(b){return parseInt(b,10)%2===0?a:\"\"}},D.now=function(){return function(){return(new Date).getTime()}},D.offset=function(a){return function(b){return a+b}},D.pad=function(a){return a=a||\"\",function(b){return(a+b).slice(-a.length)}},D.plural=function(a,b){return function(c){return 1===parseInt(c,10)?a:b}},D.progress=function(a,b){return function(c){return c=parseInt(c,10),b>a?c/b:(a-c)/a}},C.Console=function(){var a=function(a){this._transform=a.transform||function(a){return a}};return a.prototype={redraw:function(){},destroy:function(){return null},getElement:function(){return null},setValue:function(a){console.log(this._transform(a))}},a}(),C.Fill=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-fill \"+(a.className||\"\"),this._transform=a.transform||function(a){return a},this._direction=\"to-top\";for(var b=0,c=a.modifiers.length;c>b;b++)if(0===a.modifiers[b].indexOf(\"to-\")){this._direction=a.modifiers[b];break}this._fill=document.createElement(\"span\"),this._fill.className=\"soon-fill-inner\",this._progress=document.createElement(\"span\"),this._progress.className=\"soon-fill-progress\",this._fill.appendChild(this._progress),this._wrapper.appendChild(this._fill)};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){var c,d=this._transform(b);switch(this._direction){case\"to-top\":c=\"translateY(\"+(100-100*d)+\"%)\";break;case\"to-top-right\":c=\"scale(1.45) rotateZ(-45deg) translateX(\"+(-100+100*d)+\"%)\";break;case\"to-top-left\":c=\"scale(1.45) rotateZ(45deg) translateX(\"+(100-100*d)+\"%)\";break;case\"to-left\":c=\"translateX(\"+(100-100*d)+\"%)\";break;case\"to-right\":c=\"translateX(\"+(-100+100*d)+\"%)\";break;case\"to-bottom-right\":c=\"scale(1.45) rotateZ(45deg) translateX(\"+(-100+100*d)+\"%)\";break;case\"to-bottom-left\":c=\"scale(1.45) rotateZ(-45deg) translateX(\"+(100-100*d)+\"%)\";break;case\"to-bottom\":c=\"translateY(\"+(-100+100*d)+\"%)\"}a.setTransform(this._progress,c)}},b}(B),C.Flip=function(a){var b=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-flip \"+(b.className||\"\"),this._transform=b.transform||function(a){return a},this._inner=document.createElement(\"span\"),this._inner.className=\"soon-flip-inner\",this._card=document.createElement(\"span\"),this._card.className=\"soon-flip-card\",a.supportsAnimation()?(this._front=document.createElement(\"span\"),this._front.className=\"soon-flip-front soon-flip-face\",this._back=document.createElement(\"span\"),this._back.className=\"soon-flip-back soon-flip-face\",this._card.appendChild(this._front),this._card.appendChild(this._back),this._top=document.createElement(\"span\"),this._top.className=\"soon-flip-top soon-flip-face\",this._card.appendChild(this._top),this._bottom=document.createElement(\"span\"),this._bottom.className=\"soon-flip-bottom soon-flip-face\",this._card.appendChild(this._bottom)):(this._fallback=document.createElement(\"span\"),this._fallback.className=\"soon-flip-fallback\",this._card.appendChild(this._fallback)),this._bounding=document.createElement(\"span\"),this._bounding.className=\"soon-flip-bounding\",this._card.appendChild(this._bounding),this._inner.appendChild(this._card),this._wrapper.appendChild(this._inner),this._frontValue=null,this._backValue=null,this._boundingLength=0};return b.prototype={redraw:function(){},_setBoundingForValue:function(a){var b=(a+\"\").length;if(b!==this._boundingLength){this._boundingLength=b;for(var c=\"\",d=0;b>d;d++)c+=\"8\";this._bounding.textContent=c;var e=parseInt(getComputedStyle(this._card).fontSize,10),f=this._bounding.offsetWidth/e;this._inner.style.width=f+.1*(b-1)+\"em\"}},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){return b=this._transform(b),a.supportsAnimation()?this._frontValue?void(this._backValue&&this._backValue===b||this._frontValue===b||(this._backValue&&(this._bottom.textContent=this._backValue,this._front.textContent=this._backValue,this._frontValue=this._backValue),this._setBoundingForValue(b),this._top.textContent=b,this._back.textContent=b,this._backValue=b,a.triggerAnimation(this._inner,\"soon-flip-animate\"))):(this._bottom.textContent=b,this._front.textContent=b,this._frontValue=b,void this._setBoundingForValue(b)):(this._fallback.textContent=b,void this._setBoundingForValue(b))}},b}(B),C.Group=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-group \"+(a.className||\"\"),this._inner=document.createElement(\"span\"),this._inner.className=\"soon-group-inner\",this._wrapper.appendChild(this._inner),this._transform=a.transform||function(a){return a},this._presenters=a.presenters,this._presenterStorage=[]};return b.prototype={redraw:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].redraw()},destroy:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].destroy();return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){this._wrapper.setAttribute(\"data-value\",b),b=this._transform(b);for(var c,d=0,e=b instanceof Array,f=e?b.length:this._presenters.length;f>d;d++)c=this._presenterStorage[d],c||(c=a(this._presenters[d]),this._inner.appendChild(c.getElement()),this._presenterStorage[d]=c),c.setValue(e?b[d]:b)}},b}(s),C.Matrix=function(){var a={\"3x5\":{\" \":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]],0:[[1,1,1],[1,0,1],[1,0,1],[1,0,1],[1,1,1]],1:[[1,1,0],[0,1,0],[0,1,0],[0,1,0],[0,1,0]],2:[[1,1,1],[0,0,1],[1,1,1],[1,0,0],[1,1,1]],3:[[1,1,1],[0,0,1],[1,1,1],[0,0,1],[1,1,1]],4:[[1,0,1],[1,0,1],[1,1,1],[0,0,1],[0,0,1]],5:[[1,1,1],[1,0,0],[1,1,1],[0,0,1],[1,1,1]],6:[[1,1,1],[1,0,0],[1,1,1],[1,0,1],[1,1,1]],7:[[1,1,1],[0,0,1],[0,0,1],[0,0,1],[0,0,1]],8:[[1,1,1],[1,0,1],[1,1,1],[1,0,1],[1,1,1]],9:[[1,1,1],[1,0,1],[1,1,1],[0,0,1],[1,1,1]]},\"5x7\":{\" \":[[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]],0:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],1:[[0,0,1,1,0],[0,1,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,1,1,1,1]],2:[[0,1,1,1,0],[1,1,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,1,1,0,0],[1,1,0,0,0],[1,1,1,1,1]],3:[[0,1,1,1,0],[1,1,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,0,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],4:[[0,0,1,1,1],[0,1,0,1,1],[1,1,0,1,1],[1,1,1,1,1],[0,0,0,1,1],[0,0,0,1,1],[0,0,0,1,1]],5:[[1,1,1,1,1],[1,1,0,0,0],[1,1,0,0,0],[1,1,1,1,0],[0,0,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],6:[[0,1,1,1,0],[1,1,0,0,0],[1,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],7:[[1,1,1,1,1],[0,0,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,1,1,0,0],[1,1,0,0,0],[1,1,0,0,0]],8:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],9:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,1],[0,0,0,1,1],[0,1,1,1,0]]}},b=function(){var b,c,d,e,f,g,h=[];for(d in a)if(a.hasOwnProperty(d)){for(b=a[d][0].length,c=a[d][0][0].length,g=\"\",e=0;b>e;e++){for(g+='<span class=\"soon-matrix-row\">',f=0;c>f;f++)g+='<span class=\"soon-matrix-dot\"></span>';g+=\"</span>\"}h[d]=g}return h}(),c=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-matrix \"+(a.className||\"\"),this._inner=document.createElement(\"span\"),this._inner.className=\"soon-matrix-inner\",this._wrapper.appendChild(this._inner),this._transform=a.transform||function(a){return a},this._value=[],this._type=-1!==a.modifiers.indexOf(\"3x5\")?\"3x5\":\"5x7\"};return c.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},_addChar:function(){var a=document.createElement(\"span\");return a.className=\"soon-matrix-char\",a.innerHTML=b[this._type],{node:a,ref:[]}},_updateChar:function(b,c){var d,e=a[this._type][c],f=e.length,g=e[0].length,h=0,i=b.ref;if(!i.length)for(var j=b.node.getElementsByClassName(\"soon-matrix-dot\");f>h;h++)for(i[h]=[],d=0;g>d;d++)i[h][d]=j[h*g+d];for(;f>h;h++)for(d=0;g>d;d++)i[h][d].setAttribute(\"data-state\",1===e[h][d]?\"1\":\"0\")},setValue:function(a){a=this._transform(a),a+=\"\",a=a.split(\"\");for(var b=0,c=a.length;c>b;b++){var d=this._value[b];d||(d=this._addChar(),this._inner.appendChild(d.node),this._value[b]=d),this._updateChar(d,a[b])}}},c}(),C.Repeater=function(a){var b=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-repeater \"+(b.className||\"\"),this._delay=b.delay||0,this._transform=b.transform||function(a){return a},this._destroyed=!1,this._presenter=b.presenter,this._Presenter=a(this._presenter.type),this._prepend=\"undefined\"==typeof b.prepend?!0:b.prepend,this._presenterStorage=[]};return b.prototype={redraw:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].redraw()},destroy:function(){this._destroyed=!0;for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].destroy();return this._wrapper},getElement:function(){return this._wrapper},setValue:function(a){a=this._transform(a),a=a instanceof Array?a:[a],this._prepend&&a.reverse();for(var b,c,d,e=0,f=a.length,g=0,h=a.length!==this._wrapper.children.length;f>e;e++)b=this._presenterStorage[e],b||(b=new this._Presenter(this._presenter.options||{}),0!==this._wrapper.children.length&&this._prepend?this._wrapper.insertBefore(b.getElement(),this._wrapper.firstChild):this._wrapper.appendChild(b.getElement()),this._presenterStorage[e]=b,this._delay&&(g-=this._delay)),this._delay&&!h?(this._setValueDelayed(b,a[e],g),g+=this._delay):this._setValue(b,a[e],h);for(f=this._wrapper.children.length,d=e;f>e;e++)b=this._presenterStorage[e],c=b.destroy(),c.parentNode.removeChild(c),this._presenterStorage[e]=null;this._presenterStorage.length=d},_setValueDelayed:function(a,b,c,d){var e=this;setTimeout(function(){e._setValue(a,b,d)},c)},_setValue:function(a,b,c){c&&a.setValue(\" \"),a.setValue(b)}},b}(t),C.Ring=function(a,b){var c=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-ring \"+(b.className||\"\"),this._transform=b.transform||function(a){return a},this._modifiers=b.modifiers,this._animate=b.animate,this._drawn=!1,this._canvas=document.createElement(\"canvas\"),this._wrapper.appendChild(this._canvas),this._style=document.createElement(\"span\"),this._style.className=\"soon-ring-progress\",this._style.style.visibility=\"hidden\",this._style.style.position=\"absolute\",this._wrapper.appendChild(this._style),this._current=0,this._target=null,this._destroyed=!1,this._lastTick=0,this._styles=null;var c=this;a.supportsAnimation()?window.requestAnimationFrame(function(a){c._tick(a)}):this._animate=!1};return c.prototype={destroy:function(){return this._destroyed=!0,b.deregister(this._resizeBind),this._wrapper},getElement:function(){return this._wrapper},_getModifier:function(a){for(var b=0,c=this._modifiers.length,d=null;c>b;b++)if(-1!==this._modifiers[b].indexOf(a)){d=this._modifiers[b];break}if(!d)return null;if(-1===d.indexOf(\"-\"))return!0;var e=d.split(\"-\");if(-1!==e[1].indexOf(\"_\")){var f=e[1].split(\"_\");return f[0]=\"#\"+f[0],f[1]=\"#\"+f[1],f}var g=parseFloat(e[1]);return isNaN(g)?e[1]:g/100},redraw:function(){var b=window.getComputedStyle(this._style);this._styles={offset:this._getModifier(\"offset\")||0,gap:this._getModifier(\"gap\")||0,length:this._getModifier(\"length\")||1,flip:this._getModifier(\"flip\")||!1,invert:this._getModifier(\"invert\")||null,align:\"center\",size:0,radius:0,padding:parseInt(b.getPropertyValue(\"padding-bottom\"),10)||0,cap:0===parseInt(b.getPropertyValue(\"border-top-right-radius\"),10)?\"butt\":\"round\",progressColor:{fill:b.getPropertyValue(\"color\")||\"#000\",gradient:{colors:this._getModifier(\"progressgradient\")||null,type:this._getModifier(\"progressgradienttype\")||\"follow\"}},progressWidth:parseInt(b.getPropertyValue(\"border-top-width\"),10)||2,progressShadow:a.getShadowProperties(b.getPropertyValue(\"text-shadow\")),ringColor:{fill:b.getPropertyValue(\"background-color\")||\"#fff\",gradient:{colors:this._getModifier(\"ringgradient\")||null,type:this._getModifier(\"ringgradienttype\")||\"follow\"}},ringWidth:parseInt(b.getPropertyValue(\"border-bottom-width\"),10)||2,ringShadow:a.getShadowProperties(b.getPropertyValue(\"box-shadow\"))};var c=this._canvas.getContext(\"2d\"),d=this._canvas.parentNode.clientWidth,e=a.getDevicePixelRatio(),f=a.getBackingStoreRatio(c),g=e/f,h=125>d?Math.min(1,.005*d):1;if(this._styles.ringWidth=Math.ceil(this._styles.ringWidth*h),this._styles.progressWidth=Math.ceil(this._styles.progressWidth*h),\"transparent\"===this._styles.ringColor.fill&&(this._styles.ringColor.fill=\"rgba(0,0,0,0)\"),\"transparent\"===this._styles.progressColor.fill&&(this._styles.progressColor.fill=\"rgba(0,0,0,0)\"),\"round\"===this._styles.cap&&-1===this._modifiers.join(\"\").indexOf(\"gap-\")&&(this._styles.gap=.5*(this._styles.ringWidth+this._styles.progressWidth)*.005),d){e!==f?(this._canvas.width=d*g,this._canvas.height=d*g,this._canvas.style.width=d+\"px\",this._canvas.style.height=d+\"px\",c.scale(g,g)):(this._canvas.width=d,this._canvas.height=d),this._styles.size=.5*d;var i=this._styles.size-this._styles.padding;this._styles.ringRadius=i-.5*this._styles.ringWidth,this._styles.progressRadius=i-.5*this._styles.progressWidth,this._styles.progressWidth===this._styles.ringWidth?this._styles.progressRadius=this._styles.ringRadius:this._styles.progressWidth<this._styles.ringWidth?-1!==this._modifiers.indexOf(\"align-center\")?this._styles.progressRadius=this._styles.ringRadius:-1!==this._modifiers.indexOf(\"align-bottom\")?this._styles.progressRadius=i-(this._styles.ringWidth-.5*this._styles.progressWidth):-1!==this._modifiers.indexOf(\"align-inside\")&&(this._styles.progressRadius=i-(this._styles.ringWidth+.5*this._styles.progressWidth)):-1!==this._modifiers.indexOf(\"align-center\")?this._styles.ringRadius=this._styles.progressRadius:-1!==this._modifiers.indexOf(\"align-bottom\")?this._styles.ringRadius=i-(this._styles.progressWidth-.5*this._styles.ringWidth):-1!==this._modifiers.indexOf(\"align-inside\")&&(this._styles.ringRadius=i-(this._styles.progressWidth+.5*this._styles.ringWidth)),-1!==this._modifiers.indexOf(\"glow-progress\")&&this._styles.progressShadow&&(this._styles.progressShadow[this._styles.progressShadow.length-1]=null!==this._styles.progressColor.gradient.colors?this._styles.progressColor.gradient.colors[0]:this._styles.progressColor.fill),-1!==this._modifiers.indexOf(\"glow-background\")&&this._styles.ringShadow&&(this._styles.ringShadow[this._styles.ringShadow.length-1]=null!==this._styles.ringColor.gradient.colors?this._styles.ringColor.gradient.colors[0]:this._styles.ringColor.fill),this._drawn=!1}},_tick:function(a){if(!this._destroyed){null!==this._target&&this._draw(a);var b=this;window.requestAnimationFrame(function(a){b._tick(a)})}},_draw:function(b){if(this._animate){var c=b-this._lastTick,d=250>c?1e3/c:30;if(this._lastTick=b,this._current===this._target&&this._drawn)return;this._current+=(this._target-this._current)/(d/3),Math.abs(this._current-this._target)<=.001&&(this._current=this._target)}else this._current=this._target;\n    var e=this._canvas.getContext(\"2d\");e.clearRect(0,0,this._canvas.width,this._canvas.height);var f=this._styles.flip?1-this._current:this._current;a.drawRing(e,f,this._styles.offset,this._styles.length,this._styles.gap,this._styles.size,this._styles.ringRadius,this._styles.ringWidth,this._styles.ringColor,this._styles.ringShadow,this._styles.progressRadius,this._styles.progressWidth,this._styles.progressColor,this._styles.progressShadow,this._styles.cap,this._styles.invert),this._drawn=!0},setValue:function(b){this._styles||this.redraw(),b=this._transform(b),this._target!==b&&(null==this._target&&(this._current=b),this._target=b),a.supportsAnimation()||(this._current=this._target,this._draw())}},c}(B,E),C.Slot=function(a){var b=function(a){this._forceReplace=\"undefined\"==typeof a.forceReplace?!1:a.forceReplace,this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-slot \"+(a.className||\"\"),this._transform=a.transform||function(a){return a},this._new=document.createElement(\"span\"),this._new.className=\"soon-slot-new\",this._old=document.createElement(\"span\"),this._old.className=\"soon-slot-old\",this._bounding=document.createElement(\"span\"),this._bounding.className=\"soon-slot-bounding\",this._inner=document.createElement(\"span\"),this._inner.className=\"soon-slot-inner soon-slot-animate\",this._inner.appendChild(this._old),this._inner.appendChild(this._new),this._inner.appendChild(this._bounding),this._wrapper.appendChild(this._inner),this._newValue=\"\",this._oldValue=\"\",this._boundingLength=0};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},_isEmpty:function(){return!this._newValue},_isSame:function(a){return this._newValue===a},_setBoundingForValue:function(a){var b=(a+\"\").length;if(b!==this._boundingLength){this._boundingLength=b;for(var c=\"\",d=0;b>d;d++)c+=\"8\";this._bounding.textContent=c;var e=parseInt(getComputedStyle(this._wrapper).fontSize,10),f=this._bounding.offsetWidth/e;this._inner.style.width=f+.1*(b-1)+\"em\"}},_setNewValue:function(a){this._newValue=a,\" \"!==a&&(this._new.textContent=a)},_setOldValue:function(a){this._oldValue=a,this._old.textContent=a},setValue:function(b){b=this._transform(b),this._isEmpty()?(this._setNewValue(b),this._setBoundingForValue(b),a.triggerAnimation(this._inner,\"soon-slot-animate\")):this._isSame(b)&&!this._forceReplace||(this._newValue.length&&this._setOldValue(this._newValue),this._setNewValue(b),this._setBoundingForValue(b),a.triggerAnimation(this._inner,\"soon-slot-animate\"))}},b}(B),C.Text=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-text \"+(a.className||\"\"),this._transform=a.transform||function(a){return a}};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){a.setTextContent(this._wrapper,this._transform(b))}},b}(B);var F=function(a,b){var c=function(a,c){c=c||{},this._rate=c.rate||1e3,this._offset=null,this._time=0,this._paused=!1,this._nextTickReference=null,this._tickBind=this._tick.bind(this),this._onTick=a||function(){},\"addEventListener\"in document&&document.addEventListener(b.documentVisibilityEvent,this)};return c.prototype={handleEvent:function(){b.isDocumentHidden()?this._lock():this._unlock()},isRunning:function(){return null!==this._offset},isPaused:function(){return this.isRunning()&&this._paused},start:function(){this.isRunning()||this.reset()},getTime:function(){return this._time},reset:function(){this.pause(),this._offset=(new Date).getTime(),this._time=0,this.resume()},stop:function(){var a=this;setTimeout(function(){a._clearTimer(),a._offset=null},0)},pause:function(){this._paused=!0,this._clearTimer()},resume:function(){if(this.isPaused()){this._paused=!1;var a=(new Date).getTime();this._time+=a-this._offset,this._offset=a,this._tick()}},_clearTimer:function(){clearTimeout(this._nextTickReference),this._nextTickReference=null},_lock:function(){this._clearTimer()},_unlock:function(){this.isPaused()||(this.pause(),this.resume())},_tick:function(){this._onTick(this._time),this._offset+=this._rate,this._time+=this._rate,this._nextTickReference=setTimeout(this._tickBind,this._offset-(new Date).getTime())}},c}(this,B),G=[],H=0,I=[\"xxl\",\"xl\",\"l\",\"m\",\"s\",\"xs\",\"xxs\"],J=3,K=(I.length,[]),L=[],M={y:{labels:\"Year,Years\",option:\"Years\",padding:\"\"},M:{labels:\"Month,Months\",option:\"Months\",padding:\"00\"},w:{labels:\"Week,Weeks\",option:\"Weeks\",padding:\"00\"},d:{labels:\"Day,Days\",option:\"Days\",padding:\"000\"},h:{labels:\"Hour,Hours\",option:\"Hours\",padding:\"00\"},m:{labels:\"Minute,Minutes\",option:\"Minutes\",padding:\"00\"},s:{labels:\"Second,Seconds\",option:\"Seconds\",padding:\"00\"},ms:{labels:\"Millisecond,Milliseconds\",option:\"Milliseconds\",padding:\"000\"}};E.register(d);var N=/([\\d]+)[\\s]+([a-z]+)/i,O=/([\\d]+)[:]*([\\d]{2})*[:]*([\\d]{2})*/;A.parse=function(a){w(a)},A.redraw=function(a){if(a){var b=j(a);f(b.node,b.presenter)}else g()},A.reset=function(a){var b=j(a);b&&b.ticker.reset()},A.freeze=function(a){var b=j(a);b&&b.ticker.pause()},A.unfreeze=function(a){var b=j(a);b&&b.ticker.resume()},A.setOption=function(a,b,c){var d=j(a);if(d){var e=d.options;e[b]=c,this.destroy(a),this.create(a,e)}},A.setOptions=function(a,b){var c=j(a);if(c){var d,e=c.options;for(d in b)b.hasOwnProperty(d)&&(e[d]=b[d]);this.destroy(a),this.create(a,b)}},A.destroy=function(a){var b=h(a);if(null!==b){var c=i(a);null!==c&&L.splice(c,1);var d=K[b];d.ticker&&d.ticker.stop(),d.presenter.destroy();var e=d.node.querySelector(\".soon-placeholder\");d.node.removeChild(e?e:d.node.querySelector(\".soon-group\")),a.removeAttribute(\"data-initialized\"),K.splice(b,1)}},A.create=function(a,b){if(!b)return w(a);if(\"true\"===a.getAttribute(\"data-initialized\"))return null;a.setAttribute(\"data-initialized\",\"true\");var c=null,d=null;b.eventComplete&&(c=\"string\"==typeof b.eventComplete?window[b.eventComplete]:b.eventComplete),b.eventTick&&(d=\"string\"==typeof b.eventTick?window[b.eventTick]:b.eventTick),b.due&&-1!==b.due.indexOf(\"reset\")&&(c=z(a,b,c),b.eventComplete=c),l(a,b,\"layout\"),l(a,b,\"face\"),l(a,b,\"visual\"),l(a,b,\"format\"),b.scaleMax&&a.setAttribute(\"data-scale-max\",b.scaleMax),b.scaleHide&&a.setAttribute(\"data-scale-hide\",b.scaleHide);var e,f,g,h=(b.format||\"d,h,m,s\").split(\",\"),i=-1===h.indexOf(\"ms\")?1e3:24,j={};for(e in M)M.hasOwnProperty(e)&&(f=M[e],g=(b[\"labels\"+f.option]||f.labels).split(\",\"),j[e]=g[0],j[e+\"_s\"]=g[1]||g[0]);var m=\"undefined\"==typeof b.padding?!0:b.padding,n={};for(e in M)M.hasOwnProperty(e)&&(f=M[e],m?(n[e]=y(e,h),null===n[e]&&(n[e]=f.padding),b[\"padding\"+f.option]&&(n[e]=b[\"padding\"+f.option])):n[e]=\"\");var p=(b.face||\"text \").split(\" \")[0],q=b.due?x(b.due):null,r=b.since?B.isoToDate(b.since):null,s=b.now?B.isoToDate(b.now):r?null:new Date,t={due:q,since:r,now:s,view:p,face:b.face,visual:b.visual||null,format:h,separator:b.separator||null,cascade:\"undefined\"==typeof b.cascade?!0:B.toBoolean(b.cascade),singular:b.singular,reflect:b.reflect||!1,chars:\"undefined\"==typeof b.separateChars?!0:B.toBoolean(b.separateChars),label:j,padding:n,callback:{onComplete:c||function(){},onTick:d||function(){}}};B.isSlow()&&(t.view=\"text\",t.reflect=!1,t.visual=null);var A=null,C=o(t,function(){A&&A.stop(),t.callback.onComplete()});k(a);var D=u(a,C);return A=v(a,D,i,b)};var P;!function(a){P=a()}(function(a){function b(a){for(n=1;a=d.shift();)a()}var c,d=[],e=!1,f=document,g=f.documentElement,h=g.doScroll,i=\"DOMContentLoaded\",j=\"addEventListener\",k=\"onreadystatechange\",l=\"readyState\",m=h?/^loaded|^c/:/^loaded|c/,n=m.test(f[l]);return f[j]&&f[j](i,c=function(){f.removeEventListener(i,c,e),b()},e),h&&f.attachEvent(k,c=function(){/^c/.test(f[l])&&(f.detachEvent(k,c),b())}),a=h?function(b){self!=top?n?b():d.push(b):function(){try{g.doScroll(\"left\")}catch(c){return setTimeout(function(){a(b)},50)}b()}()}:function(a){n?a():d.push(a)}}),P(function(){var a=document.querySelector(\"script[src*=soon]\");if(!a||\"false\"!==a.getAttribute(\"data-auto\"))for(var b=document.getElementsByClassName?document.getElementsByClassName(\"soon\"):document.querySelectorAll(\".soon\"),c=0,d=b.length;d>c;c++)w(b[c])}),function(a,b){\"use strict\";if(b){var c=[\"destroy\",\"reset\",\"resize\",\"freeze\",\"unfreeze\",\"redraw\"],d=c.length;b.fn.soon=function(){var b=this;b.create=function(b){return this.each(function(){a.create(this,b)})},b.setOption=function(b,c){return this.each(function(){a.setOption(this,b,c)})},b.setOptions=function(b){return this.each(function(){a.setOptions(this,b)})};for(var e=0;d>e;e++)!function(c){b[c]=function(){return this.each(function(){a[c](this)})}}(c[e]);return this}}}(A,b),\"undefined\"!=typeof module&&module.exports?module.exports=A:\"function\"==typeof define&&define.amd?define(function(){return A}):a.Soon=A}}(window,window.jQuery);"

/***/ }),

/***/ "qcNp":
/***/ (function(module, exports) {

module.exports = "{{each variants}}\n<div class=\"link-order-row\">\n\t<div class=\"link-order-label\">\n\t\t${$value.name}:\n\t\t<span class=\"req_star\">*</span>\n\t</div>\n\t<div class=\"has-select link-order-label\">\n\t\t<select name=\"attr${$index}\" pattr=\"${$value.name}\">\n\t\t\t<option value=\"\">Выберите...</option>\n\t\t\t{{each $value.variants}}\n\t\t\t<option value=\"${$value}\">${$value}</option>\n\t\t\t{{/each}}\n\t\t</select>\n\t</div>\n\t<div name=\"attr${$index}_error\"></div>\n</div>\n{{/each}}\n"

/***/ }),

/***/ "r4Qy":
/***/ (function(module, exports) {

module.exports = "<div class=\"title\">\n\t<span class=\"reviews-title\">\n\t\tОтзывы, удовлетворяющие запросу - найдено\n\t\t<span class=\"results-count\" data-bind=\"text: total\"></span>\n\t\tпозиций\n\t</span>\n\t<button class=\"btn-show-all-results\" type=\"button\" data-bind=\"click: showAll\">Показать все отзывы</button>\n</div>\n\n<div class=\"review-list\" data-bind=\"foreach: items.slice(0, 4)\">\n\t<div class=\"review-list-item\" data-bind=\"\">\n\t\t<a class=\"left\" data-bind=\"attr: {href: url}\">\n\t\t\t<div class=\"img loading\" style=\"background-image: url('/public/images/loader_bg.gif')\"></div>\n\t\t\t<div class=\"img\" data-bind=\"attr: {style: 'background-image: url(\\'' + previewImage + '\\')'}\"></div>\n\t\t\t<div class=\"activity\">\n\t\t\t\t<div class=\"likes\" title=\"Количество лайков\">\n\t\t\t\t\t<span data-bind=\"text: likesCount\"></span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"comments\" title=\"Количество комментариев\">\n\t\t\t\t\t<span data-bind=\"text: commentsCount\"></span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class=\"right\">\n\t\t\t<a class=\"title\" title=\"Название товара\" data-bind=\"text: productName, attr: {href: url}\"></a>\n\t\t\t<div class=\"info\">\n\t\t\t\t<div class=\"price\" title=\"Цена товара\" data-bind=\"numeral: {value: price, format: $parent.settings.priceFormat}\"></div>\n\t\t\t\t<div class=\"shop\">\n\t\t\t\t\t<a title=\"Магазин\" data-bind=\"attr: {href: shopUrl}, text: shopName\"></a>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"rating rate-stars\" title=\"Рейтинг\" data-bind=\"css: 'rate-stars-' + rating\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"content\">\n\t\t\t\t<div class=\"author\">\n\t\t\t\t\t<a title=\"Автор\" data-bind=\"attr: {href: authorUrl}, text: authorName\"></a>\n\t\t\t\t</div>\n\t\t\t\t<a class=\"text\" data-bind=\"text: text, attr: {href: url}\"></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- ko if: $data.score -->\n\t\t<span class=\"score\" title=\"lucene score\" data-bind=\"text: score, click: showDebugInfo\"></span>\n\t\t<!-- /ko -->\n\t</div>\n</div>"

/***/ }),

/***/ "rItL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showModalIframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_dialog__ = __webpack_require__("fokk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Shows iframe-based modal window
 * @param {string} name Modal name
 * @param {object} data Custom data to passed as GET parameters
 * @param {object} dialogOptions Options for {@link ZDialog} instance
 * @return {ZDialog}
 */
function showModalIframe(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dialogOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  data = _extends({}, data);
  for (var key in data) {
    if (data[key] === null) delete data[key];
  }var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(_extends({}, data));
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__url__["g" /* siteUrl */])('modals/' + name + (query ? '?' + query : ''));
  return Object(__WEBPACK_IMPORTED_MODULE_2__widgets_dialog__["createIframeDialog"])(url, _extends({ name: name }, dialogOptions, { autoOpen: true }));
}

/***/ }),

/***/ "sS8O":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">Поздравляем!</div>\r\n</div>\r\n<div class=\"popup-text\">\r\n\t<div>Ваш запрос успешно оформлен.</div>\r\n\t{{if status == 'pending'}}\r\n\t<div>Мы выкупим этот товар как только он появится в наличии.</div>\r\n\t{{else}}\r\n\t<div>Мы выкупим этот товар в ближайшее время.</div>\r\n\t{{/if}}\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\">Готово</button>\r\n</div>\r\n"

/***/ }),

/***/ "tXil":
/***/ (function(module, exports) {

var Smart = {};

// Embed the Smart.Plurals source: 


// Create namespace:
if (typeof Smart !== 'object')
	Smart = {};

(function() {

	var rules = {} // Map of language codes to rules
		, defaultCode = null
		, defaultRule = null;

	Smart.Plurals = {
		/**
		 * Retrieves a plural rule, based on the supplied language code.
		 * If no languageCode is specified, the default rule will be returned.
		 *
		 * A plural rule is a function that takes in a value
		 * and determines whether it should be singular form, plural form,
		 * or even other forms, depending on the number of choices.
		 *
		 * @param {String} [languageCode] - Optional - a 2-letter or 4-letter language code, or the full ruleName.
		 * @returns {function({Number} value, {Number|Array} choices)}
		 */
		getRule: function(languageCode) {
			// Calling this with no parameters will return the default:
			if (!languageCode) {
				return defaultRule || (defaultRule = this.getRule(defaultCode));
			}

			// Normalize:
			languageCode = ',' + languageCode.toLowerCase() + ',';

			// Search for an "exact match":
			for (var languageCodes in rules) {
				if (!rules.hasOwnProperty(languageCodes)) continue;

				var isExactMatch = (languageCodes.indexOf(languageCode) !== -1);
				if (isExactMatch) {
					return rules[languageCodes];
				}
			}

			// If we've got a 4-letter code, search for a "generic match" (2-letter code):
			var dash = languageCode.indexOf('-');
			if (dash !== -1) {
				var twoLetterCode = languageCode.substring(1, dash);
				return this.getRule(twoLetterCode);
			}

			return null;
		}
		,
		/**
		 * Sets the default language rule.
		 *
		 * @param {String} languageCode - 2-letter or 4-letter language code
		 */
		setDefaultRule: function(languageCode) {
			defaultCode = languageCode.toLowerCase();
			defaultRule = null; // it's lazy loaded
		}
		,
		/**
		 * Defines a language rule.
		 *
		 * @param {String} languageCodes - A comma-separated list of 2-letter or 4-letter language codes
		 * @param {function({Number} value, {Number} choices)|String} pluralRule - The rule; see getRule for a description.
		 */
		defineRule: function(languageCodes, pluralRule) {
			// Normalize:
			languageCodes = ',' + languageCodes.toLowerCase() + ',';

			var normalizedRule;
			if (typeof pluralRule === 'string') {
				// Allows for aliases
				normalizedRule = this.getRule(pluralRule);
			} else {
				normalizedRule = function (value, choices) {
					if (typeof choices === 'number') {
						return pluralRule(value, choices);
					} else if (typeof choices.length === 'number') {
						return choices[pluralRule(value, choices.length)];
					}
				};
			}

			rules[languageCodes] = normalizedRule;

			if (!defaultCode) {
				this.setDefaultRule(languageCodes.split(',')[1]);
			}

			return normalizedRule;
		}
	};

})();

/**
 * Germanic family
 *  English, German, Dutch, Swedish, Danish, Norwegian, Faroese
 * Romanic family
 *  Spanish, Portuguese, Italian, Bulgarian
 * Latin/Greek family
 *  Greek
 * Finno-Ugric family
 *  Finnish, Estonian
 * Semitic family
 *  Hebrew
 * Artificial
 *  Esperanto
 * Finno-Ugric family
 *  Hungarian
 * Turkic/Altaic family
 *  Turkish
 */
Smart.Plurals.defineRule('english,en,de,nl,sv,da,no,nn,nb,fo,es,pt,it,bg,el,fi,et,he,eo,hu,tr',
	function pluralRule_english(value, choices) {
		// singular used for 1
		// special cases for 0 and negative
		var singular = (value === 1);
		if (choices === 2) return (singular ? 0 : 1);

		var zero = (value === 0);
		if (choices === 3) return (zero ? 0 : singular ? 1 : 2);

		var negative = (value < 0);
		return (negative ? 0 : zero ? 1 : singular ? 2 : 3);
	}
);

/**
 * Slavic family
 *  Czech, Slovak
 */
Smart.Plurals.defineRule('czech,cs,sk', function pluralRule_czech(value, choices) {
	// singular used for 1
	// special case for 2-4
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value >= 2 && value <= 4);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  French, Brazilian Portuguese
 */
Smart.Plurals.defineRule('french,fr,pt-br', function pluralRule_french(value, choices) {
	// singular used for 0 and 1
	var singular = (value === 0 || value === 1);
	return (singular ? 0 : 1);
});

/**
 * Celtic
 *  Gaeilge (Irish)
 */
Smart.Plurals.defineRule('irish,ga', function pluralRule_irish(value, choices) {
	// singular used for 1
	// special case for 2
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var two = (value === 2);
	return (singular ? 0 : two ? 1 : 2);
});

/**
 * Baltic family
 *  Latvian
 */
Smart.Plurals.defineRule('latvian,lv', function pluralRule_latvian(value, choices) {
	// singular used for 1, 21, 31, 41... -- but not 11, 111, 211, 311, 411...
	// special case for 0
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return (singular ? 0 : 1);

	var zero = (value === 0);
	return (zero ? 0 : singular ? 1 : 2);
});

/**
 * Baltic family
 *  Lithuanian
 */
Smart.Plurals.defineRule('lithuanian,lt', function pluralRule_lithuanian(value, choices) {
	// singular used for numbers ending in 1 (1, 21, 31, 41...)
	// special case for numbers ending in 12-19 (12-19, 112-119, 212-219...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 100 >= 12 && value % 100 <= 19);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Polish
 */
Smart.Plurals.defineRule('polish,pl', function pluralRule_polish(value, choices) {
	// singular used for 1
	// special case for numbers ending in 2-4, except for 12-14 (2-4, 22-24, 32-34...)
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  Romanian
 */
Smart.Plurals.defineRule('romanian,ro', function pluralRule_romanian(value, choices) {
	// singular used for 1
	// special case for 0 and numbers ending in 01-19 (0, 2-19, 101-119, 201-219...)
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var few = (value === 0 || (value % 100 >= 1 && value % 100 <= 19));
	return (singular ? 0 : few ? 1 : 2);
});

/**
 * Slavic family
 *  Russian, Ukrainian, Serbian, Croatian
 */
Smart.Plurals.defineRule('russian,ru,uk,sr,hr', function pluralRule_russian(value, choices) {
	// singular used for numbers ending in 1, except 11 (1, 21, 31...)
	// special case for numbers ending in 2-4, except 12-14 (2-4, 22-24, 32-34...)
	// numbers ending in 11-14 use plural (11-14, 111-114, 211-214...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Slovenian
 */
Smart.Plurals.defineRule('slovenian,sl', function pluralRule_slovenian(value, choices) {
	// singular used for numbers ending in 01 (1, 101, 201...)
	// special case for numbers ending in 02 (2, 102, 202...)
	// special case for numbers ending in 03-04 (3-4, 103-104, 203-204...)
	var singular = (value % 100 === 1);
	if (choices === 2) return singular ? 0 : 1;

	var two = (value % 100 === 2);
	if (choices === 3) return singular ? 0 : two ? 1 : 2;

	var few = (value % 100 === 3 || value % 100 === 4);
	return singular ? 0 : two ? 1 : few ? 2 : 3;
});


module.exports = Smart;


/***/ }),

/***/ "u2Mx":
/***/ (function(module, exports) {

module.exports = numeral;

/***/ }),

/***/ "vBks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vqpe":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("0iPh")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),

/***/ "w7lQ":
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-header\">\r\n    <div class=\"popup-title\">${zde.lang('hdr_hnm_temporary_unavailable')}</div>\r\n</div>\r\n<div class=\"popup-text\">${zde.lang('txt_hnm_temporary_unavailable')}</div>\r\n<div class=\"popup-buttons\">\r\n    <button type=\"button\" class=\"popup-btn\" rel=\"close-dialog\" data-dialog-result=\"cancel\">${zde.lang('btn_hnm_temporary_unavailable_cancel')}</button>\r\n    <button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\" data-dialog-result=\"ok\">${zde.lang('btn_hnm_temporary_unavailable_ok')}</button>\r\n</div>"

/***/ }),

/***/ "webD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js__ = __webpack_require__("HH+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css__ = __webpack_require__("6mWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css__);



/***/ }),

/***/ "wn5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_modals__ = __webpack_require__("YdFU");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




function init() {
	var $container = $('#reviewsContainer');
	$container.on('click', '[rel=show-review]', function (e) {
		e.preventDefault();
		var $reviewItem = $(this).closest('[rel=review-item]');
		__WEBPACK_IMPORTED_MODULE_1__core_modals__["MODAL_REVIEW"].show($reviewItem.data('id'), $reviewItem.data('index'), $container.data('filter'));
	});

	if (!Object(__WEBPACK_IMPORTED_MODULE_0_core_utils_utils__["d" /* isTouchScreen */])()) {
		var initialDelay = 1000;
		var slidersInterval = 200;
		var transitionDuration = 1000;
		var autoplayInterval = 5000;
		var sliders = createSliders('.main-reviews-col', transitionDuration, autoplayInterval);
		setTimeout(function () {
			return startSliders(sliders, slidersInterval);
		}, initialDelay);

		$container.hover(function () {
			sliders.forEach(function (s) {
				return s.pause();
			});
		}, function () {
			sliders.forEach(function (s) {
				return s.unpause();
			});
		});
	}

	/** @return {VerticalSlider[]} */
	function createSliders(selector, transitionDuration, autoplayInterval) {
		var sliders = [];
		$(selector).each(function (i) {
			var slider = new VerticalSlider(this);
			// slider.direction = 'prev';
			slider.transitionDuration = transitionDuration;
			slider.autoplayInterval = autoplayInterval;
			sliders.push(slider);
		});
		return sliders;
	}

	/**
  * @param {VerticalSlider[]} sliders
  * @param {number} interval
  */
	function startSliders(sliders, interval) {
		sliders.forEach(function (slider, i) {
			if (i == 0) {
				slider.startAutoplay();
			} else {
				setTimeout(function () {
					slider.startAutoplay();
				}, i * interval);
			}
		});
	}
}

var VerticalSlider = function () {
	function VerticalSlider(selector) {
		_classCallCheck(this, VerticalSlider);

		this._paused = false;
		this._sliding = false;
		this.direction = 'next';
		this.autoplayInterval = 2000;
		this.transitionDuration = 1000;

		this.$el = $(selector);
	}

	_createClass(VerticalSlider, [{
		key: "slideNext",
		value: function slideNext() {
			var _this = this;

			if (this._sliding) return;
			var $slides = this.getSlides();
			if ($slides.length < 3) return;
			var $slide = $slides.first();
			$slide.css('transitionDuration', this.transitionDuration / 1000 + 's').css('marginTop', -$slide.outerHeight(true));
			this._sliding = true;
			setTimeout(function () {
				$slide.css('transitionDuration', '0s').css('marginTop', '').appendTo(_this.$el);
				_this._sliding = false;
			}, this.transitionDuration);
		}
	}, {
		key: "slidePrev",
		value: function slidePrev() {
			var _this2 = this;

			if (this._sliding) return;
			var $slides = this.getSlides();
			if ($slides.length < 3) return;
			var $slide = $slides.last();
			this._sliding = true;
			$slide.prependTo(this.$el).css('transitionDuration', '0s').css('marginTop', -$slide.outerHeight(true));
			$slide[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
			$slide.css('transitionDuration', this.transitionDuration / 1000 + 's').css('marginTop', 0);
			setTimeout(function () {
				_this2._sliding = false;
			}, this.transitionDuration);
		}
	}, {
		key: "startAutoplay",
		value: function startAutoplay() {
			var _this3 = this;

			this._autoplaySlide();
			setInterval(function () {
				_this3._autoplaySlide();
			}, this.autoplayInterval);
		}
	}, {
		key: "_autoplaySlide",
		value: function _autoplaySlide() {
			if (!this._paused) {
				if (this.direction == 'prev') {
					this.slidePrev();
				} else {
					this.slideNext();
				}
			}
		}

		/** @return {JQuery} */

	}, {
		key: "getSlides",
		value: function getSlides() {
			return this.$el.children();
		}
	}, {
		key: "pause",
		value: function pause() {
			this._paused = true;
		}
	}, {
		key: "unpause",
		value: function unpause() {
			this._paused = false;
		}
	}]);

	return VerticalSlider;
}();

/***/ }),

/***/ "xlbI":
/***/ (function(module, exports) {

module.exports = "<div class=\"title\">Совпадения в ключевых словах:</div>\n<ul class=\"keyword-list parametric-list\" data-bind=\"foreach: items.slice(0, 8)\">\n\t<li data-bind=\"click: $parent.handleClick, css: 'type-' + type\">\n\t\t<a>\n\t\t\t<span data-bind=\"text: title\"></span>\n\t\t\t<span class=\"item-type\" data-bind=\"text: typeName, visible: type != 'keyword'\"></span>\n\t\t\t<!--<span data-bind=\"text: count\"></span>-->\n\t\t</a>\n\t</li>\n</ul>"

/***/ }),

/***/ "ziQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_logger__ = __webpack_require__("5wqq");


var logger = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_logger__["a" /* newLogger */])('AboutUs');

/***/ })

},[4]);


// WEBPACK FOOTER //
// landing.min.js